import React, { useEffect } from "react";
import qt from "@qt-base/jssdk";
import wxShare from "@qt-wx/share";
import "@qt-web/rem-standard";
import "@qt-web/css-common";
import { useState } from "react";
import { Fragment } from "react";
import Modal from "@qt-react/modal";
import "@qt-react/modal/dist/index.css";
import ModalSlide from "@qt-base/modal-slide";
import "@qt-base/modal-slide/dist/index.css";
import "swiper/css/swiper.css";
import { useEffect as useEffect__10, useRef } from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import Toast from "@qt-react/toast";
import "@qt-react/toast/dist/index.css";
import ReactLoading from "react-loading";
import ResultPop from "@qt-topic/result-page";
import "@qt-topic/result-page/dist/index.css";
import qs from "qs";
import "@qt-mobile/web-linkedme";
import get from "lodash/get";
import { useRef as useRef__16, useMemo } from "react";
import { Component } from "react";
import Index from "@qt-member/draw";
import "@qt-member/draw/mdist/index.css";
import jscookie from "js-cookie";
import LotteryGrid from "@lib-common/lottery-grid";
import qtWebLog from "@qt-mobile/web-log";
import { useRef as useRef__35 } from "react";
import { useRef as useRef__66 } from "react";
import { useRef as useRef__89 } from "react";
import { useEffect as useEffect__128 } from "react";
import { useRef as useRef__130, useState as useState__130, useEffect as useEffect__130 } from "react";
import { useEffect as useEffect__131 } from "react";
import { useRef as useRef__137 } from "react";
import "swiper/css/swiper.min.css";
import { useEffect as useEffect__143 } from "react";
import { useRef as useRef__154 } from "react";
import { useRef as useRef__170 } from "react";
import { useRef as useRef__202 } from "react";
import { useRef as useRef__225 } from "react";
import { useEffect as useEffect__264 } from "react";
import { useRef as useRef__266, useState as useState__266, useEffect as useEffect__266 } from "react";
import { useEffect as useEffect__267 } from "react";
import { useEffect as useEffect__268 } from "react";
window.__BUILDER_PAGE_ID = '5f3a3baf3262e253be9dec3d';
const isInApp = qt.env.inApp;

const formatTime = time => {
  const newTime = new Date(time.replace(/-/g, '/'));
  return newTime;
};

const isExpire = endTime => {
  const currentTime = new Date();

  if (endTime) {
    const newEndTime = formatTime(endTime);

    if (currentTime > newEndTime) {
      return true;
    }
  }

  return false;
};

const isNotStart = startTime => {
  const currentTime = new Date();

  if (startTime) {
    const newStartTime = formatTime(startTime);

    if (currentTime < newStartTime) {
      return true;
    }
  }

  return false;
};

const getDisplayBlock = (startTime, endTime) => {
  let display = "block";

  if (endTime && isExpire(endTime) || startTime && isNotStart(startTime)) {
    display = 'none';
  }

  return display;
};

const getShareLink = () => {
  const url = window.location.href;
  return url;
};

const getHeight = () => {
  const winHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  return winHeight;
};

const ContainerRender = ({
  basicConfig: basicConfig,
  containerConfig: containerConfig,
  children: children,
  id = "",
  nodeId = "",
  nodeType = ""
}) => {
  const shareConfig = {
    title: basicConfig.shareTitle,
    desc: basicConfig.shareSubTitle,
    imageUrl: basicConfig.shareImg,
    link: basicConfig.shareLink || getShareLink()
  };
  const wxShareConfig = {
    title: basicConfig.shareTitle,
    desc: basicConfig.shareSubTitle,
    imgUrl: basicConfig.shareImg,
    link: basicConfig.shareLink || getShareLink()
  }; //微信分享

  if (wxShare.isInWeixin) {
    wxShare.setShareConfig(wxShareConfig);
  }

  if (isInApp) {
    window.onPageAppear = async () => {
      await qt.page.setNavbar({
        show: true
      });
    };

    qt.page.setNavbar({
      hideShare: basicConfig.isHiddenAppShare
    });
    qt.page.setShare(shareConfig);
  }

  let inIosApp = qt.env.inIosApp;

  if (inIosApp) {
    window.addEventListener('hashchange', function () {
      qt.page.setShare(shareConfig);
    });
  }

  useEffect(() => {
    qt.monitor.bmsPageViewEntry({
      eventId: 'componentContainer_view',
      nodeId,
      nodeType
    });
    document.title = basicConfig.title;
    document.body.style.fontSize = '16px';
    document.body.style.background = containerConfig.bgc;
    document.body.style.backgroundImage = containerConfig.bgimg;
    document.body.style.backgroundRepeat = 'repeat';
    document.getElementById('root').minHeight = window.innerHeight;

    if (inIosApp) {
      return window.removeEventListener('hashchange', () => {});
    }
  }, []);
  const {
    startTime,
    endTime,
    endTitle,
    beforeTitle,
    bgc,
    themeColor,
    bgimg,
    style,
    margin,
    padding
  } = containerConfig;
  const isExpireShow = isExpire(endTime);
  const tip = endTime && isExpireShow ? endTitle ? endTitle : '页面已过期~' : beforeTitle ? beforeTitle : '活动还未开始，敬请期待~';
  const display = getDisplayBlock(startTime, endTime);
  const currentStyle = {
    background: bgc,
    color: themeColor,
    minHeight: getHeight(),
    backgroundImage: `url(${bgimg})`,
    backgroundRepeat: 'repeat',
    margin,
    padding
  };
  const useStyle = Object.assign(currentStyle, style);
  return display === 'block' ? <div className="scroll-y" style={useStyle}>{children}</div> : <div style={{
    minHeight: getHeight(),
    display: 'flex',
    alignItems: 'center'
  }}>
        <div style={{
      textAlign: 'center',
      transform: 'translateY(-1rem)',
      width: '100%'
    }}>
            <div style={{
        width: '6rem',
        margin: '0 auto'
      }}><img style={{
          width: '100%'
        }} alt={'logo'} src={'https://pic.qingting.fm/activity/123/qtlogo.png'} /></div>
            <div style={{
        fontSize: '0.85rem',
        color: '#333',
        width: '100%',
        textAlign: 'center',
        paddingTop: '0.5rem'
      }}>{tip}</div>
        </div>
    </div>;
};

const transferTime = time => {
  if (!time) return null;
  return new Date(Date.parse(time.replace(/-/g, '/')));
};

const TimeController = ({
  id: id,
  children: children,
  config: config
}) => {
  const {
    startTime,
    endTime,
    dynamic,
    duration
  } = config;
  const startDate = transferTime(startTime);
  const endDate = transferTime(endTime);
  const unSet = !startDate && !endDate;
  const currDate = new Date();
  const isDisplay = (currDate >= startDate || !startDate) && (currDate <= endDate || !endDate);
  const [display, setDisplay] = useState(isDisplay); // == 实时更新开启以及当前时间在结束时间或者开始时间之前才开启

  useEffect(() => {
    if (!dynamic || unSet) return;
    if (currDate >= endDate || currDate >= startDate && !endDate) return;
    const timer = setInterval(() => {
      const newDate = new Date();
      const isDisplay = (newDate >= startDate || !startDate) && (newDate <= endDate || !endDate);

      if (display !== isDisplay) {
        setDisplay(isDisplay);
        clearInterval(timer);
      }
    }, duration * 1000);
  }, []);
  return display ? children ? <div id={id}>{children}</div> : <div style={{
    margin: '30px 0',
    textAlign: 'center',
    fontSize: 14
  }}>请添加子组件</div> : null;
};

const EnvController = ({
  id: id,
  children: children,
  config: config
}) => {
  const [display, setDisplay] = useState(false);
  const {
    version,
    comparison,
    versionEnv,
    env,
    operation,
    versionOperation
  } = config;
  useEffect(() => {
    // == 环境控制，白名单取正，黑名单取反
    const envDisplay = env === 'all' ? operation === 'allow' : operation === 'allow' ? qt.env[env] : !qt.env[env];
    if (!qt.env.inApp || !version) return setDisplay(envDisplay); // == 环境匹配

    const isMatched = qt.env[versionEnv]; // == 未选不限环境且对应环境不匹配则不做版本控制

    if (versionEnv !== 'all' && !isMatched) return setDisplay(envDisplay);
    qt.compareAppVersion(version).then(comparisons => {
      // == 版本匹配白名单则显示，黑名单取反
      const versionDisplay = versionOperation === 'allow' ? comparisons[comparison] : !comparisons[comparison];
      setDisplay(envDisplay && versionDisplay);
    });
  }, []);
  return children ? display ? <div id={id}>{children}</div> : null : <div style={{
    margin: '30px 0',
    textAlign: 'center',
    fontSize: 14
  }}>请添加子组件</div>;
};

const CommonImage = ({
  config: config,
  sendLog: sendLog
}) => {
  const {
    openLazyload,
    openExpose
  } = config;
  const imgRef = React.useRef();
  const [measure, setMeasure] = React.useState();
  const [load, setLoad] = React.useState(false);
  const [exposed, setExposed] = React.useState(false);

  const getScrollTop = () => {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
  };

  React.useEffect(() => {
    if (!config.src) return;
    window.addEventListener("load", () => {
      const elem = imgRef.current;
      if (!elem) return;
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;
      const scrollTop = getScrollTop();
      const offsetTop = scrollTop + elem.getBoundingClientRect().top;
      const initMeasure = {
        offsetTop,
        windowHeight,
        load: scrollTop + windowHeight >= offsetTop
      };
      setMeasure(initMeasure);
    });
  }, []); // == 懒加载监听

  React.useEffect(() => {
    if (!openLazyload || !measure || measure.load || load) return;
    const {
      offsetTop,
      windowHeight
    } = measure;

    const lazyloadListener = () => {
      const scrollTop = getScrollTop();
      const isLoad = scrollTop + windowHeight >= parseInt(offsetTop) - 30; // 提前30像素加载

      if (isLoad) setLoad(isLoad);
    };

    window.addEventListener('scroll', lazyloadListener);
    return () => {
      window.removeEventListener('scroll', lazyloadListener);
    };
  }, [measure, load]); // == 曝光监听

  React.useEffect(() => {
    if (!openExpose || !measure || exposed) return;
    const isImageLoad = !openLazyload || measure.load || load; // == 懒加载情况下，图片未加载不开启曝光监听

    if (!isImageLoad) return;
    let height = imgRef.current.getBoundingClientRect().height;
    const {
      offsetTop,
      windowHeight
    } = measure;

    const exposeListener = () => {
      const scrollTop = getScrollTop();
      height = height > 0 ? height : imgRef.current.getBoundingClientRect().height; // == 图片50%露出才曝光

      const isExposeTop = scrollTop >= offsetTop + height / 2 - windowHeight;
      const isExposeBottom = scrollTop < offsetTop + height / 2;
      const isExpose = isExposeTop && isExposeBottom;
      if (!isExpose) return;
      sendLog('expose'); // 发送曝光打点

      setExposed(true); // == 10秒后再次开启曝光

      setTimeout(() => setExposed(false), 10000);
    };

    exposeListener();
    window.addEventListener('scroll', exposeListener);
    return () => {
      window.removeEventListener('scroll', exposeListener);
    };
  }, [measure, load, exposed]);
  return config.src ? openLazyload ? <img ref={imgRef} className={`block lh-100 ${measure && measure.load || load ? '' : 'invisible '}${config.isCenter ? 'm-auto' : ''}`} width={config.widthType === 'percent' ? `${config.width}%` : config.width} src={measure && measure.load || load ? config.src : null} /> : <img ref={imgRef} className={`block lh-100 ${config.isCenter ? 'm-auto' : ''}`} width={config.widthType === 'percent' ? `${config.width}%` : config.width} src={config.src} /> : <div className="text-center mv-3 f14">请添加图片</div>;
};

const SingleImage = ({
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  config: config,
  containerStyle: containerStyle,
  children: children
}) => {
  const {
    origin,
    pathname,
    search
  } = window.location;
  const {
    link,
    linkInApp,
    linkOutApp,
    openNewWebview
  } = config;
  const isInApp = qt.env.inApp;
  const envLink = isInApp ? linkInApp || link : linkOutApp || link;
  const isAnchorId = envLink.length === 3;
  const finalLink = isAnchorId ? origin + pathname + search + `#${envLink}` : envLink;
  const sendLogRef = React.useRef((label = 'click') => {
    if (label === 'expose') {
      qt.monitor.bmsExpose({
        eventId: 'image_view',
        nodeId,
        nodeType,
        data: {
          expose_primary_type: 'H5',
          expose_primary_id: finalLink
        }
      });
    } else {
      qt.monitor.bmsActionEvent({
        eventId: 'image_click',
        nodeId,
        nodeType,
        data: {
          action_primary_type: 'H5',
          action_primary_id: finalLink
        }
      });
    }
  });
  return finalLink ? <a id={id} className="block" style={containerStyle} onClick={e => {
    e.stopPropagation();
    sendLogRef.current();

    if (isInApp && openNewWebview) {
      qt.route.openNewWebview({
        url: finalLink
      });
    } else {
      window.location.href = finalLink;
    }
  }}>
      <CommonImage sendLog={sendLogRef.current} config={config} />
      {children}
    </a> : <div id={id} style={containerStyle}>
      <CommonImage sendLog={sendLogRef.current} config={config} />
      {children}
    </div>;
};

const wrapStyle = {
  fontSize: '14px',
  textAlign: 'center',
  vertAlign: 'middle',
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

const RenderRule = ({
  basicConfig: basicConfig,
  children: children,
  id = "",
  nodeId = "",
  nodeType = ""
}) => {
  let width = basicConfig.coverImgWidth,
      height = basicConfig.coverImgHeight,
      top = basicConfig.coverImgTop,
      right = basicConfig.coverImgRight,
      bottom = basicConfig.coverImgBottom,
      left = basicConfig.coverImgLeft,
      unit = basicConfig.unit;

  if (unit !== 'px') {
    width = width + unit;
    height = height + unit;
    top = top + unit;
    right = right + unit;
    bottom = bottom + unit;
    left = left + unit;
  }

  let ruleStyle = Object.assign({}, wrapStyle, {
    width,
    height,
    marginTop: top,
    marginRight: right,
    marginBottom: bottom,
    marginLeft: left,
    position: basicConfig.position,
    zIndex: basicConfig.zIndex
  });

  if (basicConfig.position === 'fixed' || basicConfig.position === 'absolute') {
    ruleStyle = Object.assign({}, wrapStyle, {
      width,
      height,
      top,
      right,
      bottom,
      left,
      position: basicConfig.position,
      zIndex: basicConfig.zIndex
    });
  }

  const imgStyle = {
    width,
    height,
    display: 'block'
  };
  const contentStyle = {
    lineHeight: basicConfig.lineHeight,
    whiteSpace: 'pre-wrap',
    height: basicConfig.ruleContentHeight ? basicConfig.ruleContentHeight + basicConfig.unit : '',
    maxHeight: basicConfig.ruleContentMaxHeight ? basicConfig.ruleContentMaxHeight + basicConfig.unit : '',
    textAlign: 'left',
    overflowY: 'auto',
    fontSize: basicConfig.ruleFontSize
  };
  return <Fragment>
        <div style={ruleStyle} onClick={() => {
      qt.monitor.bmsActionEvent({
        eventId: 'fixedRule_click',
        nodeId,
        nodeType
      });
      Modal.show({
        title: '活动规则',
        jsxContent: <div style={contentStyle} dangerouslySetInnerHTML={{
          __html: basicConfig.ruleContent
        }}></div>,
        showTopPic: false,
        okText: '知道了',
        onOk: () => {},
        showCancel: false
      });
    }}>
            {children ? children : <img style={imgStyle} alt={"rule-cover"} src={basicConfig.coverImg} />}
        </div>
    </Fragment>;
};

const ImageLink = ({
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  imageArchor: imageArchor,
  children: children
}) => {
  const {
    src,
    link,
    linkInApp,
    linkOutApp,
    style,
    imageStyle,
    openNewWebview
  } = imageArchor;
  const {
    origin,
    pathname,
    search
  } = window.location;
  const isInApp = qt.env.inApp;
  const envLink = isInApp ? linkInApp || link : linkOutApp || link;
  const isAnchorId = envLink.length === 3;
  const finalLink = isAnchorId ? origin + pathname + search + `#${envLink}` : envLink; // == 发送日志

  const sendLogRef = React.useRef((label = 'click') => {
    if (label === 'expose') {
      qt.monitor.bmsExpose({
        eventId: 'imageLink_view',
        nodeId,
        nodeType,
        data: {
          expose_primary_type: 'H5',
          expose_primary_id: finalLink
        }
      });
    } else {
      qt.monitor.bmsActionEvent({
        eventId: 'imageLink_click',
        nodeId,
        nodeType,
        data: {
          action_primary_type: 'H5',
          action_primary_id: finalLink
        }
      });
    }
  });

  if (style.type === 'rem') {
    const {
      top,
      bottom,
      left,
      right
    } = style;
    style.top = top ? `${top}rem` : top;
    style.bottom = bottom ? `${bottom}rem` : bottom;
    style.left = left ? `${left}rem` : left;
    style.right = right ? `${right}rem` : right;
  }

  delete style.type;
  return finalLink ? <a style={style} className="lh-100 block" onClick={e => {
    e.stopPropagation();
    sendLogRef.current();

    if (isInApp && openNewWebview) {
      qt.route.openNewWebview({
        url: finalLink
      });
    } else {
      window.location.href = finalLink;
    }
  }}>
      <img style={imageStyle} src={src} />
      {children}
    </a> : <div style={style} className="lh-100"><img style={imageStyle} src={src} />{children}</div>;
};

const BaseLayout = ({
  id: id,
  children: children,
  config: config
}) => {
  const {
    commonStyle,
    positionStyle,
    spacingStyle
  } = config;
  const {
    background
  } = commonStyle;
  const style = { ...commonStyle,
    ...positionStyle,
    ...spacingStyle
  }; // == 背景设置

  style.background = background.image ? `url(${background.image}) left top / ${background.size} ${background.repeat}` : background.color; // == rem单位处理

  if (style.type === 'rem' || style.type === '%') {
    const {
      type,
      top,
      bottom,
      left,
      right,
      marginTop,
      marginBottom,
      marginLeft,
      marginRight,
      paddingTop,
      paddingBottom,
      paddingLeft,
      paddingRight
    } = style;
    style.top = top ? `${top}${type}` : top;
    style.bottom = bottom ? `${bottom}${type}` : bottom;
    style.left = left ? `${left}${type}` : left;
    style.right = right ? `${right}${type}` : right;
    style.marginTop = marginTop ? `${marginTop}${type}` : marginTop;
    style.marginBottom = marginBottom ? `${marginBottom}${type}` : marginBottom;
    style.marginLeft = marginLeft ? `${marginLeft}${type}` : marginLeft;
    style.marginRight = marginRight ? `${marginRight}${type}` : marginRight;
    style.paddingTop = paddingTop ? `${paddingTop}${type}` : paddingTop;
    style.paddingBottom = paddingBottom ? `${paddingBottom}${type}` : paddingBottom;
    style.paddingLeft = paddingLeft ? `${paddingLeft}${type}` : paddingLeft;
    style.paddingRight = paddingRight ? `${paddingRight}${type}` : paddingRight;
  }

  delete style.type;
  return children ? <div id={id} style={style}>{children}</div> : <div className="text-center mv-3 f14">请添加布局子组件</div>;
};

const productId = {
  androidId: "5eec93f4f84f475b9763d043",
  iosId: "fm.qingting.specailactivity.12month.98yuan12"
};
const options = {
  limitJudge: true,
  isBenefit: false,
  hasResultPage: true,
  popLog: true,
  content: "立即购买"
};
const btnStyle = {
  unit: "px",
  isAbsolute: true,
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  color: "transparent",
  fontSize: null,
  hasAnimation: true,
  bgImg: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/61cf8f6d8d1a2b3a2e8474f297837930.png",
  bgColor: "transparent",
  width: null,
  height: null
};

const BuyButton = ({
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  productId: productId,
  btnStyle: btnStyle,
  options: options
}) => {
  const [deviceId, setDeviceId] = useState('');
  const [token, setToken] = useState('');
  const [showSpin, setShowSpin] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [resultData, setResultData] = useState({});
  const buttonRef = useRef(); // == 防止重复曝光打点

  const [exposed, setExposed] = React.useState(false);
  const resultParams = {};
  useEffect__10(() => {
    qt.getDevice().then(res => {
      setDeviceId(res.deviceId);
      return qt.getAccessToken();
    }).then(token => setToken(token));
  }, []);
  useEffect__10(() => {
    if (!options.popLog) return;
    if (exposed) return;
    window.addEventListener('scroll', popTrack);
  }, [exposed]); // == 判断用户是否到达购买上限

  const judgeLimit = user_id => {
    return axios.get(`https://pay${process.env.SITE_ENV === 'stg' ? '.staging' : ''}.qingting.fm/cashdesk/v1/vip/reached_limit`, {
      params: {
        user_id
      }
    }).then(data => data.data);
  }; // == 判断是否购买过特惠商品


  const checkUsesrBenefit = id => {
    return axios.get(`https://webapi${process.env.SITE_ENV === 'stg' ? '.staging' : ''}.qingting.fm/material/frontend/423/check-user-benefit`, {
      params: {
        user_id: id,
        device_id: deviceId,
        access_token: token
      },
      withCredentials: true
    }).then(data => data.data);
  }; // == 获取结果页数据


  const getResultData = ({
    userId,
    deviceId,
    phoneType,
    itemId,
    orderId,
    systemInfo = {}
  }) => {
    const params = {
      user_id: userId,
      device_id: deviceId,
      phone_type: phoneType,
      item_id: itemId,
      order_id: orderId
    };
    Object.assign(params, systemInfo);
    return axios.get(`https://pay${process.env.SITE_ENV === 'stg' ? '.staging' : ''}.qingting.fm/cashdesk/v1/vip/result`, {
      params
    }).then(data => data.data);
  }; // == 点击购买按钮


  const purchase = async () => {
    qt.monitor.bmsActionEvent({
      eventId: 'buyButton_click',
      nodeId,
      nodeType,
      data: {
        name: id
      }
    });
    const userId = await qt.getUserId();

    if (userId) {
      resultParams.userId = userId;
      let judgeLimitData, checkBenefitData;
      if (options.limitJudge) judgeLimitData = await judgeLimit(userId);

      if (judgeLimitData && judgeLimitData.data && judgeLimitData.data.reached_limit) {
        Toast.info({
          content: judgeLimitData.data.toast.substring(0, 19) + '<br />' + judgeLimitData.data.toast.substring(19) || '为保护您的权益，今日购买额度已用完，请<br />明日再尝试购买',
          duration: 3000
        });
        return;
      }

      if (options.isBenefit) checkBenefitData = await checkUsesrBenefit(userId);

      if (checkBenefitData && checkBenefitData.data && checkBenefitData.data.has_benefit) {
        Toast.info({
          content: '您已购买过特惠商品！',
          duration: 3000
        });
        return;
      }

      goPurchase();
    } else {
      qt.login({
        env: process.env.SITE_ENV === 'stg' ? 'staging' : 'production'
      });
    }
  }; // == 购买动作


  const goPurchase = () => {
    let param = {};

    if (qt.env.inIosApp) {
      param = {
        productId: productId.iosId
      };
    } else {
      param = {
        itemId: productId.androidId
      };
    }

    let partner = qs.parse(window.location.search.slice(1)).partner;
    if (partner) param.partner = partner;
    setShowSpin(true);
    qt.purchase(param).then(async (res = {}) => {
      resultParams.orderId = res.orderId;
      setShowSpin(false);

      if (options.hasResultPage && res.orderId) {
        if (qt.env.inIosApp) resultParams.systemInfo = await qt.getSystemInfo();
        resultParams.deviceId = deviceId;
        resultParams.phoneType = qt.env.inIosApp ? 'iOS' : 'android';
        resultParams.itemId = productId.androidId;
        let data = await getResultData(resultParams);
        setResultData(data.data);
        setShowResult(true);
      }

      ;
    }).catch(e => {
      setShowSpin(false);
      Toast.info({
        content: e.message,
        duration: 3000
      });
    });
  };

  const getScrollTop = () => {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
  };

  const popTrack = () => {
    if (!buttonRef.current) return;
    const pos = buttonRef.current.getBoundingClientRect();
    const scrollTop = getScrollTop();
    const offsetTop = scrollTop + pos.top;
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const isExposeTop = scrollTop >= offsetTop + pos.height / 2 - windowHeight;
    const isExposeBottom = scrollTop < offsetTop + pos.height / 2;

    if (isExposeTop && isExposeBottom) {
      qt.monitor.bmsExpose({
        eventId: 'buyButton_view',
        nodeId,
        nodeType
      });
      setExposed(true);
      setTimeout(() => setExposed(false), 10000);
      window.removeEventListener('scroll', popTrack);
    }
  };

  useEffect__10(() => {
    if (showResult) {
      const div = document.getElementById(nodeId) || document.createElement('div');
      div.setAttribute('id', nodeId);
      document.body.appendChild(div);
      ReactDOM.render(<ResultPop env={process.env.SITE_ENV} resultData={resultData} onClose={() => setShowResult(false)}></ResultPop>, div);
    } else {
      const div = document.getElementById(nodeId);
      if (div) document.body.removeChild(div);
    }
  }, [showResult]);
  const spinStyle = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 100,
    height: 50,
    width: 50,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    borderRadius: 8,
    boxSizing: 'border-box',
    padding: 10
  };
  return <>
    <style>{`
      @keyframes buy-button-breath {
        0% { transform: scale(0.9); }  
        50% { transform: scale(1); }  
        100% { transform: scale(0.9); }
      }
    `}</style>
    {showSpin ? <div style={spinStyle}><ReactLoading type={'spokes'} width={'100%'} height={'100%'} /></div> : null}
    <div style={btnStyle} onClick={() => purchase()} ref={buttonRef}>{options.content}</div>
  </>;
};

const getTime = endTime => {
  if (!endTime) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0
    };
  }

  const currentTime = new Date();
  const newEndTime = formatTime(endTime);
  const leftTime = new Date(newEndTime.valueOf() - currentTime.valueOf());
  const diff_time = leftTime / 1000;
  const days = parseInt(diff_time / 86400);
  const hours = parseInt(diff_time / 3600) - 24 * days;
  const minutes = parseInt(diff_time % 3600 / 60);
  const seconds = parseInt(diff_time % 60);
  return {
    days,
    hours,
    minutes,
    seconds
  };
};

const RenderCountDown = ({
  basicConfig: basicConfig
}) => {
  const expire = isExpire(basicConfig.endTime);
  let {
    paddingTop,
    paddingBottom,
    paddingLeft,
    paddingRight,
    top,
    bottom,
    left,
    right,
    unit
  } = basicConfig;

  if (unit !== 'px') {
    paddingTop = paddingTop + unit;
    paddingBottom = paddingBottom + unit;
    paddingLeft = paddingLeft + unit;
    paddingRight = paddingRight + unit;
    top = top + unit;
    bottom = bottom + unit;
    left = left + unit;
    right = right + unit;
  }

  let style = {
    color: basicConfig.fontColor,
    background: basicConfig.bgColor,
    borderRadius: basicConfig.borderRadius,
    paddingTop,
    paddingBottom,
    paddingLeft,
    paddingRight,
    display: 'inline-block',
    fontWeight: basicConfig.fontWeight,
    fontSize: basicConfig.fontSize,
    position: basicConfig.position,
    marginTop: top,
    marginBottom: bottom,
    marginLeft: left,
    marginRight: right
  };

  if (basicConfig.position === 'absolute' || basicConfig.position === 'fixed') {
    style = {
      color: basicConfig.fontColor,
      background: basicConfig.bgColor,
      borderRadius: basicConfig.borderRadius,
      paddingTop,
      paddingBottom,
      paddingLeft,
      paddingRight,
      display: basicConfig.display,
      fontWeight: basicConfig.fontWeight,
      fontSize: basicConfig.fontSize,
      position: basicConfig.position,
      top,
      bottom,
      left,
      right
    };
  }

  const [leftTime, setLeftTime] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    if (!basicConfig.endTime) return;

    let timeOut = () => {
      const expire = isExpire(basicConfig.endTime);
      if (expire) return;
      setTimeout(() => {
        let time = getTime(basicConfig.endTime);
        setLeftTime(time);
        timeOut();
      }, 1000);
    };

    timeOut();
  }, []);
  return basicConfig.isCustomizeEndTitle && expire ? <div style={style}>
            <span>{basicConfig.customizeEndTitle}</span>
        </div> : <div style={style}>
        <span>{basicConfig.title}</span>
        <span>{leftTime.days}天</span>
        <span>{leftTime.hours}时</span>
        <span>{leftTime.minutes}分</span>
        <span>{leftTime.seconds}秒</span>
    </div>;
};

const Button = (close = () => {}) => {
  return <div onClick={() => {
    close();
  }} style={{
    backgroundImage: 'linear-gradient(-135deg, #FF8A8A 0%, #FD5353 100%)',
    borderRadius: '20px',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '40px',
    marginTop: '16px'
  }}>
        <div style={{
      height: '20px'
    }}><img style={{
        width: '20px'
      }} src={"https://sss.staging.qingting.fm/qt-builder-manage/upload_f233ad9be29cd0eb6ef09cf8d7e1cbef.png"} /></div>
        <div style={{
      color: '#fff',
      fontSize: '16px'
    }}>开启手机通知</div>
    </div>;
};

const RenderReserve = ({
  basicConfig: basicConfig,
  styleConfig: styleConfig,
  id: id,
  nodeId: nodeId,
  nodeType: nodeType
}) => {
  const [isReserved, setReserved] = useState(false); //获取用户信息

  const getUserInfo = async () => {
    try {
      let userId = await qt.getUserId();
      let res = await qt.getDevice();
      const deviceId = res.deviceId;
      return {
        userId: userId || '',
        deviceId: deviceId
      };
    } catch (e) {
      return {
        userId: '',
        deviceId: ''
      };
    }
  };

  const host = basicConfig.isStaging ? 'https://ac.staging.qingting.fm/v1/user/appointment' : 'https://ac.qingting.fm/v1/user/appointment'; // 当前是否预约

  const getIsReserve = async () => {
    try {
      let {
        userId,
        deviceId
      } = await getUserInfo();
      const task = basicConfig.taskIds.split(',').join('&task_ids=');
      const res = await axios.get(`${host}?task_ids=${task}&device_id=${deviceId}&userId=${userId}`);
      const result = get(res, 'data.data');
      setReserved(result);
    } catch (e) {
      console.log(e);
    }
  };

  window.onPageAppear = () => {
    if (window.onPageAppear) window.onPageAppear();
    getIsReserve();
  };

  const isInApp = qt.env.inApp;
  let {
    imgWidth,
    imgHeight,
    top,
    bottom,
    left,
    right,
    unit,
    position,
    display,
    zIndex
  } = styleConfig;

  if (unit !== 'px') {
    imgWidth = imgWidth + unit;
    imgHeight = imgHeight + unit;
    top = top + unit;
    bottom = bottom + unit;
    left = left + unit;
    right = right + unit;
  }

  let wrapStyle = {
    width: imgWidth,
    height: imgHeight,
    display,
    marginTop: top,
    marginBottom: bottom,
    marginRight: right,
    marginLeft: left,
    overflow: 'hidden',
    position,
    zIndex
  };

  if (position === 'absolute' || position === 'fixed') {
    wrapStyle = {
      width: imgWidth,
      height: imgHeight,
      display,
      top,
      bottom,
      right,
      left,
      overflow: 'hidden',
      position,
      zIndex
    };
  }

  const imgStyle = {
    width: imgWidth,
    display: 'block'
  };

  const isOpen = async () => {
    try {
      const open = await qt.checkNotification({
        forceRequest: true
      });

      if (open) {
        Toast.info({
          content: '开启成功',
          duration: 3000,
          onClose: () => {}
        });
      }

      return;
    } catch (e) {
      console.log(e);
    }
  };

  window.linkedme.init('d828bfa52e3abbef26d0339a0aaa8640', {
    type: 'live'
  }, null);

  const closeModal = () => {
    qt.monitor.bmsActionEvent({
      eventId: 'modalBtn_reserve_click',
      nodeId,
      nodeType
    });
    Modal.close();
    setTimeout(() => {
      return isOpen(); // return open(isOpen)
    }, 0);
  };

  useEffect(() => {
    qt.monitor.bmsExpose({
      eventId: 'reserve_view',
      nodeId,
      nodeType
    });

    if (isInApp) {
      getIsReserve();
    }

    return () => {
      localStorage.removeItem('global_reserve_back');
    };
  }, []); //检查是否开通通知权限

  const checkNotificationPermission = async () => {
    try {
      const isOpen = await qt.checkNotification({
        forceRequest: false
      });

      if (!isOpen) {
        if (basicConfig.pushType) {
          qt.monitor.bmsExpose({
            eventId: 'modalNotice_reserve_view.',
            nodeId,
            nodeType
          });
          Modal.show({
            title: '开启通知',
            subTitle: basicConfig.modalMessage || '开启后第一时间收听上新音频',
            bottomTip: '',
            showTopPic: true,
            okText: '提交',
            onOk: () => {},
            footer: Button(closeModal),
            showCancel: true,
            cancelText: '关闭',
            showCloseIcon: true,
            topImg: 'https://sss.staging.qingting.fm/qt-builder-manage/upload_1f7e5407b843ed6c871d629a44079a38.png',
            onCancel: () => {}
          });
        }
      }

      return;
    } catch (e) {
      console.log(e);
    }
  };

  const isShowReserve = !isExpire(basicConfig.endTime) && !isNotStart(basicConfig.startTime);
  const imgUrl = isReserved ? basicConfig.reservedImg : basicConfig.unReserveImg;

  const gotoReserve = async () => {
    try {
      let {
        userId,
        deviceId = ''
      } = await getUserInfo();
      const task = basicConfig.taskIds.split(',');
      const numberTaskIds = task.map(Number);
      const response = await axios.put(`${host}`, {
        user_id: userId,
        device_id: deviceId,
        task_ids: numberTaskIds
      }); //判断通知权限有木有，并且是不是需要开启预约权限

      const errorCode = get(response, 'data.errcode', '');
      const errmsg = get(response, 'data.errmsg', '预约失败');

      if (errorCode === 0) {
        Toast.info({
          content: '预约成功',
          duration: 2000,
          onClose: () => {}
        });
        setReserved(true);
        setTimeout(() => {
          return checkNotificationPermission(); // return check(checkNotificationPermission)
        }, 0);
      } else {
        Toast.info({
          content: errmsg,
          duration: 3000,
          onClose: () => {}
        });
      }
    } catch (e) {
      Toast.info({
        content: '接口请求失败，请稍后重试',
        duration: 3000,
        onClose: () => {}
      });
    }
  };

  return isShowReserve ? <div onClick={async e => {
    e.stopPropagation();
    qt.monitor.bmsActionEvent({
      eventId: 'reserve_click',
      nodeId,
      nodeType
    }); // 已预约，则不能点击

    if (isReserved) return;

    if (isInApp) {
      let {
        userId
      } = await getUserInfo();

      if (basicConfig.isNeedLogin && !userId) {
        qt.login({
          success: () => {
            return gotoReserve();
          }
        });
      } else {
        return gotoReserve();
      }
    } else {
      window.linkedme.generate({
        type: 'h5',
        h5Url: window.location.href
      }).then(res => {
        window.linkedme.trigger(res.url);
      });
    }
  }} style={wrapStyle} id={id}>
        <img style={imgStyle} src={imgUrl} alt="reserve" />
    </div> : null;
};

const scrollAnimation = (currentY, targetY) => {
  const needScrollTop = targetY - currentY;
  let _currentY = currentY;
  const unit = 3; // 滑动单位

  const handle = () => {
    const dist = Math.ceil(needScrollTop / unit);
    _currentY += dist;
    window.scrollTo(_currentY, currentY);

    if (needScrollTop > unit || needScrollTop < -unit) {
      scrollAnimation(_currentY, targetY);
    } else {
      window.scrollTo(_currentY, targetY);
    }
  };

  if (requestAnimationFrame) {
    requestAnimationFrame(handle);
  } else {
    setTimeout(handle, 1);
  }
};

const getCurrScrollTop = () => {
  return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
};

const parseQuery = query => {
  query = query.split('?').pop();
  const queryArr = query ? query.split('&') : [];
  let params = {};

  for (let i = 0, n = queryArr.length; i < n; i++) {
    let arr = queryArr[i].split('=');

    if (arr.length > 0) {
      let key = decodeURIComponent(arr.shift());
      let value = decodeURIComponent(arr.join('=')); // 参数如果带=，在这里加上去

      params[key] = value;
    }
  }

  return params;
};

const TabNav = props => {
  const {
    nav,
    navIndex,
    navStyle,
    navHandle,
    active,
    inactive,
    showTitle,
    openScroll,
    openWrap
  } = props;
  const {
    navItem,
    activeItem,
    activeText,
    activeLine
  } = navStyle;
  const activeLineTop = activeLine.paddingBottom + activeLine.borderBottomWidth;
  const {
    active: activeImage,
    inactive: inactiveImage,
    position,
    activeColor,
    inactiveColor
  } = nav.image;
  const isActive = navIndex === props.currTabNavIndex; // == 未激活背景

  const inactiveBackground = inactiveImage ? `url(${inactiveImage}) center ${position} / contain no-repeat 
              ${inactiveColor !== 'transparent' ? inactiveColor : inactive.backgroundColor || ''}` : navStyle.navItem.background; // == 激活背景

  const activeBackground = activeImage ? `url(${activeImage}) center ${position} / contain no-repeat 
              ${activeColor !== 'transparent' ? activeColor : active.backgroundColor || ''}` : navStyle.activeItem.background;
  const itemStyle = { ...navItem,
    ...(isActive ? activeItem : {}),
    flexShrink: openScroll ? 0 : 1
  };
  const textStyle = isActive ? { ...activeText,
    ...activeLine,
    paddingTop: activeLineTop
  } : {};
  itemStyle.background = isActive ? activeBackground : inactiveBackground;
  itemStyle.borderStyle = 'solid';
  itemStyle.borderColor = isActive ? active.borderColor : inactive.borderColor;
  itemStyle.borderWidth = isActive ? active.borderWidth : inactive.borderWidth; // == 开启换行宽度自适

  if (openWrap) itemStyle.width = 'auto';
  return <a style={{ ...itemStyle,
    marginBottom: null
  }} key={navIndex} className="flex flex-center items-center" onClick={() => {
    navHandle(nav, navIndex);
  }}>
      {showTitle ? <div className="nowrap" style={textStyle}>{nav.title}</div> : null}
    </a>;
};

const TabNavBar = props => {
  const {
    navs,
    navStyle,
    setCurrTabNavIndex,
    offsetTop,
    openScroll,
    openFixed,
    fixed,
    openWrap,
    lineCount
  } = props;
  const {
    navItem,
    navBar
  } = navStyle; // == 导航点击事件处理

  const navHandle = (nav, navIndex) => {
    const isActive = navIndex === props.currTabNavIndex;
    if (isActive) return;
    if (nav.link) return window.location.href = nav.link;
    setCurrTabNavIndex(navIndex); // == 平滑滚动至固定位置

    if (openFixed && fixed) {
      const scrollTop = getCurrScrollTop();
      if (scrollTop > offsetTop) scrollAnimation(scrollTop, offsetTop);
    }
  };

  return <div className={openWrap ? 'flex flex-start items-center flex-wrap' : 'flex flex-between items-center'} style={{ ...navBar,
    marginRight: openScroll && !openWrap ? null : -navItem.marginRight,
    overflowX: openScroll && !openWrap ? 'auto' : 'hidden'
  }}>
    {navs.map((nav, index) => {
      return openWrap ? <div key={index} style={{
        width: `${100 / lineCount}%`,
        marginBottom: navItem.marginBottom
      }}>
            <TabNav nav={nav} navIndex={index} navHandle={navHandle} {...props} />
          </div> : <TabNav key={index} nav={nav} navIndex={index} navHandle={navHandle} {...props} />;
    })}
  </div>;
};

const TabNavsContainer = ({
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  children: children,
  navs: navs,
  config: config
}) => {
  // == 默认索引
  const defaultTabNavIndex = useMemo(() => {
    const configDefaultIndex = navs.findIndex(nav => nav.default);
    const params = parseQuery(window.location.search);
    const {
      tabNavsId,
      tabNavsIndex
    } = params;
    if (tabNavsId && tabNavsId !== id) return configDefaultIndex;
    const index = tabNavsIndex ? parseInt(tabNavsIndex) : -1;
    return index >= 0 ? index : configDefaultIndex;
  }, []);
  const [currTabNavIndex, setCurrTabNavIndex] = useState(defaultTabNavIndex > -1 ? defaultTabNavIndex : 0);
  const [offsetTop, setOffsetTop] = useState();
  const [fixed, setFixed] = useState(false);
  const navsRef = useRef__16();
  const {
    showTitle,
    open: openFixed = false,
    top: fixedTop = 0,
    inactive,
    active,
    openWrap,
    lineCount,
    openCache,
    openLog,
    lockMinusListener,
    openScroll
  } = config; // == 日志发送

  const sendLogRef = useRef__16(tabIndex => {
    qt.monitor.bmsActionEvent({
      eventId: 'tabNavs_click',
      nodeId,
      nodeType,
      data: {
        pos: tabIndex + 1
      }
    });
  });
  const rowCount = Math.ceil(navs.length / lineCount); // == 标签导航通用样式

  const navStyle = {
    navBar: {
      fontSize: config.fontSize,
      color: config.color,
      height: openWrap ? config.height * rowCount + config.marginBottom * (rowCount - 1) : config.height
    },
    navItem: {
      width: config.itemWidth,
      height: config.itemHeight,
      marginRight: config.marginRight,
      marginBottom: config.marginBottom,
      borderRadius: config.borderRadius
    },
    activeItem: {},
    activeText: {
      fontSize: active.fontSize,
      color: active.color,
      fontWeight: active.fontWeight
    },
    activeLine: active.line,
    content: config.content
  }; // == 背景样式

  navStyle.navBar.background = config.backgroundImage ? `url(${config.backgroundImage}) center center / contain repeat-x ${config.backgroundColor || ''}` : config.backgroundColor;
  navStyle.navItem.background = inactive.backgroundImage ? `url(${inactive.backgroundImage}) center center / contain no-repeat ${inactive.backgroundColor || ''}` : inactive.backgroundColor;
  navStyle.activeItem.background = active.backgroundImage ? `url(${active.backgroundImage}) center center / contain no-repeat ${active.backgroundColor || ''}` : active.backgroundColor; // == 初始化偏移距离

  useEffect(() => {
    const init = () => {
      if (!navsRef.current) return;
      const top = navsRef.current.getBoundingClientRect().top - fixedTop;
      const offsetTop = getCurrScrollTop() + top;
      setOffsetTop(offsetTop);
    };

    let observer;

    if (MutationObserver) {
      observer = new MutationObserver(init);
      observer.observe(document, {
        childList: true,
        subtree: true
      });
    } else {
      init();
      window.addEventListener("load", init);
    }

    return () => {
      if (observer) observer.disconnect();
      window.removeEventListener('load', init);
    };
  }, []);
  useEffect(() => {
    if (!(offsetTop >= 0)) return;

    const handleScroll = () => {
      const scrollTop = getCurrScrollTop();
      if (lockMinusListener && scrollTop < 0) return; // 负向滚动禁止

      if (scrollTop > offsetTop) {
        if (!fixed) setFixed(true);
      } else {
        if (fixed) setFixed(false);
      }
    };

    if (openFixed) {
      handleScroll();
      window.addEventListener('scroll', handleScroll);
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [offsetTop, fixed]); // == 监听导航变化并发送日志

  useEffect(() => {
    navs[currTabNavIndex]._activeCache = true; // 缓存触发标记

    if (!openLog) return;
    sendLogRef.current(currTabNavIndex);
  }, [currTabNavIndex]);
  const components = children ? children.length ? children : [children] : [];
  const navBarProps = {
    navs,
    navStyle,
    openWrap,
    lineCount,
    active,
    inactive,
    offsetTop,
    setOffsetTop,
    fixed,
    showTitle,
    openFixed,
    openScroll,
    currTabNavIndex,
    setCurrTabNavIndex
  };
  return <div className="relative scroll-y" ref={navsRef} style={fixed ? {
    paddingTop: navStyle.navBar.height
  } : {}}>
      <div className={`wd-100${fixed ? ' fixed z-index-5' : ''}`} style={fixed ? {
      top: fixedTop
    } : {}}>
        <TabNavBar {...navBarProps} />
      </div>
      {components.length ? openCache ? <div className="relative">
            {components.map((child, childIndex) => {
        const currNav = navs[childIndex] || {};
        const isActiveCache = currNav._activeCache;
        const isActive = childIndex === currTabNavIndex;
        const minHeight = currNav.minHeight;
        return isActiveCache ? <div key={childIndex} className={`${isActive ? '' : 'hide'}`} style={{
          minHeight
        }}>{child}</div> : isActive ? <div key={childIndex} style={{
          minHeight
        }}>{child}</div> : null;
      })}
          </div> : <div className="relative">
            {components.map((child, childIndex) => {
        const currNav = navs[childIndex] || {};
        const minHeight = currNav.minHeight;
        return childIndex === currTabNavIndex ? <div key={childIndex} style={{
          minHeight
        }}>{child}</div> : null;
      })}
          </div> : <div className="text-center mv-3 f14">请添加标签导航子组件</div>}
    </div>;
};

window.linkedme.init('d828bfa52e3abbef26d0339a0aaa8640', {
  type: 'live'
}, null);
window.qtWebLog = qtWebLog;
qtWebLog.push('_setAccount', 'MobileSite');

const MemberDraw = ({
  children: children,
  activity_id: activity_id,
  canSetShare: canSetShare,
  shareAddChance: shareAddChance,
  pageTitleCanModify: pageTitleCanModify,
  showTop: showTop,
  showBottom: showBottom,
  serviceUrl: serviceUrl,
  env: env,
  defaultStyle: defaultStyle,
  customeStyle: customeStyle,
  locationStyle: locationStyle,
  threeParty: threeParty,
  id: id,
  nodeType: nodeType,
  nodeId: nodeId
}) => {
  window.__SERVICE_URL = serviceUrl;
  return <div id={id}>
            <Index activity_id={activity_id} canSetShare={canSetShare} shareAddChance={shareAddChance} pageTitleCanModify={pageTitleCanModify} showTop={showTop} showBottom={showBottom} env={env} defaultStyle={defaultStyle} customeStyle={customeStyle} locationStyle={locationStyle} threeParty={threeParty} logData={{
      topic_id: window.__BUILDER_PAGE_ID,
      nodeId,
      nodeType,
      id
    }}>
                {children}
            </Index>
        </div>;
};

const RenderShare = ({
  id = "",
  nodeId = "",
  nodeType = "",
  basicConfig: basicConfig
}) => {
  const {
    style,
    imgUrl,
    showOutApp,
    shareConfig: {
      title,
      desc,
      img,
      link
    }
  } = basicConfig; // == 点击事件

  const imgClick = () => {
    qt.monitor.bmsActionEvent({
      eventId: 'click.fixedShare',
      nodeId,
      nodeType
    });
    qt.share({
      title,
      desc,
      imageUrl: img,
      link: link || window.location.href
    }).then(() => {
      const shareCallback = new CustomEvent('SHARE_CALLBACK', {
        detail: {}
      });
      window.dispatchEvent(shareCallback);
    });
  };

  return qt.env.inApp ? <img style={style} alt={"share-cover"} src={imgUrl} onClick={() => imgClick()} /> : showOutApp ? <img style={style} alt={"share-cover"} src={imgUrl} onClick={() => imgClick()} /> : null;
};

const TabNavsContainer__35 = ({
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  children: children,
  navs: navs,
  config: config
}) => {
  const defaultTabNavIndex = useMemo(() => {
    const configDefaultIndex = navs.findIndex(nav => nav.default);
    const params = parseQuery(window.location.search);
    const {
      tabNavsId,
      tabNavsIndex
    } = params;
    if (tabNavsId && tabNavsId !== id) return configDefaultIndex;
    const index = tabNavsIndex ? parseInt(tabNavsIndex) : -1;
    return index >= 0 ? index : configDefaultIndex;
  }, []);
  const [currTabNavIndex, setCurrTabNavIndex] = useState(defaultTabNavIndex > -1 ? defaultTabNavIndex : 0);
  const [offsetTop, setOffsetTop] = useState();
  const [fixed, setFixed] = useState(false);
  const navsRef = useRef__35();
  const {
    showTitle,
    open: openFixed = false,
    top: fixedTop = 0,
    inactive,
    active,
    openWrap,
    lineCount,
    openCache,
    openLog,
    lockMinusListener,
    openScroll
  } = config;
  const sendLogRef = useRef__35(tabIndex => {
    qt.monitor.bmsActionEvent({
      eventId: 'tabNavs_click',
      nodeId,
      nodeType,
      data: {
        pos: tabIndex + 1
      }
    });
  });
  const rowCount = Math.ceil(navs.length / lineCount);
  const navStyle = {
    navBar: {
      fontSize: config.fontSize,
      color: config.color,
      height: openWrap ? config.height * rowCount + config.marginBottom * (rowCount - 1) : config.height
    },
    navItem: {
      width: config.itemWidth,
      height: config.itemHeight,
      marginRight: config.marginRight,
      marginBottom: config.marginBottom,
      borderRadius: config.borderRadius
    },
    activeItem: {},
    activeText: {
      fontSize: active.fontSize,
      color: active.color,
      fontWeight: active.fontWeight
    },
    activeLine: active.line,
    content: config.content
  };
  navStyle.navBar.background = config.backgroundImage ? `url(${config.backgroundImage}) center center / contain repeat-x ${config.backgroundColor || ''}` : config.backgroundColor;
  navStyle.navItem.background = inactive.backgroundImage ? `url(${inactive.backgroundImage}) center center / contain no-repeat ${inactive.backgroundColor || ''}` : inactive.backgroundColor;
  navStyle.activeItem.background = active.backgroundImage ? `url(${active.backgroundImage}) center center / contain no-repeat ${active.backgroundColor || ''}` : active.backgroundColor;
  useEffect(() => {
    const init = () => {
      if (!navsRef.current) return;
      const top = navsRef.current.getBoundingClientRect().top - fixedTop;
      const offsetTop = getCurrScrollTop() + top;
      setOffsetTop(offsetTop);
    };

    let observer;

    if (MutationObserver) {
      observer = new MutationObserver(init);
      observer.observe(document, {
        childList: true,
        subtree: true
      });
    } else {
      init();
      window.addEventListener("load", init);
    }

    return () => {
      if (observer) observer.disconnect();
      window.removeEventListener('load', init);
    };
  }, []);
  useEffect(() => {
    if (!(offsetTop >= 0)) return;

    const handleScroll = () => {
      const scrollTop = getCurrScrollTop();
      if (lockMinusListener && scrollTop < 0) return;

      if (scrollTop > offsetTop) {
        if (!fixed) setFixed(true);
      } else {
        if (fixed) setFixed(false);
      }
    };

    if (openFixed) {
      handleScroll();
      window.addEventListener('scroll', handleScroll);
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [offsetTop, fixed]);
  useEffect(() => {
    navs[currTabNavIndex]._activeCache = true;
    if (!openLog) return;
    sendLogRef.current(currTabNavIndex);
  }, [currTabNavIndex]);
  const components = children ? children.length ? children : [children] : [];
  const navBarProps = {
    navs,
    navStyle,
    openWrap,
    lineCount,
    active,
    inactive,
    offsetTop,
    setOffsetTop,
    fixed,
    showTitle,
    openFixed,
    openScroll,
    currTabNavIndex,
    setCurrTabNavIndex
  };
  return <div className="relative scroll-y" ref={navsRef} style={fixed ? {
    paddingTop: navStyle.navBar.height
  } : {}}>
      <div className={`wd-100${fixed ? ' fixed z-index-5' : ''}`} style={fixed ? {
      top: fixedTop
    } : {}}>
        <TabNavBar {...navBarProps} />
      </div>
      {components.length ? openCache ? <div className="relative">
            {components.map((child, childIndex) => {
        const currNav = navs[childIndex] || {};
        const isActiveCache = currNav._activeCache;
        const isActive = childIndex === currTabNavIndex;
        const minHeight = currNav.minHeight;
        return isActiveCache ? <div key={childIndex} className={`${isActive ? '' : 'hide'}`} style={{
          minHeight
        }}>{child}</div> : isActive ? <div key={childIndex} style={{
          minHeight
        }}>{child}</div> : null;
      })}
          </div> : <div className="relative">
            {components.map((child, childIndex) => {
        const currNav = navs[childIndex] || {};
        const minHeight = currNav.minHeight;
        return childIndex === currTabNavIndex ? <div key={childIndex} style={{
          minHeight
        }}>{child}</div> : null;
      })}
          </div> : <div className="text-center mv-3 f14">请添加标签导航子组件</div>}
    </div>;
};

const HorizontalLayout = ({
  id: id,
  config: config,
  children: children
}) => {
  const {
    wrap,
    horizontalCss,
    verticalCss,
    commonStyle,
    positionStyle,
    spacingStyle
  } = config;
  const {
    background
  } = commonStyle;
  const style = { ...commonStyle,
    ...positionStyle,
    ...spacingStyle
  }; // == 背景处理

  style.background = background.image ? `url(${background.image}) left top / ${background.size} ${background.repeat}` : background.color; // == rem单位处理

  if (style.type === 'rem') {
    const {
      top,
      bottom,
      left,
      right
    } = style;
    style.top = top ? `${top}rem` : top;
    style.bottom = bottom ? `${bottom}rem` : bottom;
    style.left = left ? `${left}rem` : left;
    style.right = right ? `${right}rem` : right;
  }

  delete style.type;
  return children ? <div id={id} className={`flex${horizontalCss ? ' ' + horizontalCss : ''}${verticalCss ? ' ' + verticalCss : ''}${wrap ? ' flex-wrap' : ' '}`} style={style}>
      {children}
    </div> : <div className="text-center mv-3 f14">请添加布局子组件</div>;
};

const TabNavsContainer__66 = ({
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  children: children,
  navs: navs,
  config: config
}) => {
  const defaultTabNavIndex = useMemo(() => {
    const configDefaultIndex = navs.findIndex(nav => nav.default);
    const params = parseQuery(window.location.search);
    const {
      tabNavsId,
      tabNavsIndex
    } = params;
    if (tabNavsId && tabNavsId !== id) return configDefaultIndex;
    const index = tabNavsIndex ? parseInt(tabNavsIndex) : -1;
    return index >= 0 ? index : configDefaultIndex;
  }, []);
  const [currTabNavIndex, setCurrTabNavIndex] = useState(defaultTabNavIndex > -1 ? defaultTabNavIndex : 0);
  const [offsetTop, setOffsetTop] = useState();
  const [fixed, setFixed] = useState(false);
  const navsRef = useRef__66();
  const {
    showTitle,
    open: openFixed = false,
    top: fixedTop = 0,
    inactive,
    active,
    openWrap,
    lineCount,
    openCache,
    openLog,
    lockMinusListener,
    openScroll
  } = config;
  const sendLogRef = useRef__66(tabIndex => {
    qt.monitor.bmsActionEvent({
      eventId: 'tabNavs_click',
      nodeId,
      nodeType,
      data: {
        pos: tabIndex + 1
      }
    });
  });
  const rowCount = Math.ceil(navs.length / lineCount);
  const navStyle = {
    navBar: {
      fontSize: config.fontSize,
      color: config.color,
      height: openWrap ? config.height * rowCount + config.marginBottom * (rowCount - 1) : config.height
    },
    navItem: {
      width: config.itemWidth,
      height: config.itemHeight,
      marginRight: config.marginRight,
      marginBottom: config.marginBottom,
      borderRadius: config.borderRadius
    },
    activeItem: {},
    activeText: {
      fontSize: active.fontSize,
      color: active.color,
      fontWeight: active.fontWeight
    },
    activeLine: active.line,
    content: config.content
  };
  navStyle.navBar.background = config.backgroundImage ? `url(${config.backgroundImage}) center center / contain repeat-x ${config.backgroundColor || ''}` : config.backgroundColor;
  navStyle.navItem.background = inactive.backgroundImage ? `url(${inactive.backgroundImage}) center center / contain no-repeat ${inactive.backgroundColor || ''}` : inactive.backgroundColor;
  navStyle.activeItem.background = active.backgroundImage ? `url(${active.backgroundImage}) center center / contain no-repeat ${active.backgroundColor || ''}` : active.backgroundColor;
  useEffect(() => {
    const init = () => {
      if (!navsRef.current) return;
      const top = navsRef.current.getBoundingClientRect().top - fixedTop;
      const offsetTop = getCurrScrollTop() + top;
      setOffsetTop(offsetTop);
    };

    let observer;

    if (MutationObserver) {
      observer = new MutationObserver(init);
      observer.observe(document, {
        childList: true,
        subtree: true
      });
    } else {
      init();
      window.addEventListener("load", init);
    }

    return () => {
      if (observer) observer.disconnect();
      window.removeEventListener('load', init);
    };
  }, []);
  useEffect(() => {
    if (!(offsetTop >= 0)) return;

    const handleScroll = () => {
      const scrollTop = getCurrScrollTop();
      if (lockMinusListener && scrollTop < 0) return;

      if (scrollTop > offsetTop) {
        if (!fixed) setFixed(true);
      } else {
        if (fixed) setFixed(false);
      }
    };

    if (openFixed) {
      handleScroll();
      window.addEventListener('scroll', handleScroll);
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [offsetTop, fixed]);
  useEffect(() => {
    navs[currTabNavIndex]._activeCache = true;
    if (!openLog) return;
    sendLogRef.current(currTabNavIndex);
  }, [currTabNavIndex]);
  const components = children ? children.length ? children : [children] : [];
  const navBarProps = {
    navs,
    navStyle,
    openWrap,
    lineCount,
    active,
    inactive,
    offsetTop,
    setOffsetTop,
    fixed,
    showTitle,
    openFixed,
    openScroll,
    currTabNavIndex,
    setCurrTabNavIndex
  };
  return <div className="relative scroll-y" ref={navsRef} style={fixed ? {
    paddingTop: navStyle.navBar.height
  } : {}}>
      <div className={`wd-100${fixed ? ' fixed z-index-5' : ''}`} style={fixed ? {
      top: fixedTop
    } : {}}>
        <TabNavBar {...navBarProps} />
      </div>
      {components.length ? openCache ? <div className="relative">
            {components.map((child, childIndex) => {
        const currNav = navs[childIndex] || {};
        const isActiveCache = currNav._activeCache;
        const isActive = childIndex === currTabNavIndex;
        const minHeight = currNav.minHeight;
        return isActiveCache ? <div key={childIndex} className={`${isActive ? '' : 'hide'}`} style={{
          minHeight
        }}>{child}</div> : isActive ? <div key={childIndex} style={{
          minHeight
        }}>{child}</div> : null;
      })}
          </div> : <div className="relative">
            {components.map((child, childIndex) => {
        const currNav = navs[childIndex] || {};
        const minHeight = currNav.minHeight;
        return childIndex === currTabNavIndex ? <div key={childIndex} style={{
          minHeight
        }}>{child}</div> : null;
      })}
          </div> : <div className="text-center mv-3 f14">请添加标签导航子组件</div>}
    </div>;
};

const TabNavsContainer__89 = ({
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  children: children,
  navs: navs,
  config: config
}) => {
  const defaultTabNavIndex = useMemo(() => {
    const configDefaultIndex = navs.findIndex(nav => nav.default);
    const params = parseQuery(window.location.search);
    const {
      tabNavsId,
      tabNavsIndex
    } = params;
    if (tabNavsId && tabNavsId !== id) return configDefaultIndex;
    const index = tabNavsIndex ? parseInt(tabNavsIndex) : -1;
    return index >= 0 ? index : configDefaultIndex;
  }, []);
  const [currTabNavIndex, setCurrTabNavIndex] = useState(defaultTabNavIndex > -1 ? defaultTabNavIndex : 0);
  const [offsetTop, setOffsetTop] = useState();
  const [fixed, setFixed] = useState(false);
  const navsRef = useRef__89();
  const {
    showTitle,
    open: openFixed = false,
    top: fixedTop = 0,
    inactive,
    active,
    openWrap,
    lineCount,
    openCache,
    openLog,
    lockMinusListener,
    openScroll
  } = config;
  const sendLogRef = useRef__89(tabIndex => {
    qt.monitor.bmsActionEvent({
      eventId: 'tabNavs_click',
      nodeId,
      nodeType,
      data: {
        pos: tabIndex + 1
      }
    });
  });
  const rowCount = Math.ceil(navs.length / lineCount);
  const navStyle = {
    navBar: {
      fontSize: config.fontSize,
      color: config.color,
      height: openWrap ? config.height * rowCount + config.marginBottom * (rowCount - 1) : config.height
    },
    navItem: {
      width: config.itemWidth,
      height: config.itemHeight,
      marginRight: config.marginRight,
      marginBottom: config.marginBottom,
      borderRadius: config.borderRadius
    },
    activeItem: {},
    activeText: {
      fontSize: active.fontSize,
      color: active.color,
      fontWeight: active.fontWeight
    },
    activeLine: active.line,
    content: config.content
  };
  navStyle.navBar.background = config.backgroundImage ? `url(${config.backgroundImage}) center center / contain repeat-x ${config.backgroundColor || ''}` : config.backgroundColor;
  navStyle.navItem.background = inactive.backgroundImage ? `url(${inactive.backgroundImage}) center center / contain no-repeat ${inactive.backgroundColor || ''}` : inactive.backgroundColor;
  navStyle.activeItem.background = active.backgroundImage ? `url(${active.backgroundImage}) center center / contain no-repeat ${active.backgroundColor || ''}` : active.backgroundColor;
  useEffect(() => {
    const init = () => {
      if (!navsRef.current) return;
      const top = navsRef.current.getBoundingClientRect().top - fixedTop;
      const offsetTop = getCurrScrollTop() + top;
      setOffsetTop(offsetTop);
    };

    let observer;

    if (MutationObserver) {
      observer = new MutationObserver(init);
      observer.observe(document, {
        childList: true,
        subtree: true
      });
    } else {
      init();
      window.addEventListener("load", init);
    }

    return () => {
      if (observer) observer.disconnect();
      window.removeEventListener('load', init);
    };
  }, []);
  useEffect(() => {
    if (!(offsetTop >= 0)) return;

    const handleScroll = () => {
      const scrollTop = getCurrScrollTop();
      if (lockMinusListener && scrollTop < 0) return;

      if (scrollTop > offsetTop) {
        if (!fixed) setFixed(true);
      } else {
        if (fixed) setFixed(false);
      }
    };

    if (openFixed) {
      handleScroll();
      window.addEventListener('scroll', handleScroll);
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [offsetTop, fixed]);
  useEffect(() => {
    navs[currTabNavIndex]._activeCache = true;
    if (!openLog) return;
    sendLogRef.current(currTabNavIndex);
  }, [currTabNavIndex]);
  const components = children ? children.length ? children : [children] : [];
  const navBarProps = {
    navs,
    navStyle,
    openWrap,
    lineCount,
    active,
    inactive,
    offsetTop,
    setOffsetTop,
    fixed,
    showTitle,
    openFixed,
    openScroll,
    currTabNavIndex,
    setCurrTabNavIndex
  };
  return <div className="relative scroll-y" ref={navsRef} style={fixed ? {
    paddingTop: navStyle.navBar.height
  } : {}}>
      <div className={`wd-100${fixed ? ' fixed z-index-5' : ''}`} style={fixed ? {
      top: fixedTop
    } : {}}>
        <TabNavBar {...navBarProps} />
      </div>
      {components.length ? openCache ? <div className="relative">
            {components.map((child, childIndex) => {
        const currNav = navs[childIndex] || {};
        const isActiveCache = currNav._activeCache;
        const isActive = childIndex === currTabNavIndex;
        const minHeight = currNav.minHeight;
        return isActiveCache ? <div key={childIndex} className={`${isActive ? '' : 'hide'}`} style={{
          minHeight
        }}>{child}</div> : isActive ? <div key={childIndex} style={{
          minHeight
        }}>{child}</div> : null;
      })}
          </div> : <div className="relative">
            {components.map((child, childIndex) => {
        const currNav = navs[childIndex] || {};
        const minHeight = currNav.minHeight;
        return childIndex === currTabNavIndex ? <div key={childIndex} style={{
          minHeight
        }}>{child}</div> : null;
      })}
          </div> : <div className="text-center mv-3 f14">请添加标签导航子组件</div>}
    </div>;
};

const SpaceLayout = ({
  id: id,
  children: children,
  config: config
}) => {
  const {
    common,
    styles
  } = config;
  const {
    height,
    cloneElementId
  } = common;
  const {
    background,
    position,
    top
  } = styles;
  const [elemHeight, setElemHeight] = useState(height); // == 获取元素高度

  useEffect__128(() => {
    if (!cloneElementId) return;
    const elem = document.getElementById(cloneElementId);
    if (!elem) return;

    const updateHeight = () => {
      const dynamicHeight = elem.getBoundingClientRect().height;
      if (dynamicHeight > 0 && elemHeight !== dynamicHeight) setElemHeight(dynamicHeight);
    };

    if (elem.tagName === 'IMG') {
      elem.complete ? updateHeight() : elem.onload = () => {
        updateHeight();
      };
    } else {
      const imgElems = elem.querySelectorAll('img');
      if (!imgElems.length) return updateHeight();

      for (let i = 0, n = imgElems.length; i < n; i++) {
        const imgElem = imgElems[i];
        imgElem.complete ? updateHeight() : imgElem.onload = () => {
          updateHeight();
        };
      }
    }
  }, []); // == 设置样式

  const style = {
    position,
    top,
    height: elemHeight
  };
  style.background = background.image ? `url(${background.image}) left top / ${background.size} ${background.repeat}` : background.color;
  return <div id={id} style={style}>{children || null}</div>;
};

const position = "bottom";
const effects = "scrollUpShow";
const effectParam = {
  scrollUpDisAppear: {
    top: 500
  },
  scrollUpShow: {
    top: 500
  }
};
const unit = "px";
const customStyle = {
  width: 108,
  height: 22,
  aspectRatio: "108:22",
  bgImg: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/4c3bc0207e60ddc82bc67b678abd3e70.png",
  bgColor: "transparent",
  top: 100,
  zIndex: 100,
  hasGradient: false,
  gradientDeg: 90,
  bgColor2: "transparent"
};

const FixedBar = ({
  children: children,
  position: position,
  customStyle: customStyle,
  effects: effects,
  effectParam: effectParam
}) => {
  const fixBar = useRef__130();
  const [fixStyle, setFixStyle] = useState__130({});
  useEffect__130(() => {
    const basicFixStyle = {
      position: 'fixed',
      height: 70,
      transition: 'transform 300ms ease-in',
      zIndex: customStyle.zIndex
    };
    const positionStyle = {
      topStyle: {
        top: 0,
        width: '100%'
      },
      bottomStyle: {
        bottom: 0,
        width: '100%'
      },
      leftStyle: {
        left: 0,
        top: '60%',
        width: 70
      },
      rightStyle: {
        right: 0,
        top: '60%',
        width: 70
      }
    };
    let widthRadio, heightRadio;

    if (customStyle.aspectRatio) {
      const radios = customStyle.aspectRatio.split(':');
      widthRadio = Number(radios[0]);
      heightRadio = Number(radios[1]);
    }

    switch (position) {
      case 'top':
        Object.assign(basicFixStyle, positionStyle.topStyle, customStyle);

        if (widthRadio) {
          basicFixStyle.height = window.innerWidth / widthRadio * heightRadio;
        }

        break;

      case 'bottom':
        Object.assign(basicFixStyle, positionStyle.bottomStyle, customStyle);

        if (widthRadio) {
          basicFixStyle.height = window.innerWidth / widthRadio * heightRadio;
        }

        break;

      case 'left':
        Object.assign(basicFixStyle, positionStyle.leftStyle, customStyle);
        break;

      case 'right':
        Object.assign(basicFixStyle, positionStyle.rightStyle, customStyle);
        break;

      default:
        break;
    }

    switch (effects) {
      case 'scrollUpDisAppear':
        window.addEventListener('scroll', () => {
          if (!fixBar.current) return;
          const param = effectParam[effects];

          if (document.body.scrollTop >= param.top || document.documentElement.scrollTop >= param.top) {
            fixBar.current.style.transform = `translateY(${basicFixStyle.height.toString().indexOf('px') > -1 ? basicFixStyle.height : basicFixStyle.height + 'px'})`;
          } else {
            fixBar.current.style.transform = '';
          }
        });
        break;

      case 'scrollUpShow':
        basicFixStyle.transform = `translateY(${basicFixStyle.height.toString().indexOf('px') > -1 ? basicFixStyle.height : basicFixStyle.height + 'px'})`;
        window.addEventListener('scroll', () => {
          if (!fixBar.current) return;
          const param = effectParam[effects];

          if (document.body.scrollTop >= param.top || document.documentElement.scrollTop >= param.top) {
            fixBar.current.style.transform = '';
          } else {
            fixBar.current.style.transform = `translateY(${basicFixStyle.height.toString().indexOf('px') > -1 ? basicFixStyle.height : basicFixStyle.height + 'px'})`;
          }
        });
        break;

      default:
        break;
    }

    setFixStyle(basicFixStyle);
  }, []);
  return <div style={fixStyle} ref={fixBar}>{children}</div>;
};

const productId__131 = {
  androidId: "5eec93f4f84f475b9763d043",
  iosId: "fm.qingting.specailactivity.12month.98yuan12"
};
const options__131 = {
  limitJudge: true,
  isBenefit: false,
  hasResultPage: true,
  popLog: true,
  content: ""
};
const btnStyle__131 = {
  unit: "px",
  isAbsolute: true,
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  color: "#fff",
  fontSize: 16,
  hasAnimation: false,
  bgImg: "",
  bgColor: "transparent",
  width: null,
  height: null
};

const BuyButton__131 = ({
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  productId: productId__131,
  btnStyle: btnStyle__131,
  options: options__131
}) => {
  const [deviceId, setDeviceId] = useState('');
  const [token, setToken] = useState('');
  const [showSpin, setShowSpin] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [resultData, setResultData] = useState({});
  const buttonRef = useRef();
  const [exposed, setExposed] = React.useState(false);
  const resultParams = {};
  useEffect__131(() => {
    qt.getDevice().then(res => {
      setDeviceId(res.deviceId);
      return qt.getAccessToken();
    }).then(token => setToken(token));
  }, []);
  useEffect__131(() => {
    if (!options__131.popLog) return;
    if (exposed) return;
    window.addEventListener('scroll', popTrack);
  }, [exposed]); // == 判断用户是否到达购买上限

  const judgeLimit = user_id => {
    return axios.get(`https://pay${process.env.SITE_ENV === 'stg' ? '.staging' : ''}.qingting.fm/cashdesk/v1/vip/reached_limit`, {
      params: {
        user_id
      }
    }).then(data => data.data);
  }; // == 判断是否购买过特惠商品


  const checkUsesrBenefit = id => {
    return axios.get(`https://webapi${process.env.SITE_ENV === 'stg' ? '.staging' : ''}.qingting.fm/material/frontend/423/check-user-benefit`, {
      params: {
        user_id: id,
        device_id: deviceId,
        access_token: token
      },
      withCredentials: true
    }).then(data => data.data);
  }; // == 获取结果页数据


  const getResultData = ({
    userId,
    deviceId,
    phoneType,
    itemId,
    orderId,
    systemInfo = {}
  }) => {
    const params = {
      user_id: userId,
      device_id: deviceId,
      phone_type: phoneType,
      item_id: itemId,
      order_id: orderId
    };
    Object.assign(params, systemInfo);
    return axios.get(`https://pay${process.env.SITE_ENV === 'stg' ? '.staging' : ''}.qingting.fm/cashdesk/v1/vip/result`, {
      params
    }).then(data => data.data);
  }; // == 点击购买按钮


  const purchase = async () => {
    qt.monitor.bmsActionEvent({
      eventId: 'buyButton_click',
      nodeId,
      nodeType,
      data: {
        name: id
      }
    });
    const userId = await qt.getUserId();

    if (userId) {
      resultParams.userId = userId;
      let judgeLimitData, checkBenefitData;
      if (options__131.limitJudge) judgeLimitData = await judgeLimit(userId);

      if (judgeLimitData && judgeLimitData.data && judgeLimitData.data.reached_limit) {
        Toast.info({
          content: judgeLimitData.data.toast.substring(0, 19) + '<br />' + judgeLimitData.data.toast.substring(19) || '为保护您的权益，今日购买额度已用完，请<br />明日再尝试购买',
          duration: 3000
        });
        return;
      }

      if (options__131.isBenefit) checkBenefitData = await checkUsesrBenefit(userId);

      if (checkBenefitData && checkBenefitData.data && checkBenefitData.data.has_benefit) {
        Toast.info({
          content: '您已购买过特惠商品！',
          duration: 3000
        });
        return;
      }

      goPurchase();
    } else {
      qt.login({
        env: process.env.SITE_ENV === 'stg' ? 'staging' : 'production'
      });
    }
  }; // == 购买动作


  const goPurchase = () => {
    let param = {};

    if (qt.env.inIosApp) {
      param = {
        productId: productId__131.iosId
      };
    } else {
      param = {
        itemId: productId__131.androidId
      };
    }

    let partner = qs.parse(window.location.search.slice(1)).partner;
    if (partner) param.partner = partner;
    setShowSpin(true);
    qt.purchase(param).then(async (res = {}) => {
      resultParams.orderId = res.orderId;
      setShowSpin(false);

      if (options__131.hasResultPage && res.orderId) {
        if (qt.env.inIosApp) resultParams.systemInfo = await qt.getSystemInfo();
        resultParams.deviceId = deviceId;
        resultParams.phoneType = qt.env.inIosApp ? 'iOS' : 'android';
        resultParams.itemId = productId__131.androidId;
        let data = await getResultData(resultParams);
        setResultData(data.data);
        setShowResult(true);
      }

      ;
    }).catch(e => {
      setShowSpin(false);
      Toast.info({
        content: e.message,
        duration: 3000
      });
    });
  };

  const getScrollTop = () => {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
  };

  const popTrack = () => {
    if (!buttonRef.current) return;
    const pos = buttonRef.current.getBoundingClientRect();
    const scrollTop = getScrollTop();
    const offsetTop = scrollTop + pos.top;
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const isExposeTop = scrollTop >= offsetTop + pos.height / 2 - windowHeight;
    const isExposeBottom = scrollTop < offsetTop + pos.height / 2;

    if (isExposeTop && isExposeBottom) {
      qt.monitor.bmsExpose({
        eventId: 'buyButton_view',
        nodeId,
        nodeType
      });
      setExposed(true);
      setTimeout(() => setExposed(false), 10000);
      window.removeEventListener('scroll', popTrack);
    }
  };

  useEffect__131(() => {
    if (showResult) {
      const div = document.getElementById(nodeId) || document.createElement('div');
      div.setAttribute('id', nodeId);
      document.body.appendChild(div);
      ReactDOM.render(<ResultPop env={process.env.SITE_ENV} resultData={resultData} onClose={() => setShowResult(false)}></ResultPop>, div);
    } else {
      const div = document.getElementById(nodeId);
      if (div) document.body.removeChild(div);
    }
  }, [showResult]);
  const spinStyle = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 100,
    height: 50,
    width: 50,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    borderRadius: 8,
    boxSizing: 'border-box',
    padding: 10
  };
  return <>
    <style>{`
      @keyframes buy-button-breath {
        0% { transform: scale(0.9); }  
        50% { transform: scale(1); }  
        100% { transform: scale(0.9); }
      }
    `}</style>
    {showSpin ? <div style={spinStyle}><ReactLoading type={'spokes'} width={'100%'} height={'100%'} /></div> : null}
    <div style={btnStyle__131} onClick={() => purchase()} ref={buttonRef}>{options__131.content}</div>
  </>;
};

const TopicMarquee = ({
  id: id,
  config: config,
  children: children
}) => {
  const {
    list,
    common,
    style,
    positionStyle
  } = config;
  const {
    direction,
    delay,
    slidesPerView
  } = common;
  const {
    color,
    backgroundColor,
    fontSize,
    height,
    margin,
    opacity
  } = style;
  const [fileData, setFileData] = useState();
  const ref = useRef__137();
  const canSlide = list.length && !(list.length === 1 && !list[0].text);
  const perView = slidesPerView > list.length ? list.length : slidesPerView; // == rem单位处理

  if (positionStyle.type === 'rem' || positionStyle.type === '%') {
    const {
      type,
      top,
      bottom,
      left,
      right
    } = positionStyle;
    positionStyle.top = top ? `${top}${type}` : top;
    positionStyle.bottom = bottom ? `${bottom}${type}` : bottom;
    positionStyle.left = left ? `${left}${type}` : left;
    positionStyle.right = right ? `${right}${type}` : right;
  }

  delete positionStyle.type; // == 按需加载swiper.js

  useEffect(() => {
    import('swiper').then(fileData => {
      setFileData(fileData);
    });
  }, []);
  useEffect(() => {
    if (!fileData) return;
    new fileData.default(ref.current, {
      loop: true,
      autoplay: {
        delay
      },
      allowTouchMove: false,
      spaceBetween: margin,
      direction,
      slidesPerView: perView
    });
  }, [fileData]); // == 样式计算

  const padding = height * 0.15;
  const innerHeight = height - 2 * padding;
  const swiperHeight = height * perView + margin * (perView - 1);
  const itemStyle = {
    color,
    backgroundColor,
    height: innerHeight,
    padding,
    paddingRight: padding * 3,
    borderRadius: height / 2,
    borderBottomLeftRadius: 0,
    opacity: opacity / 100
  };
  const avatarStyle = {
    width: innerHeight,
    height: innerHeight
  };
  const textStyle = {
    maxWidth: 183,
    marginLeft: padding / 2,
    fontSize,
    paddingTop: (innerHeight - fontSize) / 2
  };
  return canSlide ? <div id={id} style={positionStyle}>
      <div id={`swiper-${id}`} ref={ref} className={`swiper-container`} style={{
      display: fileData ? 'block' : 'none',
      height: swiperHeight
    }}>
        <div className="swiper-wrapper">
          {list.map((item, index) => {
          const {
            avatar,
            text
          } = item;
          return <div key={index} className="swiper-slide">
              <div style={itemStyle} className="clearfix inblock relative">
                {avatar ? <img src={avatar} className="fl radius-50" style={avatarStyle} /> : <span className="fl radius-50" style={{
                backgroundColor: "#ffffff",
                ...avatarStyle
              }}></span>}
                <span className="fl ellipsis" style={textStyle}>{text}</span>
              </div>
            </div>;
        })}
        </div>
      </div>
      {children}
    </div> : <div style={{
    margin: '30px 0',
    textAlign: 'center',
    fontSize: 14
  }}>请添加和录入字幕</div>;
};

const wrapStyle__139 = {
  fontSize: '14px',
  textAlign: 'center',
  vertAlign: 'middle',
  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

const RenderRule__139 = ({
  basicConfig: basicConfig,
  children: children,
  id = "",
  nodeId = "",
  nodeType = ""
}) => {
  let width = basicConfig.coverImgWidth,
      height = basicConfig.coverImgHeight,
      top = basicConfig.coverImgTop,
      right = basicConfig.coverImgRight,
      bottom = basicConfig.coverImgBottom,
      left = basicConfig.coverImgLeft,
      unit = basicConfig.unit;

  if (unit !== 'px') {
    width = width + unit;
    height = height + unit;
    top = top + unit;
    right = right + unit;
    bottom = bottom + unit;
    left = left + unit;
  }

  let ruleStyle = Object.assign({}, wrapStyle__139, {
    width,
    height,
    marginTop: top,
    marginRight: right,
    marginBottom: bottom,
    marginLeft: left,
    position: basicConfig.position,
    zIndex: basicConfig.zIndex
  });

  if (basicConfig.position === 'fixed' || basicConfig.position === 'absolute') {
    ruleStyle = Object.assign({}, wrapStyle__139, {
      width,
      height,
      top,
      right,
      bottom,
      left,
      position: basicConfig.position,
      zIndex: basicConfig.zIndex
    });
  }

  const imgStyle = {
    width,
    height,
    display: 'block'
  };
  const contentStyle = {
    lineHeight: basicConfig.lineHeight,
    whiteSpace: 'pre-wrap',
    height: basicConfig.ruleContentHeight ? basicConfig.ruleContentHeight + basicConfig.unit : '',
    maxHeight: basicConfig.ruleContentMaxHeight ? basicConfig.ruleContentMaxHeight + basicConfig.unit : '',
    textAlign: 'left',
    overflowY: 'auto',
    fontSize: basicConfig.ruleFontSize
  };
  return <Fragment>
        <div style={ruleStyle} onClick={() => {
      qt.monitor.bmsActionEvent({
        eventId: 'fixedRule_click',
        nodeId,
        nodeType
      });
      Modal.show({
        title: '活动规则',
        jsxContent: <div style={contentStyle} dangerouslySetInnerHTML={{
          __html: basicConfig.ruleContent
        }}></div>,
        showTopPic: false,
        okText: '知道了',
        onOk: () => {},
        showCancel: false
      });
    }}>
            {children ? children : <img style={imgStyle} alt={"rule-cover"} src={basicConfig.coverImg} />}
        </div>
    </Fragment>;
};

const productId__143 = {
  androidId: "5cab0479dfaf350bc750f4b4",
  iosId: "fm.qingting.specailactivity.12month.98yuan1"
};
const options__143 = {
  limitJudge: true,
  isBenefit: false,
  hasResultPage: true,
  popLog: true,
  content: ""
};
const btnStyle__143 = {
  unit: "px",
  isAbsolute: true,
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  color: "transparent",
  fontSize: null,
  hasAnimation: true,
  bgImg: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/fbd8c9d5387843730fb245dd9231e621.png",
  bgColor: "transparent",
  width: null,
  height: null
};

const BuyButton__143 = ({
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  productId: productId__143,
  btnStyle: btnStyle__143,
  options: options__143
}) => {
  const [deviceId, setDeviceId] = useState('');
  const [token, setToken] = useState('');
  const [showSpin, setShowSpin] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [resultData, setResultData] = useState({});
  const buttonRef = useRef();
  const [exposed, setExposed] = React.useState(false);
  const resultParams = {};
  useEffect__143(() => {
    qt.getDevice().then(res => {
      setDeviceId(res.deviceId);
      return qt.getAccessToken();
    }).then(token => setToken(token));
  }, []);
  useEffect__143(() => {
    if (!options__143.popLog) return;
    if (exposed) return;
    window.addEventListener('scroll', popTrack);
  }, [exposed]);

  const judgeLimit = user_id => {
    return axios.get(`https://pay${process.env.SITE_ENV === 'stg' ? '.staging' : ''}.qingting.fm/cashdesk/v1/vip/reached_limit`, {
      params: {
        user_id
      }
    }).then(data => data.data);
  };

  const checkUsesrBenefit = id => {
    return axios.get(`https://webapi${process.env.SITE_ENV === 'stg' ? '.staging' : ''}.qingting.fm/material/frontend/423/check-user-benefit`, {
      params: {
        user_id: id,
        device_id: deviceId,
        access_token: token
      },
      withCredentials: true
    }).then(data => data.data);
  };

  const getResultData = ({
    userId,
    deviceId,
    phoneType,
    itemId,
    orderId,
    systemInfo = {}
  }) => {
    const params = {
      user_id: userId,
      device_id: deviceId,
      phone_type: phoneType,
      item_id: itemId,
      order_id: orderId
    };
    Object.assign(params, systemInfo);
    return axios.get(`https://pay${process.env.SITE_ENV === 'stg' ? '.staging' : ''}.qingting.fm/cashdesk/v1/vip/result`, {
      params
    }).then(data => data.data);
  };

  const purchase = async () => {
    qt.monitor.bmsActionEvent({
      eventId: 'buyButton_click',
      nodeId,
      nodeType,
      data: {
        name: id
      }
    });
    const userId = await qt.getUserId();

    if (userId) {
      resultParams.userId = userId;
      let judgeLimitData, checkBenefitData;
      if (options__143.limitJudge) judgeLimitData = await judgeLimit(userId);

      if (judgeLimitData && judgeLimitData.data && judgeLimitData.data.reached_limit) {
        Toast.info({
          content: judgeLimitData.data.toast.substring(0, 19) + '<br />' + judgeLimitData.data.toast.substring(19) || '为保护您的权益，今日购买额度已用完，请<br />明日再尝试购买',
          duration: 3000
        });
        return;
      }

      if (options__143.isBenefit) checkBenefitData = await checkUsesrBenefit(userId);

      if (checkBenefitData && checkBenefitData.data && checkBenefitData.data.has_benefit) {
        Toast.info({
          content: '您已购买过特惠商品！',
          duration: 3000
        });
        return;
      }

      goPurchase();
    } else {
      qt.login({
        env: process.env.SITE_ENV === 'stg' ? 'staging' : 'production'
      });
    }
  };

  const goPurchase = () => {
    let param = {};

    if (qt.env.inIosApp) {
      param = {
        productId: productId__143.iosId
      };
    } else {
      param = {
        itemId: productId__143.androidId
      };
    }

    let partner = qs.parse(window.location.search.slice(1)).partner;
    if (partner) param.partner = partner;
    setShowSpin(true);
    qt.purchase(param).then(async (res = {}) => {
      resultParams.orderId = res.orderId;
      setShowSpin(false);

      if (options__143.hasResultPage && res.orderId) {
        if (qt.env.inIosApp) resultParams.systemInfo = await qt.getSystemInfo();
        resultParams.deviceId = deviceId;
        resultParams.phoneType = qt.env.inIosApp ? 'iOS' : 'android';
        resultParams.itemId = productId__143.androidId;
        let data = await getResultData(resultParams);
        setResultData(data.data);
        setShowResult(true);
      }

      ;
    }).catch(e => {
      setShowSpin(false);
      Toast.info({
        content: e.message,
        duration: 3000
      });
    });
  };

  const getScrollTop = () => {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
  };

  const popTrack = () => {
    if (!buttonRef.current) return;
    const pos = buttonRef.current.getBoundingClientRect();
    const scrollTop = getScrollTop();
    const offsetTop = scrollTop + pos.top;
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const isExposeTop = scrollTop >= offsetTop + pos.height / 2 - windowHeight;
    const isExposeBottom = scrollTop < offsetTop + pos.height / 2;

    if (isExposeTop && isExposeBottom) {
      qt.monitor.bmsExpose({
        eventId: 'buyButton_view',
        nodeId,
        nodeType
      });
      setExposed(true);
      setTimeout(() => setExposed(false), 10000);
      window.removeEventListener('scroll', popTrack);
    }
  };

  useEffect__143(() => {
    if (showResult) {
      const div = document.getElementById(nodeId) || document.createElement('div');
      div.setAttribute('id', nodeId);
      document.body.appendChild(div);
      ReactDOM.render(<ResultPop env={process.env.SITE_ENV} resultData={resultData} onClose={() => setShowResult(false)}></ResultPop>, div);
    } else {
      const div = document.getElementById(nodeId);
      if (div) document.body.removeChild(div);
    }
  }, [showResult]);
  const spinStyle = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 100,
    height: 50,
    width: 50,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    borderRadius: 8,
    boxSizing: 'border-box',
    padding: 10
  };
  return <>
    <style>{`
      @keyframes buy-button-breath {
        0% { transform: scale(0.9); }  
        50% { transform: scale(1); }  
        100% { transform: scale(0.9); }
      }
    `}</style>
    {showSpin ? <div style={spinStyle}><ReactLoading type={'spokes'} width={'100%'} height={'100%'} /></div> : null}
    <div style={btnStyle__143} onClick={() => purchase()} ref={buttonRef}>{options__143.content}</div>
  </>;
};

window.linkedme.init('d828bfa52e3abbef26d0339a0aaa8640', {
  type: 'live'
}, null);
window.qtWebLog = qtWebLog;
qtWebLog.push('_setAccount', 'MobileSite');

const TabNavsContainer__154 = ({
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  children: children,
  navs: navs,
  config: config
}) => {
  const defaultTabNavIndex = useMemo(() => {
    const configDefaultIndex = navs.findIndex(nav => nav.default);
    const params = parseQuery(window.location.search);
    const {
      tabNavsId,
      tabNavsIndex
    } = params;
    if (tabNavsId && tabNavsId !== id) return configDefaultIndex;
    const index = tabNavsIndex ? parseInt(tabNavsIndex) : -1;
    return index >= 0 ? index : configDefaultIndex;
  }, []);
  const [currTabNavIndex, setCurrTabNavIndex] = useState(defaultTabNavIndex > -1 ? defaultTabNavIndex : 0);
  const [offsetTop, setOffsetTop] = useState();
  const [fixed, setFixed] = useState(false);
  const navsRef = useRef__154();
  const {
    showTitle,
    open: openFixed = false,
    top: fixedTop = 0,
    inactive,
    active,
    openWrap,
    lineCount,
    openCache,
    openLog,
    lockMinusListener,
    openScroll
  } = config; // == 日志发送

  const sendLogRef = useRef__154(tabIndex => {
    qt.monitor.bmsActionEvent({
      eventId: 'tabNavs_click',
      nodeId,
      nodeType,
      data: {
        pos: tabIndex + 1
      }
    });
  });
  const rowCount = Math.ceil(navs.length / lineCount); // == 标签导航通用样式

  const navStyle = {
    navBar: {
      fontSize: config.fontSize,
      color: config.color,
      height: openWrap ? config.height * rowCount + config.marginBottom * (rowCount - 1) : config.height
    },
    navItem: {
      width: config.itemWidth,
      height: config.itemHeight,
      marginRight: config.marginRight,
      marginBottom: config.marginBottom,
      borderRadius: config.borderRadius
    },
    activeItem: {},
    activeText: {
      fontSize: active.fontSize,
      color: active.color,
      fontWeight: active.fontWeight
    },
    activeLine: active.line,
    content: config.content
  }; // == 背景样式

  navStyle.navBar.background = config.backgroundImage ? `url(${config.backgroundImage}) center center / contain repeat-x ${config.backgroundColor || ''}` : config.backgroundColor;
  navStyle.navItem.background = inactive.backgroundImage ? `url(${inactive.backgroundImage}) center center / contain no-repeat ${inactive.backgroundColor || ''}` : inactive.backgroundColor;
  navStyle.activeItem.background = active.backgroundImage ? `url(${active.backgroundImage}) center center / contain no-repeat ${active.backgroundColor || ''}` : active.backgroundColor; // == 初始化偏移距离

  useEffect(() => {
    const init = () => {
      if (!navsRef.current) return;
      const top = navsRef.current.getBoundingClientRect().top - fixedTop;
      const offsetTop = getCurrScrollTop() + top;
      setOffsetTop(offsetTop);
    };

    let observer;

    if (MutationObserver) {
      observer = new MutationObserver(init);
      observer.observe(document, {
        childList: true,
        subtree: true
      });
    } else {
      init();
      window.addEventListener("load", init);
    }

    return () => {
      if (observer) observer.disconnect();
      window.removeEventListener('load', init);
    };
  }, []); // == 监听滚动并吸顶

  useEffect(() => {
    if (!(offsetTop >= 0)) return;

    const handleScroll = () => {
      const scrollTop = getCurrScrollTop();
      if (lockMinusListener && scrollTop < 0) return; // 负向滚动禁止

      if (scrollTop > offsetTop) {
        if (!fixed) setFixed(true);
      } else {
        if (fixed) setFixed(false);
      }
    };

    if (openFixed) {
      handleScroll();
      window.addEventListener('scroll', handleScroll);
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [offsetTop, fixed]); // == 监听导航变化并发送日志

  useEffect(() => {
    navs[currTabNavIndex]._activeCache = true; // 缓存触发标记

    if (!openLog) return;
    sendLogRef.current(currTabNavIndex);
  }, [currTabNavIndex]);
  const components = children ? children.length ? children : [children] : [];
  const navBarProps = {
    navs,
    navStyle,
    openWrap,
    lineCount,
    active,
    inactive,
    offsetTop,
    setOffsetTop,
    fixed,
    showTitle,
    openFixed,
    openScroll,
    currTabNavIndex,
    setCurrTabNavIndex
  };
  return <div className="relative scroll-y" ref={navsRef} style={fixed ? {
    paddingTop: navStyle.navBar.height
  } : {}}>
      <div className={`wd-100${fixed ? ' fixed z-index-5' : ''}`} style={fixed ? {
      top: fixedTop
    } : {}}>
        <TabNavBar {...navBarProps} />
      </div>
      {components.length ? openCache ? <div className="relative">
            {components.map((child, childIndex) => {
        const currNav = navs[childIndex] || {};
        const isActiveCache = currNav._activeCache;
        const isActive = childIndex === currTabNavIndex;
        const minHeight = currNav.minHeight;
        return isActiveCache ? <div key={childIndex} className={`${isActive ? '' : 'hide'}`} style={{
          minHeight
        }}>{child}</div> : isActive ? <div key={childIndex} style={{
          minHeight
        }}>{child}</div> : null;
      })}
          </div> : <div className="relative">
            {components.map((child, childIndex) => {
        const currNav = navs[childIndex] || {};
        const minHeight = currNav.minHeight;
        return childIndex === currTabNavIndex ? <div key={childIndex} style={{
          minHeight
        }}>{child}</div> : null;
      })}
          </div> : <div className="text-center mv-3 f14">请添加标签导航子组件</div>}
    </div>;
};

const TabNavsContainer__170 = ({
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  children: children,
  navs: navs,
  config: config
}) => {
  const defaultTabNavIndex = useMemo(() => {
    const configDefaultIndex = navs.findIndex(nav => nav.default);
    const params = parseQuery(window.location.search);
    const {
      tabNavsId,
      tabNavsIndex
    } = params;
    if (tabNavsId && tabNavsId !== id) return configDefaultIndex;
    const index = tabNavsIndex ? parseInt(tabNavsIndex) : -1;
    return index >= 0 ? index : configDefaultIndex;
  }, []);
  const [currTabNavIndex, setCurrTabNavIndex] = useState(defaultTabNavIndex > -1 ? defaultTabNavIndex : 0);
  const [offsetTop, setOffsetTop] = useState();
  const [fixed, setFixed] = useState(false);
  const navsRef = useRef__170();
  const {
    showTitle,
    open: openFixed = false,
    top: fixedTop = 0,
    inactive,
    active,
    openWrap,
    lineCount,
    openCache,
    openLog,
    lockMinusListener,
    openScroll
  } = config;
  const sendLogRef = useRef__170(tabIndex => {
    qt.monitor.bmsActionEvent({
      eventId: 'tabNavs_click',
      nodeId,
      nodeType,
      data: {
        pos: tabIndex + 1
      }
    });
  });
  const rowCount = Math.ceil(navs.length / lineCount);
  const navStyle = {
    navBar: {
      fontSize: config.fontSize,
      color: config.color,
      height: openWrap ? config.height * rowCount + config.marginBottom * (rowCount - 1) : config.height
    },
    navItem: {
      width: config.itemWidth,
      height: config.itemHeight,
      marginRight: config.marginRight,
      marginBottom: config.marginBottom,
      borderRadius: config.borderRadius
    },
    activeItem: {},
    activeText: {
      fontSize: active.fontSize,
      color: active.color,
      fontWeight: active.fontWeight
    },
    activeLine: active.line,
    content: config.content
  };
  navStyle.navBar.background = config.backgroundImage ? `url(${config.backgroundImage}) center center / contain repeat-x ${config.backgroundColor || ''}` : config.backgroundColor;
  navStyle.navItem.background = inactive.backgroundImage ? `url(${inactive.backgroundImage}) center center / contain no-repeat ${inactive.backgroundColor || ''}` : inactive.backgroundColor;
  navStyle.activeItem.background = active.backgroundImage ? `url(${active.backgroundImage}) center center / contain no-repeat ${active.backgroundColor || ''}` : active.backgroundColor;
  useEffect(() => {
    const init = () => {
      if (!navsRef.current) return;
      const top = navsRef.current.getBoundingClientRect().top - fixedTop;
      const offsetTop = getCurrScrollTop() + top;
      setOffsetTop(offsetTop);
    };

    let observer;

    if (MutationObserver) {
      observer = new MutationObserver(init);
      observer.observe(document, {
        childList: true,
        subtree: true
      });
    } else {
      init();
      window.addEventListener("load", init);
    }

    return () => {
      if (observer) observer.disconnect();
      window.removeEventListener('load', init);
    };
  }, []);
  useEffect(() => {
    if (!(offsetTop >= 0)) return;

    const handleScroll = () => {
      const scrollTop = getCurrScrollTop();
      if (lockMinusListener && scrollTop < 0) return;

      if (scrollTop > offsetTop) {
        if (!fixed) setFixed(true);
      } else {
        if (fixed) setFixed(false);
      }
    };

    if (openFixed) {
      handleScroll();
      window.addEventListener('scroll', handleScroll);
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [offsetTop, fixed]);
  useEffect(() => {
    navs[currTabNavIndex]._activeCache = true;
    if (!openLog) return;
    sendLogRef.current(currTabNavIndex);
  }, [currTabNavIndex]);
  const components = children ? children.length ? children : [children] : [];
  const navBarProps = {
    navs,
    navStyle,
    openWrap,
    lineCount,
    active,
    inactive,
    offsetTop,
    setOffsetTop,
    fixed,
    showTitle,
    openFixed,
    openScroll,
    currTabNavIndex,
    setCurrTabNavIndex
  };
  return <div className="relative scroll-y" ref={navsRef} style={fixed ? {
    paddingTop: navStyle.navBar.height
  } : {}}>
      <div className={`wd-100${fixed ? ' fixed z-index-5' : ''}`} style={fixed ? {
      top: fixedTop
    } : {}}>
        <TabNavBar {...navBarProps} />
      </div>
      {components.length ? openCache ? <div className="relative">
            {components.map((child, childIndex) => {
        const currNav = navs[childIndex] || {};
        const isActiveCache = currNav._activeCache;
        const isActive = childIndex === currTabNavIndex;
        const minHeight = currNav.minHeight;
        return isActiveCache ? <div key={childIndex} className={`${isActive ? '' : 'hide'}`} style={{
          minHeight
        }}>{child}</div> : isActive ? <div key={childIndex} style={{
          minHeight
        }}>{child}</div> : null;
      })}
          </div> : <div className="relative">
            {components.map((child, childIndex) => {
        const currNav = navs[childIndex] || {};
        const minHeight = currNav.minHeight;
        return childIndex === currTabNavIndex ? <div key={childIndex} style={{
          minHeight
        }}>{child}</div> : null;
      })}
          </div> : <div className="text-center mv-3 f14">请添加标签导航子组件</div>}
    </div>;
};

const TabNavsContainer__202 = ({
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  children: children,
  navs: navs,
  config: config
}) => {
  const defaultTabNavIndex = useMemo(() => {
    const configDefaultIndex = navs.findIndex(nav => nav.default);
    const params = parseQuery(window.location.search);
    const {
      tabNavsId,
      tabNavsIndex
    } = params;
    if (tabNavsId && tabNavsId !== id) return configDefaultIndex;
    const index = tabNavsIndex ? parseInt(tabNavsIndex) : -1;
    return index >= 0 ? index : configDefaultIndex;
  }, []);
  const [currTabNavIndex, setCurrTabNavIndex] = useState(defaultTabNavIndex > -1 ? defaultTabNavIndex : 0);
  const [offsetTop, setOffsetTop] = useState();
  const [fixed, setFixed] = useState(false);
  const navsRef = useRef__202();
  const {
    showTitle,
    open: openFixed = false,
    top: fixedTop = 0,
    inactive,
    active,
    openWrap,
    lineCount,
    openCache,
    openLog,
    lockMinusListener,
    openScroll
  } = config;
  const sendLogRef = useRef__202(tabIndex => {
    qt.monitor.bmsActionEvent({
      eventId: 'tabNavs_click',
      nodeId,
      nodeType,
      data: {
        pos: tabIndex + 1
      }
    });
  });
  const rowCount = Math.ceil(navs.length / lineCount);
  const navStyle = {
    navBar: {
      fontSize: config.fontSize,
      color: config.color,
      height: openWrap ? config.height * rowCount + config.marginBottom * (rowCount - 1) : config.height
    },
    navItem: {
      width: config.itemWidth,
      height: config.itemHeight,
      marginRight: config.marginRight,
      marginBottom: config.marginBottom,
      borderRadius: config.borderRadius
    },
    activeItem: {},
    activeText: {
      fontSize: active.fontSize,
      color: active.color,
      fontWeight: active.fontWeight
    },
    activeLine: active.line,
    content: config.content
  };
  navStyle.navBar.background = config.backgroundImage ? `url(${config.backgroundImage}) center center / contain repeat-x ${config.backgroundColor || ''}` : config.backgroundColor;
  navStyle.navItem.background = inactive.backgroundImage ? `url(${inactive.backgroundImage}) center center / contain no-repeat ${inactive.backgroundColor || ''}` : inactive.backgroundColor;
  navStyle.activeItem.background = active.backgroundImage ? `url(${active.backgroundImage}) center center / contain no-repeat ${active.backgroundColor || ''}` : active.backgroundColor;
  useEffect(() => {
    const init = () => {
      if (!navsRef.current) return;
      const top = navsRef.current.getBoundingClientRect().top - fixedTop;
      const offsetTop = getCurrScrollTop() + top;
      setOffsetTop(offsetTop);
    };

    let observer;

    if (MutationObserver) {
      observer = new MutationObserver(init);
      observer.observe(document, {
        childList: true,
        subtree: true
      });
    } else {
      init();
      window.addEventListener("load", init);
    }

    return () => {
      if (observer) observer.disconnect();
      window.removeEventListener('load', init);
    };
  }, []);
  useEffect(() => {
    if (!(offsetTop >= 0)) return;

    const handleScroll = () => {
      const scrollTop = getCurrScrollTop();
      if (lockMinusListener && scrollTop < 0) return;

      if (scrollTop > offsetTop) {
        if (!fixed) setFixed(true);
      } else {
        if (fixed) setFixed(false);
      }
    };

    if (openFixed) {
      handleScroll();
      window.addEventListener('scroll', handleScroll);
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [offsetTop, fixed]);
  useEffect(() => {
    navs[currTabNavIndex]._activeCache = true;
    if (!openLog) return;
    sendLogRef.current(currTabNavIndex);
  }, [currTabNavIndex]);
  const components = children ? children.length ? children : [children] : [];
  const navBarProps = {
    navs,
    navStyle,
    openWrap,
    lineCount,
    active,
    inactive,
    offsetTop,
    setOffsetTop,
    fixed,
    showTitle,
    openFixed,
    openScroll,
    currTabNavIndex,
    setCurrTabNavIndex
  };
  return <div className="relative scroll-y" ref={navsRef} style={fixed ? {
    paddingTop: navStyle.navBar.height
  } : {}}>
      <div className={`wd-100${fixed ? ' fixed z-index-5' : ''}`} style={fixed ? {
      top: fixedTop
    } : {}}>
        <TabNavBar {...navBarProps} />
      </div>
      {components.length ? openCache ? <div className="relative">
            {components.map((child, childIndex) => {
        const currNav = navs[childIndex] || {};
        const isActiveCache = currNav._activeCache;
        const isActive = childIndex === currTabNavIndex;
        const minHeight = currNav.minHeight;
        return isActiveCache ? <div key={childIndex} className={`${isActive ? '' : 'hide'}`} style={{
          minHeight
        }}>{child}</div> : isActive ? <div key={childIndex} style={{
          minHeight
        }}>{child}</div> : null;
      })}
          </div> : <div className="relative">
            {components.map((child, childIndex) => {
        const currNav = navs[childIndex] || {};
        const minHeight = currNav.minHeight;
        return childIndex === currTabNavIndex ? <div key={childIndex} style={{
          minHeight
        }}>{child}</div> : null;
      })}
          </div> : <div className="text-center mv-3 f14">请添加标签导航子组件</div>}
    </div>;
};

const TabNavsContainer__225 = ({
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  children: children,
  navs: navs,
  config: config
}) => {
  const defaultTabNavIndex = useMemo(() => {
    const configDefaultIndex = navs.findIndex(nav => nav.default);
    const params = parseQuery(window.location.search);
    const {
      tabNavsId,
      tabNavsIndex
    } = params;
    if (tabNavsId && tabNavsId !== id) return configDefaultIndex;
    const index = tabNavsIndex ? parseInt(tabNavsIndex) : -1;
    return index >= 0 ? index : configDefaultIndex;
  }, []);
  const [currTabNavIndex, setCurrTabNavIndex] = useState(defaultTabNavIndex > -1 ? defaultTabNavIndex : 0);
  const [offsetTop, setOffsetTop] = useState();
  const [fixed, setFixed] = useState(false);
  const navsRef = useRef__225();
  const {
    showTitle,
    open: openFixed = false,
    top: fixedTop = 0,
    inactive,
    active,
    openWrap,
    lineCount,
    openCache,
    openLog,
    lockMinusListener,
    openScroll
  } = config;
  const sendLogRef = useRef__225(tabIndex => {
    qt.monitor.bmsActionEvent({
      eventId: 'tabNavs_click',
      nodeId,
      nodeType,
      data: {
        pos: tabIndex + 1
      }
    });
  });
  const rowCount = Math.ceil(navs.length / lineCount);
  const navStyle = {
    navBar: {
      fontSize: config.fontSize,
      color: config.color,
      height: openWrap ? config.height * rowCount + config.marginBottom * (rowCount - 1) : config.height
    },
    navItem: {
      width: config.itemWidth,
      height: config.itemHeight,
      marginRight: config.marginRight,
      marginBottom: config.marginBottom,
      borderRadius: config.borderRadius
    },
    activeItem: {},
    activeText: {
      fontSize: active.fontSize,
      color: active.color,
      fontWeight: active.fontWeight
    },
    activeLine: active.line,
    content: config.content
  };
  navStyle.navBar.background = config.backgroundImage ? `url(${config.backgroundImage}) center center / contain repeat-x ${config.backgroundColor || ''}` : config.backgroundColor;
  navStyle.navItem.background = inactive.backgroundImage ? `url(${inactive.backgroundImage}) center center / contain no-repeat ${inactive.backgroundColor || ''}` : inactive.backgroundColor;
  navStyle.activeItem.background = active.backgroundImage ? `url(${active.backgroundImage}) center center / contain no-repeat ${active.backgroundColor || ''}` : active.backgroundColor;
  useEffect(() => {
    const init = () => {
      if (!navsRef.current) return;
      const top = navsRef.current.getBoundingClientRect().top - fixedTop;
      const offsetTop = getCurrScrollTop() + top;
      setOffsetTop(offsetTop);
    };

    let observer;

    if (MutationObserver) {
      observer = new MutationObserver(init);
      observer.observe(document, {
        childList: true,
        subtree: true
      });
    } else {
      init();
      window.addEventListener("load", init);
    }

    return () => {
      if (observer) observer.disconnect();
      window.removeEventListener('load', init);
    };
  }, []);
  useEffect(() => {
    if (!(offsetTop >= 0)) return;

    const handleScroll = () => {
      const scrollTop = getCurrScrollTop();
      if (lockMinusListener && scrollTop < 0) return;

      if (scrollTop > offsetTop) {
        if (!fixed) setFixed(true);
      } else {
        if (fixed) setFixed(false);
      }
    };

    if (openFixed) {
      handleScroll();
      window.addEventListener('scroll', handleScroll);
    }

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [offsetTop, fixed]);
  useEffect(() => {
    navs[currTabNavIndex]._activeCache = true;
    if (!openLog) return;
    sendLogRef.current(currTabNavIndex);
  }, [currTabNavIndex]);
  const components = children ? children.length ? children : [children] : [];
  const navBarProps = {
    navs,
    navStyle,
    openWrap,
    lineCount,
    active,
    inactive,
    offsetTop,
    setOffsetTop,
    fixed,
    showTitle,
    openFixed,
    openScroll,
    currTabNavIndex,
    setCurrTabNavIndex
  };
  return <div className="relative scroll-y" ref={navsRef} style={fixed ? {
    paddingTop: navStyle.navBar.height
  } : {}}>
      <div className={`wd-100${fixed ? ' fixed z-index-5' : ''}`} style={fixed ? {
      top: fixedTop
    } : {}}>
        <TabNavBar {...navBarProps} />
      </div>
      {components.length ? openCache ? <div className="relative">
            {components.map((child, childIndex) => {
        const currNav = navs[childIndex] || {};
        const isActiveCache = currNav._activeCache;
        const isActive = childIndex === currTabNavIndex;
        const minHeight = currNav.minHeight;
        return isActiveCache ? <div key={childIndex} className={`${isActive ? '' : 'hide'}`} style={{
          minHeight
        }}>{child}</div> : isActive ? <div key={childIndex} style={{
          minHeight
        }}>{child}</div> : null;
      })}
          </div> : <div className="relative">
            {components.map((child, childIndex) => {
        const currNav = navs[childIndex] || {};
        const minHeight = currNav.minHeight;
        return childIndex === currTabNavIndex ? <div key={childIndex} style={{
          minHeight
        }}>{child}</div> : null;
      })}
          </div> : <div className="text-center mv-3 f14">请添加标签导航子组件</div>}
    </div>;
};

const SpaceLayout__264 = ({
  id: id,
  children: children,
  config: config
}) => {
  const {
    common,
    styles
  } = config;
  const {
    height,
    cloneElementId
  } = common;
  const {
    background,
    position,
    top
  } = styles;
  const [elemHeight, setElemHeight] = useState(height);
  useEffect__264(() => {
    if (!cloneElementId) return;
    const elem = document.getElementById(cloneElementId);
    if (!elem) return;

    const updateHeight = () => {
      const dynamicHeight = elem.getBoundingClientRect().height;
      if (dynamicHeight > 0 && elemHeight !== dynamicHeight) setElemHeight(dynamicHeight);
    };

    if (elem.tagName === 'IMG') {
      elem.complete ? updateHeight() : elem.onload = () => {
        updateHeight();
      };
    } else {
      const imgElems = elem.querySelectorAll('img');
      if (!imgElems.length) return updateHeight();

      for (let i = 0, n = imgElems.length; i < n; i++) {
        const imgElem = imgElems[i];
        imgElem.complete ? updateHeight() : imgElem.onload = () => {
          updateHeight();
        };
      }
    }
  }, []);
  const style = {
    position,
    top,
    height: elemHeight
  };
  style.background = background.image ? `url(${background.image}) left top / ${background.size} ${background.repeat}` : background.color;
  return <div id={id} style={style}>{children || null}</div>;
};

const effectParam__266 = {
  scrollUpDisAppear: {
    top: 500
  },
  scrollUpShow: {
    top: 500
  }
};
const customStyle__266 = {
  width: 108,
  height: 22,
  aspectRatio: "108:22",
  bgImg: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/d8f0ade877042263bc70093902ab20c2.png",
  bgColor: "transparent",
  top: 100,
  zIndex: 100,
  hasGradient: false,
  gradientDeg: 90,
  bgColor2: "transparent"
};

const FixedBar__266 = ({
  children: children,
  position: position,
  customStyle: customStyle__266,
  effects: effects,
  effectParam: effectParam__266
}) => {
  const fixBar = useRef__266();
  const [fixStyle, setFixStyle] = useState__266({});
  useEffect__266(() => {
    const basicFixStyle = {
      position: 'fixed',
      height: 70,
      transition: 'transform 300ms ease-in',
      zIndex: customStyle__266.zIndex
    };
    const positionStyle = {
      topStyle: {
        top: 0,
        width: '100%'
      },
      bottomStyle: {
        bottom: 0,
        width: '100%'
      },
      leftStyle: {
        left: 0,
        top: '60%',
        width: 70
      },
      rightStyle: {
        right: 0,
        top: '60%',
        width: 70
      }
    };
    let widthRadio, heightRadio;

    if (customStyle__266.aspectRatio) {
      const radios = customStyle__266.aspectRatio.split(':');
      widthRadio = Number(radios[0]);
      heightRadio = Number(radios[1]);
    }

    switch (position) {
      case 'top':
        Object.assign(basicFixStyle, positionStyle.topStyle, customStyle__266);

        if (widthRadio) {
          basicFixStyle.height = window.innerWidth / widthRadio * heightRadio;
        }

        break;

      case 'bottom':
        Object.assign(basicFixStyle, positionStyle.bottomStyle, customStyle__266);

        if (widthRadio) {
          basicFixStyle.height = window.innerWidth / widthRadio * heightRadio;
        }

        break;

      case 'left':
        Object.assign(basicFixStyle, positionStyle.leftStyle, customStyle__266);
        break;

      case 'right':
        Object.assign(basicFixStyle, positionStyle.rightStyle, customStyle__266);
        break;

      default:
        break;
    }

    switch (effects) {
      case 'scrollUpDisAppear':
        window.addEventListener('scroll', () => {
          if (!fixBar.current) return;
          const param = effectParam__266[effects];

          if (document.body.scrollTop >= param.top || document.documentElement.scrollTop >= param.top) {
            fixBar.current.style.transform = `translateY(${basicFixStyle.height.toString().indexOf('px') > -1 ? basicFixStyle.height : basicFixStyle.height + 'px'})`;
          } else {
            fixBar.current.style.transform = '';
          }
        });
        break;

      case 'scrollUpShow':
        basicFixStyle.transform = `translateY(${basicFixStyle.height.toString().indexOf('px') > -1 ? basicFixStyle.height : basicFixStyle.height + 'px'})`;
        window.addEventListener('scroll', () => {
          if (!fixBar.current) return;
          const param = effectParam__266[effects];

          if (document.body.scrollTop >= param.top || document.documentElement.scrollTop >= param.top) {
            fixBar.current.style.transform = '';
          } else {
            fixBar.current.style.transform = `translateY(${basicFixStyle.height.toString().indexOf('px') > -1 ? basicFixStyle.height : basicFixStyle.height + 'px'})`;
          }
        });
        break;

      default:
        break;
    }

    setFixStyle(basicFixStyle);
  }, []);
  return <div style={fixStyle} ref={fixBar}>{children}</div>;
};

const productId__267 = {
  androidId: "5cab0479dfaf350bc750f4b4",
  iosId: "fm.qingting.specailactivity.12month.98yuan1"
};
const options__267 = {
  limitJudge: true,
  isBenefit: false,
  hasResultPage: true,
  popLog: true,
  content: ""
};
const btnStyle__267 = {
  unit: "px",
  isAbsolute: true,
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  color: "#fff",
  fontSize: 16,
  hasAnimation: false,
  bgImg: "",
  bgColor: "transparent",
  width: 350,
  height: 60
};

const BuyButton__267 = ({
  id: id,
  nodeType: nodeType,
  nodeId: nodeId,
  productId: productId__267,
  btnStyle: btnStyle__267,
  options: options__267
}) => {
  const [deviceId, setDeviceId] = useState('');
  const [token, setToken] = useState('');
  const [showSpin, setShowSpin] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [resultData, setResultData] = useState({});
  const buttonRef = useRef();
  const [exposed, setExposed] = React.useState(false);
  const resultParams = {};
  useEffect__267(() => {
    qt.getDevice().then(res => {
      setDeviceId(res.deviceId);
      return qt.getAccessToken();
    }).then(token => setToken(token));
  }, []);
  useEffect__267(() => {
    if (!options__267.popLog) return;
    if (exposed) return;
    window.addEventListener('scroll', popTrack);
  }, [exposed]);

  const judgeLimit = user_id => {
    return axios.get(`https://pay${process.env.SITE_ENV === 'stg' ? '.staging' : ''}.qingting.fm/cashdesk/v1/vip/reached_limit`, {
      params: {
        user_id
      }
    }).then(data => data.data);
  };

  const checkUsesrBenefit = id => {
    return axios.get(`https://webapi${process.env.SITE_ENV === 'stg' ? '.staging' : ''}.qingting.fm/material/frontend/423/check-user-benefit`, {
      params: {
        user_id: id,
        device_id: deviceId,
        access_token: token
      },
      withCredentials: true
    }).then(data => data.data);
  };

  const getResultData = ({
    userId,
    deviceId,
    phoneType,
    itemId,
    orderId,
    systemInfo = {}
  }) => {
    const params = {
      user_id: userId,
      device_id: deviceId,
      phone_type: phoneType,
      item_id: itemId,
      order_id: orderId
    };
    Object.assign(params, systemInfo);
    return axios.get(`https://pay${process.env.SITE_ENV === 'stg' ? '.staging' : ''}.qingting.fm/cashdesk/v1/vip/result`, {
      params
    }).then(data => data.data);
  };

  const purchase = async () => {
    qt.monitor.bmsActionEvent({
      eventId: 'buyButton_click',
      nodeId,
      nodeType,
      data: {
        name: id
      }
    });
    const userId = await qt.getUserId();

    if (userId) {
      resultParams.userId = userId;
      let judgeLimitData, checkBenefitData;
      if (options__267.limitJudge) judgeLimitData = await judgeLimit(userId);

      if (judgeLimitData && judgeLimitData.data && judgeLimitData.data.reached_limit) {
        Toast.info({
          content: judgeLimitData.data.toast.substring(0, 19) + '<br />' + judgeLimitData.data.toast.substring(19) || '为保护您的权益，今日购买额度已用完，请<br />明日再尝试购买',
          duration: 3000
        });
        return;
      }

      if (options__267.isBenefit) checkBenefitData = await checkUsesrBenefit(userId);

      if (checkBenefitData && checkBenefitData.data && checkBenefitData.data.has_benefit) {
        Toast.info({
          content: '您已购买过特惠商品！',
          duration: 3000
        });
        return;
      }

      goPurchase();
    } else {
      qt.login({
        env: process.env.SITE_ENV === 'stg' ? 'staging' : 'production'
      });
    }
  };

  const goPurchase = () => {
    let param = {};

    if (qt.env.inIosApp) {
      param = {
        productId: productId__267.iosId
      };
    } else {
      param = {
        itemId: productId__267.androidId
      };
    }

    let partner = qs.parse(window.location.search.slice(1)).partner;
    if (partner) param.partner = partner;
    setShowSpin(true);
    qt.purchase(param).then(async (res = {}) => {
      resultParams.orderId = res.orderId;
      setShowSpin(false);

      if (options__267.hasResultPage && res.orderId) {
        if (qt.env.inIosApp) resultParams.systemInfo = await qt.getSystemInfo();
        resultParams.deviceId = deviceId;
        resultParams.phoneType = qt.env.inIosApp ? 'iOS' : 'android';
        resultParams.itemId = productId__267.androidId;
        let data = await getResultData(resultParams);
        setResultData(data.data);
        setShowResult(true);
      }

      ;
    }).catch(e => {
      setShowSpin(false);
      Toast.info({
        content: e.message,
        duration: 3000
      });
    });
  };

  const getScrollTop = () => {
    return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
  };

  const popTrack = () => {
    if (!buttonRef.current) return;
    const pos = buttonRef.current.getBoundingClientRect();
    const scrollTop = getScrollTop();
    const offsetTop = scrollTop + pos.top;
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;
    const isExposeTop = scrollTop >= offsetTop + pos.height / 2 - windowHeight;
    const isExposeBottom = scrollTop < offsetTop + pos.height / 2;

    if (isExposeTop && isExposeBottom) {
      qt.monitor.bmsExpose({
        eventId: 'buyButton_view',
        nodeId,
        nodeType
      });
      setExposed(true);
      setTimeout(() => setExposed(false), 10000);
      window.removeEventListener('scroll', popTrack);
    }
  };

  useEffect__267(() => {
    if (showResult) {
      const div = document.getElementById(nodeId) || document.createElement('div');
      div.setAttribute('id', nodeId);
      document.body.appendChild(div);
      ReactDOM.render(<ResultPop env={process.env.SITE_ENV} resultData={resultData} onClose={() => setShowResult(false)}></ResultPop>, div);
    } else {
      const div = document.getElementById(nodeId);
      if (div) document.body.removeChild(div);
    }
  }, [showResult]);
  const spinStyle = {
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 100,
    height: 50,
    width: 50,
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    borderRadius: 8,
    boxSizing: 'border-box',
    padding: 10
  };
  return <>
    <style>{`
      @keyframes buy-button-breath {
        0% { transform: scale(0.9); }  
        50% { transform: scale(1); }  
        100% { transform: scale(0.9); }
      }
    `}</style>
    {showSpin ? <div style={spinStyle}><ReactLoading type={'spokes'} width={'100%'} height={'100%'} /></div> : null}
    <div style={btnStyle__267} onClick={() => purchase()} ref={buttonRef}>{options__267.content}</div>
  </>;
};

const popConfig = {
  type: "link",
  src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/e2a3126c07db609de8546b28d0f94b7d.png",
  cancelText: "残忍离开",
  okText: "再看看",
  code: "",
  link: "https://sss.qingting.fm/vips/members/v2/?source=wanliu_supervip_activity_91",
  toast: "",
  anchor: "",
  frequency: "once",
  productIds: "5eec93f4f84f475b9763d043",
  shieldRule: "ios-rules",
  exposeLog: true,
  clickLog: true
};

const LeavePop = ({
  config: config,
  nodeType: nodeType,
  nodeId: nodeId
}) => {
  const {
    origin,
    pathname,
    search
  } = window.location;
  const [userInfo, setUserInfo] = useState();
  const [login, setLogin] = useState(false);

  const getUserInfo = async () => {
    const userId = await qt.getUserId();
    let token;

    if (userId) {
      token = await qt.getAccessToken();
    }

    let deviceInfo;

    if (qt.env.inApp) {
      deviceInfo = await qt.getDevice();
    } else {
      deviceInfo = {
        deviceId: localStorage.getItem('weblogDeviceId') || 'web'
      };
    }

    return {
      userId,
      token,
      deviceInfo
    };
  };

  const checkByRule = async () => {
    if (config.shieldRule === 'ios' && qt.env.inIosApp) {
      return false;
    } else if (config.shieldRule === 'ios-rules' && qt.env.inIosApp) {
      const systemInfo = await qt.getSystemInfo();

      if (systemInfo.portaltype && systemInfo.portaltype.toLowerCase() === 'ios' && (systemInfo.device && systemInfo.device.indexOf('iPad(') > 0 || systemInfo.carrier && systemInfo.carrier !== 'telcom' && systemInfo.carrier !== 'unicom' && systemInfo.carrier !== 'mobile')) {
        return false;
      }
    }

    return true;
  };

  const checkPurchaseStatus = async () => {
    const data = await axios.get(`https://webapi${process.env.SITE_ENV === 'stg' ? '.staging' : ''}.qingting.fm/material/payment/check-purchase-status`, {
      params: {
        user_id: userInfo.userId,
        item_id: config.productIds
      }
    });
    const res = data.data;

    if (res.data && res.data.purchased_in_7days) {
      return false;
    }

    return true;
  };

  const checkByFrequency = () => {
    let userPop, devicePop;

    if (config.frequency === 'once') {
      if (userInfo.userId) {
        userPop = localStorage.getItem(userInfo.userId);
      }

      if (userInfo.deviceInfo) {
        devicePop = localStorage.getItem(userInfo.deviceInfo.deviceId);
      }

      if (userPop && JSON.parse(userPop).leavePop && devicePop && JSON.parse(devicePop).leavePop || !userInfo.userId && devicePop && JSON.parse(devicePop).leavePop) {
        return false;
      }
    }

    return true;
  };

  const cachePopInfo = userInfo => {
    if (userInfo.userId) {
      let userPop = localStorage.getItem(userInfo.userId); // 防止影响已存数据

      if (userPop) {
        let userMsg = JSON.parse(userPop);
        userMsg.leavePop = true;
        localStorage.setItem(userInfo.userId, JSON.stringify(userMsg));
      } else {
        localStorage.setItem(userInfo.userId, JSON.stringify({
          leavePop: true
        }));
      }
    }

    if (userInfo.deviceInfo && userInfo.deviceInfo.deviceId) {
      let devicePop = localStorage.getItem(userInfo.deviceInfo.deviceId);

      if (devicePop) {
        let deviceMsg = JSON.parse(devicePop);
        deviceMsg.leavePop = true;
        localStorage.setItem(userInfo.deviceInfo.deviceId, JSON.stringify(deviceMsg));
      } else {
        localStorage.setItem(userInfo.deviceInfo.deviceId, JSON.stringify({
          leavePop: true
        }));
      }
    }
  };

  const receiveCoupon = ({
    userId,
    useCode,
    deviceId,
    token
  }) => {
    return axios.get(`https://webapi${process.env.SITE_ENV === 'stg' ? '.staging' : ''}.qingting.fm/material/frontend/423/exchange-coupon`, {
      params: {
        user_id: userId,
        use_code: useCode,
        device_id: deviceId || '',
        access_token: token
      },
      withCredentials: true
    }).then(data => {
      return data.data;
    });
  };

  const operate = async () => {
    if (config.type === 'coupon') {
      let user = await getUserInfo();
      cachePopInfo(user);

      if (!user.userId) {
        qt.login().then(() => setLogin(true));
        return;
      }

      if (config.clickLog) {
        qt.monitor.bmsActionEvent({
          eventId: 'leavePop_coupons_click',
          nodeId,
          nodeType
        });
      }

      receiveCoupon({
        userId: user.userId,
        useCode: config.code,
        deviceId: user.deviceInfo && user.deviceInfo.deviceId,
        token: user.token
      }).then(data => {
        if (data) {
          if (data.errorno === 0) {
            Toast.info({
              content: config.toast,
              duration: 2000
            });

            if (config.anchor) {
              window.location.href = origin + pathname + search + `#${config.anchor}`;
            }

            Modal.close();
          } else if (data.errorno === 50001) {
            Toast.info({
              content: '系统繁忙, 请稍后再试',
              duration: 2000
            });
            Modal.close();
          } else {
            Toast.info({
              content: data.errormsg || '领取失败',
              duration: 2000
            });
            Modal.close();
          }
        } else {
          Toast.info({
            content: '领取失败',
            duration: 2000
          });
          Modal.close();
        }
      }).catch(e => {
        Toast.info({
          content: e && e.response && e.response.errormsg || '领取失败',
          duration: 2000
        });
        Modal.close();
      });
    } else {
      if (config.clickLog) {
        qt.monitor.bmsActionEvent({
          eventId: 'leavePop_jump_click',
          nodeId,
          nodeType
        });
      }

      if (config.link) {
        window.location.href = config.link;
      } else if (config.anchor) {
        window.location.href = origin + pathname + search + `#${config.anchor}`;
      }
    }
  };

  const showPop = async () => {
    const ruleRes = await checkByRule();
    const purchaseRes = await checkPurchaseStatus();

    if (ruleRes && purchaseRes && checkByFrequency()) {
      if (config.exposeLog) {
        qt.monitor.bmsExpose({
          eventId: 'leavePop_view',
          nodeId,
          nodeType
        });
      }

      Modal.show({
        showCloseIcon: true,
        jsxContent: <img src={config.src} style={{
          width: '100%'
        }} onClick={operate} alt='' />,
        footer: <div className="btn-container">
          <div className="normal-btn cancel" onClick={() => {
            qt.monitor.bmsActionEvent({
              eventId: 'leavePop_exit_click',
              nodeId,
              nodeType
            });
            qt.route.backTo();
          }}>{config.cancelText}</div>
          <div className="normal-btn ok" onClick={operate}>{config.okText}</div>
        </div>,
        onCancel: () => {
          qt.monitor.bmsActionEvent({
            eventId: 'leavePop_exit_click',
            nodeId,
            nodeType
          });
        }
      });
      cachePopInfo(userInfo);
    } else {
      qt.route.backTo();
    }
  };

  useEffect__268(() => {
    getUserInfo().then(data => setUserInfo(data));
  }, []);
  useEffect__268(() => {
    if (userInfo) {
      qt.backPressLinstener({
        onBack: showPop
      });
    }
  }, [userInfo]);
  useEffect__268(() => {
    if (login) {
      getUserInfo().then(data => setUserInfo(data));
      operate();
    }
  }, [login]);
  return <div></div>;
};

export default (({}) => {
  const basicConfig = {
    title: "超级会员买1得7",
    shareTitle: "恭喜你被选中",
    shareImg: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/2835a3efe5aef2988d11a8f9ba12a718.png",
    shareSubTitle: "超级会员买1得7 限时抢购中>",
    shareLink: "",
    isHiddenAppShare: false
  };
  const containerConfig = {
    startTime: "2020-08-27 22:08:59",
    endTime: "2020-09-03 23:59:59",
    bgc: "#c00001",
    themeColor: "#333",
    style: {},
    endTitle: "页面已过期~",
    beforeTitle: "活动还未开始，敬请期待~",
    bgimg: "",
    padding: "",
    margin: ""
  };
  const timeController = {
    startTime: "2020-08-27 11:33:00",
    endTime: "2020-08-31 23:59:59",
    dynamic: true,
    duration: 10
  };
  const envController = {
    env: "all",
    operation: "allow",
    version: "8.8.0",
    comparison: "isGreaterOrEqual",
    versionEnv: "inIosApp",
    versionOperation: "deny"
  };
  const singleImage = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/51f6e17940b051b12096fb1eb96c52ef.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const basicConfig__4 = {
    position: "absolute",
    coverImg: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/d85500bd36f828d67cfe1cf91979e61f.png",
    unit: "px",
    coverImgWidth: 60,
    coverImgHeight: null,
    coverImgTop: 38,
    coverImgRight: 0,
    coverImgBottom: null,
    coverImgLeft: null,
    zIndex: "9",
    ruleContent: "<p>活动规则:</p><p>一、活动时间</p><p>2020年8月28日00:00:00-2020年9月10日23:59:59</p><p>二、活动特惠</p><p>1.预热期(8.28-8.31):年卡买1得2</p><p>预热期可享蜻蜓FM超级会员年卡98元,并可从活动页展示的赠礼中任选一个赠礼进行领取，赠礼领取有效期7天;</p><p>2.正式期(9.1-9.3):年卡最高买1得N</p><p>正式期可享蜻蜓FM超级会员年卡98元,并可领取活动页展示的所有赠礼，赠礼领取有效期7天;&nbsp;&nbsp;&nbsp;</p><p>3.返场期(9.4-9.10):联合会员专场,蜻蜓FM年卡买1得2,具体赠礼以活动页面展示为准;&nbsp;&nbsp;</p><p>三、购买规则</p><p>1.同一账户每日仅限购买1次会员商品(包括蜻蜓FM超级会员年卡/半年卡/季卡/月卡等产品).</p><p>2.活动中的品牌赠礼库存有限,先到先得.当有某一品牌库存领取完毕,将在活动页面对该品牌赠礼做下架处理，在此之后购买会员将不享该权益，请提前核对好活动页赠礼详情后进行购买.</p><p>3.超级会员服务为虚拟产品，一经售卖不做退换.</p><p>四、赠礼说明</p><p>1.一年内同一手机号码在蜻蜓FM仅可充值共2次京东PLUS会员，京东PLUS年卡指京东PLUS京典卡，不包含爱奇艺、腾讯等异业权益，京东PLUS年卡所含权益及规则以京东官方公布为准，本次活动暂不支持海外手机号领取京东PLUS会员权益。且由于京东PLUS会员开通有综合评分要求，因此可能存在极少异常账号无法开通成功的情况，具体可咨询京东客服。</p><p>2.活动赠送的品牌会员所含权益及规则以对应APP官方公布为准；</p><p>3.获取赠礼应遵循蜻蜓FM《用户协议》、《超级会员服务协议》，不得通过不正当手段获取赠礼进行盈利，如被发现违反相关协议规定，蜻蜓FM及赠礼合作方任意一方均有权单独按照其平台的用户协议规定进行处理；</p><p>4.领取赠礼时，务必确认账号登录正确，避免充值到错误账号（温馨提示：用户如因输入错误账号导致赠礼领取失败，均不予以赔偿）</p><p>5.活动赠礼为蜻蜓FM用户购买超级会员商品后的加权益,领取有效期为7天，赠礼权益需要您在有效期内到赠礼页面绑定充值权益的手机号账户,请您注意及时领取，超出领取时间将视为自动放弃未领取权益,后续也将不再进行赠礼权益的领取支持；</p><p>五、抽奖规则</p><p>1.抽奖时间：8月28日00:00:00-9月3日23:59:59</p><p>2.抽奖机会：</p><p>在8月28日00:00:00-9月3日符合以下条件的用户可获得抽奖机会:</p><p>①有效会员根据对应会员等级可获得抽奖机会:</p><p>V1~V2等级获得1次抽奖机会;</p><p>V3~V4等级获得2次抽奖机会;</p><p>V5等级获得3次抽奖机会;</p><p>②在活动期间,每次在蜻蜓FM官方渠道购买超级会员年卡均可获得3次抽奖机会;</p><p>③在活动期间,每次在蜻蜓FM官方渠道购买购买超级会员月卡/季卡/半年卡，均可获得2次抽奖机会;</p><p>④在活动期间,每次分享活动页可获得2次抽奖机会,每个用户每天最多分享2次;</p><p>3.抽奖奖品:</p><p>①抽奖获得积分奖品,将在24小时内到账,可前往“蜻蜓FM手机APP-个人中心-积分商城”查看并使用;</p><p>②抽奖获得优惠券奖品,将在24小时内到账,可前往“蜻蜓FM手机APP-个人中心-优惠券”查看并使用;</p><p>③抽奖获得实物奖品(万元金卡、 HUAWEI P40 Pro、Beats X 蓝牙无线、100元京东卡、小米手环、早教机、晓年鉴周边)将在活动结束后30个工作日内发放,请在活动期内按照要求填写真实的个人信息用于申报个税，否则视为放弃</p><p>④若存在刷奖等故意或者恶意违规的行为，一经核实，该用户将取消中奖资格。</p><p>六、会员特权</p><p>开通成为蜻蜓FM超级会员的用户，将获得更多新品内容免费畅听、福利社专享福利等升级权益；权益仅限于蜻蜓FM的APP上使用.</p><p>七、其他问题</p><p>如在使用蜻蜓FM超级会员过程中有任何咨询或疑问,请通过“蜻蜓FM手机APP-个人中心-帮助与反馈-联系客服”联系客服进行咨询;</p>",
    ruleContentHeight: 350,
    ruleContentMaxHeight: 300,
    ruleFontSize: 13,
    lineHeight: "1.5"
  };
  const imageArchor = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/109803e1c7ed6abb0332001072dd1659.png",
    link: "",
    linkInApp: "https://sss.qingting.fm/vips/members/v2/presents.html",
    linkOutApp: "https://sss.qingting.fm/vips/members/v2/presents.html",
    imageStyle: {
      width: 61,
      height: null
    },
    style: {
      position: "absolute",
      top: 1.2,
      bottom: null,
      left: null,
      right: 0.001,
      type: "rem"
    },
    openNewWebview: false
  };
  const singleImage__6 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/8266afc98ed4f2c55d4b9415147b29ed.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__6 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const imageArchor__7 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/0fe3fa977f1e5e13d688398e7e6161e3.png",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    imageStyle: {
      width: 280,
      height: null
    },
    style: {
      position: "absolute",
      top: 1.7,
      bottom: null,
      left: 0.2,
      right: null,
      type: "rem"
    },
    openNewWebview: false
  };
  const row = "3";
  const picConfig = {
    data: [{
      pic: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/586c2acecae131956a4c6bab1ff648df.png",
      pop: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/ca2a27357fdcb064a4afb049b11ae7ec.png",
      title: "京东",
      desc: "年卡\xA5198"
    }, {
      pic: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/577925e1d153e50889f27eedda0d249f.png",
      pop: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/50ba1442ffff33c229a84ecddba51cba.png",
      title: "网易云音乐",
      desc: "年卡\xA5216"
    }, {
      pic: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/1d8b1096e2106254fe879b77e233343a.png",
      pop: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/d95733c18f6305abbb6c3bca2f592966.png",
      title: "Keep",
      desc: "年卡\xA5248"
    }, {
      pic: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/74559ef4fab048014b510c4c69eb1457.png",
      pop: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/6102b66757e8b6e473ffcb61f30ff193.png",
      title: "去哪儿",
      desc: "年卡\xA569"
    }, {
      pic: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/dec308bfe97f874c0d52fb47147251dd.png",
      pop: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/7f4b591d353aa4c64ea68922cbbf3b82.png",
      title: "大地影院",
      desc: "年卡\xA550"
    }, {
      pic: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/d432e1186f5ed4ada2235fc670defda9.png",
      pop: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/5ca74a13a5491787329750276f3ae681.png",
      title: "快看漫画",
      desc: "年卡\xA5188"
    }],
    titleColor: "#ffffff",
    titleFontSize: 12,
    descColor: "#ffffff",
    descFontSize: 10,
    popLoop: true
  };
  const cornerConfig = {
    pic: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/f911722541ad851cfff87ee27eeb17d5.png",
    textAlign: "right",
    unit1: "rem",
    width: 1.4,
    height: "",
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0.06
  };
  const wholeConfig = {
    position: "absolute",
    unit2: "rem",
    marginTop: 1.7,
    marginBottom: 0,
    marginLeft: 0.16,
    marginRight: 0.16,
    zIndex: 0
  };
  const baseLayoutConfig = {
    commonStyle: {
      textAlign: "center",
      height: 55,
      overflow: "hidden",
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "rem"
    },
    positionStyle: {
      position: "absolute",
      top: null,
      bottom: 0.4,
      left: 0.4,
      right: 0.4
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const style = {
    backgroundImage: `url(${btnStyle.bgImg})`,
    backgroundColor: btnStyle.bgColor,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    color: btnStyle.color,
    fontSize: btnStyle.fontSize + btnStyle.unit,
    margin: '0 auto',
    width: btnStyle.width + btnStyle.unit,
    height: btnStyle.height + btnStyle.unit,
    lineHeight: btnStyle.height + btnStyle.unit,
    borderRadius: btnStyle.height / 2 + btnStyle.unit,
    textAlign: 'center',
    position: btnStyle.isAbsolute ? 'absolute' : 'relative',
    animation: btnStyle.hasAnimation ? `buy-button-breath 1s infinite` : null
  };
  const abStyle = {
    top: btnStyle.top + btnStyle.unit,
    left: btnStyle.left + btnStyle.unit,
    right: btnStyle.right + btnStyle.unit,
    bottom: btnStyle.bottom + btnStyle.unit
  };
  const reStyle = {
    marginTop: btnStyle.top + btnStyle.unit,
    marginBottom: btnStyle.bottom + btnStyle.unit,
    marginLeft: btnStyle.left + btnStyle.unit,
    marginRight: btnStyle.right + btnStyle.unit
  };
  const singleImage__11 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/3d34d665cc79f447e74f37b1fb46e208.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__11 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const basicConfig__12 = {
    endTime: "2020-09-01 00:00:00",
    title: "距开始：",
    isCustomizeEndTitle: false,
    customizeEndTitle: "活动结束啦",
    fontColor: "#9e43d7",
    bgColor: "transparent",
    borderRadius: "",
    unit: "rem",
    paddingTop: "",
    paddingBottom: "",
    paddingRight: "",
    paddingLeft: "",
    fontWeight: 400,
    fontSize: "14px",
    position: "absolute",
    top: 0.9,
    bottom: "",
    left: 2,
    right: "",
    display: "inline-block"
  };
  const basicConfig__13 = {
    pushType: "appPush",
    taskIds: "94",
    modalMessage: "",
    isNeedLogin: true,
    startTime: null,
    endTime: null,
    unReserveImg: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/8946e1d46c1219c01d04b26188e1ac6f.jpg",
    reservedImg: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/539655d1736580071c4848d90891bc68.jpg",
    isStaging: false
  };
  const styleConfig = {
    unit: "%",
    imgWidth: 100,
    imgHeight: "",
    top: "",
    bottom: "",
    left: "",
    right: "",
    display: "block",
    position: "relative",
    zIndex: 1
  };
  const singleImage__14 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/5087987e4a2b031ac180d031cd362de9.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__14 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const baseLayoutConfig__15 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: "hidden",
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "%"
    },
    positionStyle: {
      position: "relative",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: 1.2,
      marginRight: 1.2,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: 1,
      paddingRight: 1
    }
  };
  const tabNavs = [{
    title: "京东",
    link: "",
    minHeight: null,
    default: false,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "transparent",
      activeColor: "transparent",
      position: "center"
    }
  }, {
    title: "网易云音乐",
    link: "",
    minHeight: "",
    default: false,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "",
      activeColor: "",
      position: ""
    }
  }, {
    title: "去哪儿",
    link: "",
    minHeight: "",
    default: false,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "",
      activeColor: "",
      position: ""
    }
  }, {
    title: "Keep",
    link: "",
    minHeight: "",
    default: false,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "",
      activeColor: "",
      position: ""
    }
  }, {
    title: "大地影院",
    link: "",
    minHeight: "",
    default: false,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "",
      activeColor: "",
      position: ""
    }
  }, {
    title: "快看漫画",
    link: "",
    minHeight: "",
    default: false,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "",
      activeColor: "",
      position: ""
    }
  }];
  const tabNavsConfig = {
    showTitle: true,
    fontSize: 13,
    color: "#ffffff",
    backgroundColor: "transparent",
    backgroundImage: "",
    openWrap: true,
    lineCount: 3,
    openScroll: false,
    height: 38,
    itemWidth: 100,
    itemHeight: 26,
    marginRight: 6,
    marginBottom: 5,
    borderRadius: 12,
    open: false,
    top: 0,
    openCache: false,
    openLog: true,
    lockMinusListener: false,
    active: {
      fontSize: 13,
      color: "#4711a7",
      fontWeight: 700,
      backgroundColor: "#ffffff",
      backgroundImage: "",
      borderWidth: 1,
      borderColor: "#ffffff",
      line: {
        paddingBottom: 5,
        borderBottomWidth: 2,
        borderBottomStyle: "solid",
        borderBottomColor: "transparent"
      }
    },
    inactive: {
      backgroundColor: "transparent",
      backgroundImage: "",
      borderWidth: 1,
      borderColor: "#ffffff"
    }
  };
  const singleImage__17 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/ca2a27357fdcb064a4afb049b11ae7ec.png",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__17 = {
    marginTop: 0,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__18 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/3cd9102c85536ac132dcb735c0eb548c.png",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__18 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__19 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/02af41ffe6f5ef6e6057b80f5ba6cbf2.png",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__19 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__20 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/d95733c18f6305abbb6c3bca2f592966.png",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__20 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__21 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/280ad6fa3de8ed7d07798a90a45b9e4b.png",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__21 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__22 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/ccaf84cde915e4d71bb0858b131a6a55.png",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__22 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const envController__23 = {
    env: "inIosApp",
    operation: "allow",
    version: "8.8.0",
    comparison: "isGreaterOrEqual",
    versionEnv: "inIosApp",
    versionOperation: "allow"
  };
  const singleImage__24 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/0525f0fc580350fde32c997b767c614d.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__24 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__25 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/e9b5e39710999ee9c51982317193af2f.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__25 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__26 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/a3f3c775b3893ca6c520d588818ca047.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__26 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const config = {
    activity_id: 1027,
    canSetShare: false,
    shareAddChance: false,
    pageTitleCanModify: false,
    showTop: false,
    showBottom: false,
    serviceUrl: "",
    defaultStyle: {
      pageBg: "",
      topImg: "",
      bottomImg: "",
      drawBackImg: "",
      prizeBorderColor: "",
      prizeNameColor: "",
      prizeDefaultColor: "",
      prizeSelectColor: "",
      drawBtnImg: "",
      ruleImg: "",
      myPrizeImg: ""
    },
    customeStyle: {
      prizeDefaultImg: "",
      prizeSelectImg: "",
      replaceCarousel: ""
    },
    locationStyle: {
      top: 0,
      bottom: 0,
      spacing: 24,
      type: "px"
    }
  };
  const basicConfig__28 = {
    imgUrl: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/a30506f154a9550fdd664fe9f936fed9.jpg",
    showOutApp: false,
    style: {
      position: "relative",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      width: "100%",
      height: "auto",
      zIndex: 1
    },
    shareConfig: {
      title: "恭喜你被选中!",
      desc: "超级会员买1得2 限时抢购中>>",
      img: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/d89e83e4b6487b26290bb6f4f7410ed2.png",
      link: ""
    }
  };
  const singleImage__29 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/f5c4ea79360aa61b15fcee4a98a724a7.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__29 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__30 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/4d80c1a083f90d7d0354a6eca83f16b8.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/297486",
    linkOutApp: "https://m.qingting.fm/vchannels/297486",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__30 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__31 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/c7fa87be1510397cadb82b00985e65cb.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/367198",
    linkOutApp: "https://m.qingting.fm/vchannels/367198",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__31 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__32 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/d35d3a3f118d23966c4f74edfdf1505f.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/145302",
    linkOutApp: "https://m.qingting.fm/vchannels/145302",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__32 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__33 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/cf8937464e51b193b8c4d3038783667d.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__33 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const baseLayoutConfig__34 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "#ffadbf",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "%"
    },
    positionStyle: {
      position: "relative",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: 4.2,
      marginRight: 4.2,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: 4,
      paddingRight: 4
    }
  };
  const tabNavs__35 = [{
    title: "神作上新",
    link: "",
    minHeight: null,
    default: true,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "transparent",
      activeColor: "transparent",
      position: "center"
    }
  }, {
    title: "全网上新",
    link: "",
    minHeight: null,
    default: false,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "",
      activeColor: "",
      position: ""
    }
  }, {
    title: "精品爆更",
    link: "",
    minHeight: null,
    default: false,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "",
      activeColor: "",
      position: ""
    }
  }, {
    title: "重磅精选",
    link: "",
    minHeight: null,
    default: false,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "",
      activeColor: "",
      position: ""
    }
  }];
  const tabNavsConfig__35 = {
    showTitle: true,
    fontSize: 13,
    color: "#c51332",
    backgroundColor: "transparent",
    backgroundImage: "",
    openWrap: true,
    lineCount: 4,
    openScroll: false,
    height: 30,
    itemWidth: 100,
    itemHeight: 22,
    marginRight: 10,
    marginBottom: 0,
    borderRadius: 12,
    open: false,
    top: 0,
    openCache: false,
    openLog: true,
    lockMinusListener: false,
    active: {
      fontSize: 13,
      color: "#fffbfb",
      fontWeight: 700,
      backgroundColor: "#c51332",
      backgroundImage: "",
      borderWidth: 1,
      borderColor: "transparent",
      line: {
        paddingBottom: 5,
        borderBottomWidth: 2,
        borderBottomStyle: "solid",
        borderBottomColor: "transparent"
      }
    },
    inactive: {
      backgroundColor: "#ffb1bf",
      backgroundImage: "",
      borderWidth: 1,
      borderColor: "#c51332"
    }
  };
  const baseLayoutConfig__36 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "px"
    },
    positionStyle: {
      position: "relative",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const layoutConfig = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__38 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/cea5adf44fdcf54cc2cc485e0559eb8b.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/371308",
    linkOutApp: "https://m.qingting.fm/vchannels/371308",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__38 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__39 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/0f9e0faaa8dfd0cdde5184ba6aabfcc8.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/373535",
    linkOutApp: "https://m.qingting.fm/vchannels/373535",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__39 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__40 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/8bac6da21bad529ee5bce7d23aa1f77e.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/348805",
    linkOutApp: "https://m.qingting.fm/vchannels/348805",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__40 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const layoutConfig__41 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__42 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/1b9dbfce81199c6676c36331a88e8336.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/372836",
    linkOutApp: "https://m.qingting.fm/vchannels/372836",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__42 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__43 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/8c8d691913ff0e091a1ac29bdfdb9868.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/196022",
    linkOutApp: "https://m.qingting.fm/vchannels/196022",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__43 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__44 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/630d31b3bff571aab3b07d07f4924204.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/372089",
    linkOutApp: "https://m.qingting.fm/vchannels/372089",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__44 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__45 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/ed3a3e8d135b2aa1b8bb4cdfef4707c0.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/372837",
    linkOutApp: "https://m.qingting.fm/vchannels/372837",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__45 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const baseLayoutConfig__46 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "px"
    },
    positionStyle: {
      position: "relative",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const layoutConfig__47 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__48 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/b3aad2e62e1cceb36d5da93ccc9ac706.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/365706",
    linkOutApp: "https://m.qingting.fm/vchannels/365706",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__48 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__49 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/0d6cbacb84f018018b71bebe28bc5601.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/368072",
    linkOutApp: "https://m.qingting.fm/vchannels/368072",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__49 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__50 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/c3f6dfc92595a7feff658ce24bb1222d.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/356117",
    linkOutApp: "https://m.qingting.fm/vchannels/356117",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__50 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const layoutConfig__51 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__52 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/e1df9ac04059fd3108f1739d632557ec.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/321512",
    linkOutApp: "https://m.qingting.fm/vchannels/321512",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__52 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__53 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/88a812625ca2fe75f741b99604eef7e4.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/355264",
    linkOutApp: "https://m.qingting.fm/vchannels/355264",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__53 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__54 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/94fe246f9c68b81564657206cc639d8a.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/332299",
    linkOutApp: "https://m.qingting.fm/vchannels/332299",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__54 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const baseLayoutConfig__55 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "px"
    },
    positionStyle: {
      position: "relative",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const layoutConfig__56 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__57 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/7975c14d8e4a839a782ad148a66874d1.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/35242",
    linkOutApp: "https://m.qingting.fm/vchannels/35242",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__57 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__58 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/c52caefa256ffbdeb10b295146a3e9f4.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/205768",
    linkOutApp: "https://m.qingting.fm/vchannels/205768",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__58 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__59 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/86a6e78a769f696c5ff419d7eb243cf7.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/367745",
    linkOutApp: "https://m.qingting.fm/vchannels/367745",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__59 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const layoutConfig__60 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__61 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/2849469493495007bc24f52a9060771c.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/354487",
    linkOutApp: "https://m.qingting.fm/vchannels/354487",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__61 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__62 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/9483bd6bb1754248e80ad3aa1b6afa22.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/320747",
    linkOutApp: "https://m.qingting.fm/vchannels/320747",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__62 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__63 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/1183cd6d7d0b4941fe44802c19312bad.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/359961",
    linkOutApp: "https://m.qingting.fm/vchannels/359961",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__63 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__64 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/62c4d9782cb621e0eb14033425ba5f43.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__64 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const baseLayoutConfig__65 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "#fff6ee",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "%"
    },
    positionStyle: {
      position: "relative",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: 4.2,
      marginRight: 4.2,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: 4,
      paddingRight: 4
    }
  };
  const tabNavs__66 = [{
    title: "爆款小说",
    link: "",
    minHeight: null,
    default: true,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "transparent",
      activeColor: "transparent",
      position: "center"
    }
  }, {
    title: "必听爽文",
    link: "",
    minHeight: null,
    default: false,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "",
      activeColor: "",
      position: ""
    }
  }, {
    title: "出版畅销",
    link: "",
    minHeight: null,
    default: false,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "",
      activeColor: "",
      position: ""
    }
  }, {
    title: "心动言情",
    link: "",
    minHeight: null,
    default: false,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "",
      activeColor: "",
      position: ""
    }
  }];
  const tabNavsConfig__66 = {
    showTitle: true,
    fontSize: 13,
    color: "#c51332",
    backgroundColor: "transparent",
    backgroundImage: "",
    openWrap: true,
    lineCount: 4,
    openScroll: false,
    height: 30,
    itemWidth: 100,
    itemHeight: 22,
    marginRight: 10,
    marginBottom: 0,
    borderRadius: 12,
    open: false,
    top: 0,
    openCache: false,
    openLog: true,
    lockMinusListener: false,
    active: {
      fontSize: 13,
      color: "#fffbfb",
      fontWeight: 700,
      backgroundColor: "#c51332",
      backgroundImage: "",
      borderWidth: 1,
      borderColor: "transparent",
      line: {
        paddingBottom: 5,
        borderBottomWidth: 2,
        borderBottomStyle: "solid",
        borderBottomColor: "transparent"
      }
    },
    inactive: {
      backgroundColor: "transparent",
      backgroundImage: "",
      borderWidth: 1,
      borderColor: "#c51332"
    }
  };
  const baseLayoutConfig__67 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "px"
    },
    positionStyle: {
      position: "relative",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const singleImage__68 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/18d82321656f15b74745f48d91504feb.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/268108",
    linkOutApp: "https://m.qingting.fm/vchannels/268108",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__68 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__69 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/fc39e888e9063e9e54bf50083d6b9e16.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/323440",
    linkOutApp: "https://m.qingting.fm/vchannels/323440",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__69 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__70 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/0c0f83d10fede0b60e2299dc4e07f574.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/294908",
    linkOutApp: "https://m.qingting.fm/vchannels/294908",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__70 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__71 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/37395357b57630147fbf21683f417e7e.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/325019",
    linkOutApp: "https://m.qingting.fm/vchannels/325019",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__71 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const baseLayoutConfig__72 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "px"
    },
    positionStyle: {
      position: "relative",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const singleImage__73 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/8395220b0108db0e5a70cbdf7c470c77.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/366125",
    linkOutApp: "https://m.qingting.fm/vchannels/366125",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__73 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__74 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/aa7cd15d12207dbf520cd3b5c97e9e2e.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/368027",
    linkOutApp: "https://m.qingting.fm/vchannels/368027",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__74 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__75 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/b461ff77eb6d3f1ab49cbf48eabfb478.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/366131",
    linkOutApp: "https://m.qingting.fm/vchannels/366131",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__75 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__76 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/94ee3e8fc80b127c014b9ea200deabfd.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/369121",
    linkOutApp: "https://m.qingting.fm/vchannels/369121",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__76 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const baseLayoutConfig__77 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "px"
    },
    positionStyle: {
      position: "relative",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const singleImage__78 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/99e84f5867f58609ce619ce7651240ab.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/370585",
    linkOutApp: "https://m.qingting.fm/vchannels/370585",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__78 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__79 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/c229cabeeec3a0afc4eeaf524581d7bb.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/370579",
    linkOutApp: "https://m.qingting.fm/vchannels/370579",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__79 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__80 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/dd07d0aa7c6d8eae62ceb47c2e6cc148.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/363336",
    linkOutApp: "https://m.qingting.fm/vchannels/363336",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__80 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__81 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/e0ac2e0d63b2fc0305e98c65bfa8bfaf.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/363306",
    linkOutApp: "https://m.qingting.fm/vchannels/363306",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__81 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const baseLayoutConfig__82 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "px"
    },
    positionStyle: {
      position: "relative",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const singleImage__83 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/8a6ff599abb221ff5b36221938ea488e.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/338837",
    linkOutApp: "https://m.qingting.fm/vchannels/338837",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__83 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__84 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/191fecaab56b376f7641a5be93d6113c.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/319491",
    linkOutApp: "https://m.qingting.fm/vchannels/319491",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__84 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__85 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/1347954ccf9b8b13a5ff0307e1547ecd.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/365786",
    linkOutApp: "https://m.qingting.fm/vchannels/365786",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__85 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__86 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/8aa02eed9b0b18b1eba11edd5b6e37ee.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/368263",
    linkOutApp: "https://m.qingting.fm/vchannels/368263",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__86 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__87 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/5ed528fdb81b83c919266dd3a3f0198c.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__87 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const baseLayoutConfig__88 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "#ddf0ff",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "%"
    },
    positionStyle: {
      position: "relative",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: 4.2,
      marginRight: 4.2,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: 4,
      paddingRight: 4
    }
  };
  const tabNavs__89 = [{
    title: "畅销精选",
    link: "",
    minHeight: null,
    default: true,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "transparent",
      activeColor: "transparent",
      position: "center"
    }
  }, {
    title: "都市生活",
    link: "",
    minHeight: null,
    default: false,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "",
      activeColor: "",
      position: ""
    }
  }, {
    title: "热血玄幻",
    link: "",
    minHeight: null,
    default: false,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "",
      activeColor: "",
      position: ""
    }
  }, {
    title: "豪门种田",
    link: "",
    minHeight: null,
    default: false,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "",
      activeColor: "",
      position: ""
    }
  }];
  const tabNavsConfig__89 = {
    showTitle: true,
    fontSize: 13,
    color: "#4115a1",
    backgroundColor: "transparent",
    backgroundImage: "",
    openWrap: true,
    lineCount: 4,
    openScroll: false,
    height: 30,
    itemWidth: null,
    itemHeight: 22,
    marginRight: 10,
    marginBottom: 0,
    borderRadius: 12,
    open: false,
    top: 0,
    openCache: false,
    openLog: true,
    lockMinusListener: false,
    active: {
      fontSize: 12,
      color: "#ddf0ff",
      fontWeight: 700,
      backgroundColor: "#4115a1",
      backgroundImage: "",
      borderWidth: 1,
      borderColor: "transparent",
      line: {
        paddingBottom: 5,
        borderBottomWidth: 2,
        borderBottomStyle: "solid",
        borderBottomColor: "transparent"
      }
    },
    inactive: {
      backgroundColor: "transparent",
      backgroundImage: "",
      borderWidth: 1,
      borderColor: "#4115a1"
    }
  };
  const baseLayoutConfig__90 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "px"
    },
    positionStyle: {
      position: "relative",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const layoutConfig__91 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__92 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/8c68e279c0ae42f26dd3dab18bad256c.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a7ed5266mjx2g",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a7ed5266mjx2g",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__92 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__93 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/aade06c6ecd991a673f3a7c93182fd66.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a6ea726obpmco",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a6ea726obpmco",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__93 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__94 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/06cb091e42de32eeb7a9093d7212dd2a.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a7cbb26fif75y",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a7cbb26fif75y",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__94 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const layoutConfig__95 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__96 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/5e1b2b0b5f6a0b2a6def7a7c4dfb08ec.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a6eam26t071jh",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a6eam26t071jh",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__96 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__97 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/ec4a6a0b072545bf14ac0c309ec909d7.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/1721296d8cep3c89hf4j",
    linkOutApp: "https://novel.qingting.fm/novels/1721296d8cep3c89hf4j",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__97 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__98 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/36a3623b0267c28a22384a8e4b5c3fd2.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/32044810172d11ea88c3f9da2654db67",
    linkOutApp: "https://novel.qingting.fm/novels/32044810172d11ea88c3f9da2654db67",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__98 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const baseLayoutConfig__99 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "px"
    },
    positionStyle: {
      position: "relative",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const layoutConfig__100 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__101 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/7e70a1998089d4c09011b7d026cbe7cb.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a7afw26g0ja5u",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a7afw26g0ja5u",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__101 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__102 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/d68851051fe2141c3c251234e321ae94.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a6e9z26izc8d9",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a6e9z26izc8d9",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__102 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__103 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/dc8f126e71c61d939e50fda6ddde543b.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/17375e9b84ad8xpv0nje",
    linkOutApp: "https://novel.qingting.fm/novels/17375e9b84ad8xpv0nje",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__103 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const layoutConfig__104 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__105 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/84cd5e9efa85b742b9ad9fc7b9a4a269.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a6ffx26oomj1d",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a6ffx26oomj1d",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__105 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__106 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/9159c22f0156d32f1de85240ad755fd7.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a7bc326y7dvku",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a7bc326y7dvku",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__106 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__107 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/4ba0a224a5a68362d41754a923d8081e.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a737626pc617b",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a737626pc617b",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__107 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const baseLayoutConfig__108 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "px"
    },
    positionStyle: {
      position: "relative",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const layoutConfig__109 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__110 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/6b0ff7f72fea9bbfb587999be36675a4.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a7b5c26q74knc",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a7b5c26q74knc",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__110 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__111 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/aaa38d4f5322f8a07faa1e92f6320e58.png",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__111 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__112 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/2659b218dc864c4d7d0f27578787b2c2.png",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__112 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const layoutConfig__113 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__114 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/76db47832a43701f22c9773b0a964eef.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a7e3c26nqwjl4",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a7e3c26nqwjl4",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__114 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__115 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/f811684a873f8b05a4be4ac0f2b761e1.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a7d1926x7jsru",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a7d1926x7jsru",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__115 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__116 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/6f8494103106d39ce6007e930ef3949b.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a7ddq26qm8vwt",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a7ddq26qm8vwt",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__116 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const baseLayoutConfig__117 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "px"
    },
    positionStyle: {
      position: "relative",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const layoutConfig__118 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__119 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/e7e779d983495f047852658b1c0e8424.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/172128b01d8l3c8mbgpk",
    linkOutApp: "https://novel.qingting.fm/novels/172128b01d8l3c8mbgpk",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__119 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__120 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/78ff55b85dc8d70c3cb53a377058cdad.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a785g26awg0lj",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a785g26awg0lj",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__120 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__121 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/a663cd203efedfdbb133f845c57c04a8.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/172128abb9113c8xk0iu",
    linkOutApp: "https://novel.qingting.fm/novels/172128abb9113c8xk0iu",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__121 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const layoutConfig__122 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__123 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/8eb954aaa944e7285597431fc2ec7d62.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/17375e9b062p8fybn6ci",
    linkOutApp: "https://novel.qingting.fm/novels/17375e9b062p8fybn6ci",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__123 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__124 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/80b9016ff2ff62cb9632d461505a659a.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a7b5g26yahtvw",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a7b5g26yahtvw",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__124 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__125 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/15d762f6f25fe59da1a322ea97bf7a58.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/17186e22c2db6vo85q8p",
    linkOutApp: "https://novel.qingting.fm/novels/17186e22c2db6vo85q8p",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__125 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__126 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/9a6547954b4d25799e2c12bfd7031b5c.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__126 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__127 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/6c812f3a36e30b388a4ca4817217fd50.jpg",
    link: "",
    linkInApp: "http://sss.qingting.fm/super-vip-rights/build/index.html?source=home_supervip_icon_content",
    linkOutApp: "http://sss.qingting.fm/super-vip-rights/build/index.html?source=home_supervip_icon_content",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__127 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const spaceLayoutConfig = {
    common: {
      height: 80,
      cloneElementId: ""
    },
    styles: {
      background: {
        color: "#4115a1",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      position: "relative",
      top: null
    }
  };
  const envController__129 = {
    env: "all",
    operation: "allow",
    version: "8.8.0",
    comparison: "isGreaterOrEqual",
    versionEnv: "inIosApp",
    versionOperation: "deny"
  };
  const commonStyle = {
    backgroundImage: customStyle.bgImg ? `url(${customStyle.bgImg})` : customStyle.hasGradient ? `linear-gradient(${customStyle.gradientDeg}deg, ${customStyle.bgColor}, ${customStyle.bgColor2})` : 'none',
    backgroundSize: 'cover',
    backgroundColor: customStyle.bgColor,
    backgroundRepeat: 'no-repeat',
    zIndex: customStyle.zIndex,
    aspectRatio: customStyle.aspectRatio
  };
  const style__130 = {
    top: {
      height: customStyle.height + unit
    },
    bottom: {
      height: customStyle.height + unit
    },
    left: {
      top: customStyle.top + unit,
      width: customStyle.width + unit,
      height: customStyle.height + unit
    },
    right: {
      top: customStyle.top + unit,
      width: customStyle.width + unit,
      height: customStyle.height + unit
    }
  };
  const style__131 = {
    backgroundImage: `url(${btnStyle__131.bgImg})`,
    backgroundColor: btnStyle__131.bgColor,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    color: btnStyle__131.color,
    fontSize: btnStyle__131.fontSize + btnStyle__131.unit,
    margin: '0 auto',
    width: btnStyle__131.width + btnStyle__131.unit,
    height: btnStyle__131.height + btnStyle__131.unit,
    lineHeight: btnStyle__131.height + btnStyle__131.unit,
    borderRadius: btnStyle__131.height / 2 + btnStyle__131.unit,
    textAlign: 'center',
    position: btnStyle__131.isAbsolute ? 'absolute' : 'relative',
    animation: btnStyle__131.hasAnimation ? `buy-button-breath 1s infinite` : null
  };
  const abStyle__131 = {
    top: btnStyle__131.top + btnStyle__131.unit,
    left: btnStyle__131.left + btnStyle__131.unit,
    right: btnStyle__131.right + btnStyle__131.unit,
    bottom: btnStyle__131.bottom + btnStyle__131.unit
  };
  const reStyle__131 = {
    marginTop: btnStyle__131.top + btnStyle__131.unit,
    marginBottom: btnStyle__131.bottom + btnStyle__131.unit,
    marginLeft: btnStyle__131.left + btnStyle__131.unit,
    marginRight: btnStyle__131.right + btnStyle__131.unit
  };
  const timeController__132 = {
    startTime: "2020-09-01 00:00:00",
    endTime: "2020-09-03 23:59:59",
    dynamic: true,
    duration: 10
  };
  const baseLayoutConfig__133 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "#cc0001",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "px"
    },
    positionStyle: {
      position: "relative",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const envController__134 = {
    env: "all",
    operation: "allow",
    version: "8.8.0",
    comparison: "isGreaterOrEqual",
    versionEnv: "inIosApp",
    versionOperation: "deny"
  };
  const singleImage__135 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/c2f2ea5aec3488a32ff242117da3b4ca.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__135 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const basicConfig__136 = {
    endTime: "2020-09-03 23:59:59",
    title: "仅剩:",
    isCustomizeEndTitle: false,
    customizeEndTitle: "活动结束啦",
    fontColor: "#910706",
    bgColor: "transparent",
    borderRadius: "",
    unit: "rem",
    paddingTop: "",
    paddingBottom: "",
    paddingRight: "",
    paddingLeft: "",
    fontWeight: 400,
    fontSize: "14px",
    position: "absolute",
    top: null,
    bottom: 0.02,
    left: "",
    right: 0.4,
    display: "inline-block"
  };
  const marqueeConfig = {
    common: {
      direction: "vertical",
      slidesPerView: 1,
      delay: 5000
    },
    list: [{
      avatar: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/9e7df42d55573f9d3a3ce5379e62fcff.png",
      text: "京东年卡已售罄>>"
    }, {
      avatar: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/4702d77db60729c27881b54b38e84a56.png",
      text: "赠礼有限,手慢无!"
    }],
    style: {
      color: "#febdb9",
      backgroundColor: "#b90000",
      fontSize: 12,
      height: 25,
      margin: 5,
      opacity: 100
    },
    positionStyle: {
      position: "absolute",
      type: "rem",
      left: 0.06,
      right: null,
      top: null,
      bottom: 0.08,
      zIndex: 1
    }
  };
  const imageArchor__138 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/26f45cb3732892309ed4f5f539f19b28.png",
    link: "",
    linkInApp: "https://sss.qingting.fm/vips/members/v2/presents.html",
    linkOutApp: "https://sss.qingting.fm/vips/members/v2/presents.html",
    imageStyle: {
      width: 66,
      height: null
    },
    style: {
      position: "absolute",
      top: 35,
      bottom: null,
      left: null,
      right: 0,
      type: "px"
    },
    openNewWebview: false
  };
  const basicConfig__139 = {
    position: "absolute",
    coverImg: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/d434b4e4029e20effe9c8e99a406ab87.png",
    unit: "px",
    coverImgWidth: 65,
    coverImgHeight: null,
    coverImgTop: 12,
    coverImgRight: 0,
    coverImgBottom: null,
    coverImgLeft: null,
    zIndex: "9",
    ruleContent: "<p class=\"ql-align-justify\">活动规则:</p><p class=\"ql-align-justify\">一、活动时间</p><p class=\"ql-align-justify\">2020年8月28日00:00:00-2020年9月10日23:59:59</p><p class=\"ql-align-justify\">二、活动特惠</p><p class=\"ql-align-justify\">1.预热期(8.28-8.31):年卡买1得2</p><p class=\"ql-align-justify\">预热期可享蜻蜓FM超级会员年卡98元,并可从活动页展示的赠礼中任选一个赠礼进行领取，赠礼领取有效期7天;</p><p class=\"ql-align-justify\">2.正式期(9.1-9.3):年卡最高买1得N</p><p class=\"ql-align-justify\">正式期可享蜻蜓FM超级会员年卡98元,并可领取活动页展示的所有赠礼，赠礼领取有效期7天;&nbsp;&nbsp;&nbsp;</p><p class=\"ql-align-justify\">3.返场期(9.4-9.10):联合会员专场,蜻蜓FM年卡买1得2,具体赠礼以活动页面展示为准;&nbsp;&nbsp;</p><p class=\"ql-align-justify\">三、购买规则</p><p class=\"ql-align-justify\">1.同一账户每日仅限购买1次会员商品(包括蜻蜓FM超级会员年卡/半年卡/季卡/月卡等产品).</p><p class=\"ql-align-justify\">2.活动中的品牌赠礼库存有限,先到先得.当有某一品牌库存领取完毕,将在活动页面对该品牌赠礼做下架处理，在此之后购买会员将不享该权益，请提前核对好活动页赠礼详情后进行购买.</p><p class=\"ql-align-justify\">3.超级会员服务为虚拟产品，一经售卖不做退换.</p><p class=\"ql-align-justify\">四、赠礼说明</p><p class=\"ql-align-justify\">1.一年内同一手机号码在蜻蜓FM仅可充值共2次京东PLUS会员，京东PLUS年卡指京东PLUS京典卡，不包含爱奇艺、腾讯等异业权益，京东PLUS年卡所含权益及规则以京东官方公布为准，本次活动暂不支持海外手机号领取京东PLUS会员权益。且由于京东PLUS会员开通有综合评分要求，因此可能存在极少异常账号无法开通成功的情况，具体可咨询京东客服。</p><p class=\"ql-align-justify\">2.芒果TV会员仅适用于手机+iPad+电脑（不含电视）;</p><p class=\"ql-align-justify\">3.<span style=\"color: rgb(17, 31, 44);\">同一去哪儿账号（手机号）会员最多可充值1095天，若充值达到上限，将出现会员</span><span style=\"color: rgb(17, 31, 44); font-size: 14px;\">充值不成功情况</span>;</p><p class=\"ql-align-justify\">4.活动赠送的品牌会员所含权益及规则以对应APP官方公布为准；</p><p class=\"ql-align-justify\">5.获取赠礼应遵循蜻蜓FM《用户协议》、《超级会员服务协议》，不得通过不正当手段获取赠礼进行盈利，如被发现违反相关协议规定，蜻蜓FM及赠礼合作方任意一方均有权单独按照其平台的用户协议规定进行处理；</p><p class=\"ql-align-justify\">6.领取赠礼时，务必确认账号登录正确，避免充值到错误账号（温馨提示：用户如因输入错误账号导致赠礼领取失败，均不予以赔偿）</p><p class=\"ql-align-justify\">7.活动赠礼为蜻蜓FM用户购买超级会员商品后的加权益,领取有效期为7天，赠礼权益需要您在有效期内到赠礼页面绑定充值权益的手机号账户,请您注意及时领取，超出领取时间将视为自动放弃未领取权益,后续也将不再进行赠礼权益的领取支持；</p><p class=\"ql-align-justify\">五、抽奖规则</p><p class=\"ql-align-justify\">1.抽奖时间：8月28日00:00:00-9月3日23:59:59</p><p class=\"ql-align-justify\">2.抽奖机会：</p><p class=\"ql-align-justify\">在8月28日00:00:00-9月3日符合以下条件的用户可获得抽奖机会:</p><p class=\"ql-align-justify\">①有效会员根据对应会员等级可获得抽奖机会:</p><p class=\"ql-align-justify\">V1~V2等级获得1次抽奖机会;</p><p class=\"ql-align-justify\">V3~V4等级获得2次抽奖机会;</p><p class=\"ql-align-justify\">V5等级获得3次抽奖机会;</p><p class=\"ql-align-justify\">②在活动期间,每次购买超级会员年卡均可获得3次抽奖机会;</p><p class=\"ql-align-justify\">③在活动期间,每次购买超级会员月卡/季卡/半年卡，均可获得2次抽奖机会;</p><p class=\"ql-align-justify\">3.抽奖奖品:</p><p class=\"ql-align-justify\">①抽奖获得积分奖品,将在24小时内到账,可前往“蜻蜓FM手机APP-个人中心-积分商城”查看并使用;</p><p class=\"ql-align-justify\">②抽奖获得优惠券奖品,将在24小时内到账,可前往“蜻蜓FM手机APP-个人中心-优惠券”查看并使用;</p><p class=\"ql-align-justify\">③抽奖获得实物奖品(万元金卡、&nbsp;HUAWEI P40 Pro、Beats X 蓝牙无线、100元京东卡、小米手环、早教机、晓年鉴周边)将在活动结束后30个工作日内发放,请在活动期内按照要求填写真实的个人信息用于申报个税，否则视为放弃</p><p class=\"ql-align-justify\">④若存在刷奖等故意或者恶意违规的行为，一经核实，该用户将取消中奖资格。</p><p class=\"ql-align-justify\">六、会员特权</p><p class=\"ql-align-justify\">开通成为蜻蜓FM超级会员的用户，将获得更多新品内容免费畅听、福利社专享福利等升级权益；权益仅限于蜻蜓FM的APP上使用.</p><p class=\"ql-align-justify\">七、其他问题</p><p class=\"ql-align-justify\">如在使用蜻蜓FM超级会员过程中有任何咨询或疑问,请通过“蜻蜓FM手机APP-个人中心-帮助与反馈-联系客服”联系客服进行咨询;</p>",
    ruleContentHeight: 350,
    ruleContentMaxHeight: 300,
    ruleFontSize: 13,
    lineHeight: "1.5"
  };
  const singleImage__140 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/8da2a366fc80e36891fb0df35f889319.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__140 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const row__141 = "4";
  const picConfig__141 = {
    data: [{
      pic: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/dbc200b1875836e3b4f25c4aba4a77bb.png",
      pop: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/ca2a27357fdcb064a4afb049b11ae7ec.png",
      title: "京东",
      desc: "年卡\xA5198"
    }, {
      pic: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/577925e1d153e50889f27eedda0d249f.png",
      pop: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/50ba1442ffff33c229a84ecddba51cba.png",
      title: "网易云音乐",
      desc: "年卡\xA5216"
    }, {
      pic: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/1d8b1096e2106254fe879b77e233343a.png",
      pop: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/d95733c18f6305abbb6c3bca2f592966.png",
      title: "Keep",
      desc: "年卡\xA5248"
    }, {
      pic: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/8638cbfa38ebc3269cff806071085d91.png",
      pop: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/b30d90c9ed1ec69e805fa34bb9f42803.png",
      title: "快看漫画",
      desc: "年卡\xA5188"
    }, {
      pic: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/52453f347e202e1f4c13497bd4636f6b.png",
      pop: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/aa3a761ff3845192852c40e60810cb90.png",
      title: "去哪儿",
      desc: "年卡\xA569"
    }, {
      pic: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/785561d666914fa876024d8d8405b183.png",
      pop: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/6cb977cb929392475aa8920d72994972.png",
      title: "大地影院",
      desc: "年卡\xA550"
    }, {
      pic: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/b95855191816db71d04692b5194ead6b.png",
      pop: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/6ed31e4edd2079aa782136ff832664bd.png",
      title: "芒果TV",
      desc: "月卡\xA520"
    }],
    titleColor: "#915300",
    titleFontSize: 14,
    descColor: "#915300",
    descFontSize: 10,
    popLoop: true
  };
  const cornerConfig__141 = {
    pic: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/da6298fd64e1f296a954e57e092293a9.png",
    textAlign: "right",
    unit1: "rem",
    width: 1.2,
    height: "",
    marginTop: 0,
    marginBottom: 0,
    marginLeft: 0,
    marginRight: 0.2
  };
  const wholeConfig__141 = {
    position: "absolute",
    unit2: "rem",
    marginTop: 0.8,
    marginBottom: 0,
    marginLeft: 0.15,
    marginRight: 0.15,
    zIndex: 0
  };
  const baseLayoutConfig__142 = {
    commonStyle: {
      textAlign: "center",
      height: 55,
      overflow: "hidden",
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "rem"
    },
    positionStyle: {
      position: "absolute",
      top: null,
      bottom: 0.6,
      left: 0.4,
      right: 0.4
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const style__143 = {
    backgroundImage: `url(${btnStyle__143.bgImg})`,
    backgroundColor: btnStyle__143.bgColor,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    color: btnStyle__143.color,
    fontSize: btnStyle__143.fontSize + btnStyle__143.unit,
    margin: '0 auto',
    width: btnStyle__143.width + btnStyle__143.unit,
    height: btnStyle__143.height + btnStyle__143.unit,
    lineHeight: btnStyle__143.height + btnStyle__143.unit,
    borderRadius: btnStyle__143.height / 2 + btnStyle__143.unit,
    textAlign: 'center',
    position: btnStyle__143.isAbsolute ? 'absolute' : 'relative',
    animation: btnStyle__143.hasAnimation ? `buy-button-breath 1s infinite` : null
  };
  const abStyle__143 = {
    top: btnStyle__143.top + btnStyle__143.unit,
    left: btnStyle__143.left + btnStyle__143.unit,
    right: btnStyle__143.right + btnStyle__143.unit,
    bottom: btnStyle__143.bottom + btnStyle__143.unit
  };
  const reStyle__143 = {
    marginTop: btnStyle__143.top + btnStyle__143.unit,
    marginBottom: btnStyle__143.bottom + btnStyle__143.unit,
    marginLeft: btnStyle__143.left + btnStyle__143.unit,
    marginRight: btnStyle__143.right + btnStyle__143.unit
  };
  const envController__144 = {
    env: "inIosApp",
    operation: "allow",
    version: "8.8.0",
    comparison: "isGreaterOrEqual",
    versionEnv: "inIosApp",
    versionOperation: "allow"
  };
  const singleImage__145 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/e8d2fd6e2dbea5f76cfe577b12319630.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__145 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__146 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/c7b6f0a4f8a31b86e72232f4d8e5f862.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__146 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__147 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/6014aebe0ae80b33e4c8a87c716c0673.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__147 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__148 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/9a58edb0298f4faf1a627f2a7f57d2c1.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__148 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const config__149 = {
    activity_id: 1027,
    canSetShare: false,
    shareAddChance: false,
    pageTitleCanModify: false,
    showTop: false,
    showBottom: false,
    serviceUrl: "",
    defaultStyle: {
      pageBg: "#ca0000",
      topImg: "",
      bottomImg: "",
      drawBackImg: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/f6fffc6e2d451d0f3b433219025dd40c.png",
      prizeBorderColor: "",
      prizeNameColor: "",
      prizeDefaultColor: "",
      prizeSelectColor: "",
      drawBtnImg: "",
      ruleImg: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/92d7ed698b465c98248c92b1a0c90e12.png",
      myPrizeImg: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/33b3ec0d4347fdf4d19c099a3bbba5ae.png"
    },
    customeStyle: {
      prizeDefaultImg: "",
      prizeSelectImg: "",
      replaceCarousel: ""
    },
    locationStyle: {
      top: 0,
      bottom: 0,
      spacing: 24,
      type: "px"
    }
  };
  const timeController__150 = {
    startTime: null,
    endTime: "2020-09-01 15:42:31",
    dynamic: false,
    duration: 10
  };
  const basicConfig__151 = {
    imgUrl: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/2680a5e2decdad1b8aaf377f61e7b9c7.jpg",
    showOutApp: false,
    style: {
      position: "relative",
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      width: "100%",
      height: "auto",
      zIndex: 1
    },
    shareConfig: {
      title: "🔥福利升级!",
      desc: "买蜻蜓年卡得8大会员 速戳>>",
      img: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/88f0fe0cb378531d08ef1b6bc9332bcd.png",
      link: ""
    }
  };
  const singleImage__152 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/3ccdbf263b5ccd9dadeebe5d3dbd7589.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__152 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const baseLayoutConfig__153 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: "hidden",
      background: {
        color: "#cc0001",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "%"
    },
    positionStyle: {
      position: "relative",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: 1.2,
      marginRight: 1.2,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: 1,
      paddingRight: 1
    }
  };
  const tabNavs__154 = [{
    title: "京东",
    link: "",
    minHeight: null,
    default: false,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "transparent",
      activeColor: "transparent",
      position: "center"
    }
  }, {
    title: "网易云音乐",
    link: "",
    minHeight: "",
    default: false,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "",
      activeColor: "",
      position: ""
    }
  }, {
    title: "Keep",
    link: "",
    minHeight: "",
    default: false,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "",
      activeColor: "",
      position: ""
    }
  }, {
    title: "快看漫画",
    link: "",
    minHeight: "",
    default: false,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "",
      activeColor: "",
      position: ""
    }
  }, {
    title: "去哪儿",
    link: "",
    minHeight: "",
    default: false,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "",
      activeColor: "",
      position: ""
    }
  }, {
    title: "大地影院",
    link: "",
    minHeight: "",
    default: false,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "",
      activeColor: "",
      position: ""
    }
  }, {
    title: "芒果TV",
    link: "",
    minHeight: "",
    default: false,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "",
      activeColor: "",
      position: ""
    }
  }, {
    title: "牛听听",
    link: "",
    minHeight: "",
    default: false,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "",
      activeColor: "",
      position: ""
    }
  }];
  const tabNavsConfig__154 = {
    showTitle: true,
    fontSize: 13,
    color: "#ffffff",
    backgroundColor: "transparent",
    backgroundImage: "",
    openWrap: true,
    lineCount: 4,
    openScroll: false,
    height: 36,
    itemWidth: 100,
    itemHeight: 24,
    marginRight: 6,
    marginBottom: 5,
    borderRadius: 12,
    open: false,
    top: 0,
    openCache: false,
    openLog: true,
    lockMinusListener: false,
    active: {
      fontSize: 13,
      color: "#cc0001",
      fontWeight: 700,
      backgroundColor: "#ffffff",
      backgroundImage: "",
      borderWidth: 1,
      borderColor: "#ffffff",
      line: {
        paddingBottom: 5,
        borderBottomWidth: 2,
        borderBottomStyle: "solid",
        borderBottomColor: "transparent"
      }
    },
    inactive: {
      backgroundColor: "transparent",
      backgroundImage: "",
      borderWidth: 1,
      borderColor: "#ffffff"
    }
  };
  const singleImage__155 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/ca2a27357fdcb064a4afb049b11ae7ec.png",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__155 = {
    marginTop: 0,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__156 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/3cd9102c85536ac132dcb735c0eb548c.png",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__156 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__157 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/d95733c18f6305abbb6c3bca2f592966.png",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__157 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__158 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/ccaf84cde915e4d71bb0858b131a6a55.png",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__158 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__159 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/02af41ffe6f5ef6e6057b80f5ba6cbf2.png",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__159 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__160 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/280ad6fa3de8ed7d07798a90a45b9e4b.png",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__160 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__161 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/0749c8d671c03fc89af90aa2e2434232.png",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__161 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__162 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/3998808e697db4c9570aa63182b08d91.png",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__162 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__163 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/8069cbe30d00d70de77cd95e6c621585.jpg",
    link: "",
    linkInApp: "http://sss.qingting.fm/qt-web/redirect-url/auth-duiba.html?redirect=http://activity.m.duiba.com.cn/chw/visual-editor/skins?id=51374",
    linkOutApp: "http://sss.qingting.fm/qt-web/redirect-url/auth-duiba.html?redirect=http://activity.m.duiba.com.cn/chw/visual-editor/skins?id=51374",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__163 = {
    marginTop: 10,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__164 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/e5dad8d63705a15c7422dd980f1ffc8b.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__164 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__165 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/4f5b67cb0e6e5e052c24699095404fa0.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/297486",
    linkOutApp: "https://m.qingting.fm/vchannels/297486",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__165 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__166 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/c989472181eeda20416fb772b350f503.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/367198",
    linkOutApp: "https://m.qingting.fm/vchannels/367198",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__166 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__167 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/4e5da7f4dc332254fde210d8216f616d.jpg",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/145302",
    linkOutApp: "https://m.qingting.fm/vchannels/145302",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__167 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__168 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/04fc10f871a604427fff56a9330036a3.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__168 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const baseLayoutConfig__169 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "#ffadbf",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "%"
    },
    positionStyle: {
      position: "relative",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: 4.3,
      marginRight: 4.3,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: 4.1,
      paddingRight: 4.1
    }
  };
  const tabNavs__170 = [{
    title: "神作上新",
    link: "",
    minHeight: null,
    default: true,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "transparent",
      activeColor: "transparent",
      position: "center"
    }
  }, {
    title: "全网上新",
    link: "",
    minHeight: null,
    default: false,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "",
      activeColor: "",
      position: ""
    }
  }, {
    title: "精品爆更",
    link: "",
    minHeight: null,
    default: false,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "",
      activeColor: "",
      position: ""
    }
  }, {
    title: "重磅精选",
    link: "",
    minHeight: null,
    default: false,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "",
      activeColor: "",
      position: ""
    }
  }];
  const tabNavsConfig__170 = {
    showTitle: true,
    fontSize: 13,
    color: "#c51332",
    backgroundColor: "transparent",
    backgroundImage: "",
    openWrap: true,
    lineCount: 4,
    openScroll: false,
    height: 30,
    itemWidth: 100,
    itemHeight: 22,
    marginRight: 10,
    marginBottom: 0,
    borderRadius: 12,
    open: false,
    top: 0,
    openCache: false,
    openLog: true,
    lockMinusListener: false,
    active: {
      fontSize: 13,
      color: "#fffbfb",
      fontWeight: 700,
      backgroundColor: "#c51332",
      backgroundImage: "",
      borderWidth: 1,
      borderColor: "transparent",
      line: {
        paddingBottom: 5,
        borderBottomWidth: 2,
        borderBottomStyle: "solid",
        borderBottomColor: "transparent"
      }
    },
    inactive: {
      backgroundColor: "#ffb1bf",
      backgroundImage: "",
      borderWidth: 1,
      borderColor: "#c51332"
    }
  };
  const baseLayoutConfig__171 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "px"
    },
    positionStyle: {
      position: "relative",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const layoutConfig__172 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__173 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/cea5adf44fdcf54cc2cc485e0559eb8b.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/371308",
    linkOutApp: "https://m.qingting.fm/vchannels/371308",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__173 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__174 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/0f9e0faaa8dfd0cdde5184ba6aabfcc8.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/373535",
    linkOutApp: "https://m.qingting.fm/vchannels/373535",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__174 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__175 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/8bac6da21bad529ee5bce7d23aa1f77e.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/348805",
    linkOutApp: "https://m.qingting.fm/vchannels/348805",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__175 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const layoutConfig__176 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__177 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/1b9dbfce81199c6676c36331a88e8336.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/372836",
    linkOutApp: "https://m.qingting.fm/vchannels/372836",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__177 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__178 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/8c8d691913ff0e091a1ac29bdfdb9868.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/196022",
    linkOutApp: "https://m.qingting.fm/vchannels/196022",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__178 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__179 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/630d31b3bff571aab3b07d07f4924204.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/372089",
    linkOutApp: "https://m.qingting.fm/vchannels/372089",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__179 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__180 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/ed3a3e8d135b2aa1b8bb4cdfef4707c0.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/372837",
    linkOutApp: "https://m.qingting.fm/vchannels/372837",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__180 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const baseLayoutConfig__181 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "px"
    },
    positionStyle: {
      position: "relative",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const layoutConfig__182 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__183 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/b3aad2e62e1cceb36d5da93ccc9ac706.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/365706",
    linkOutApp: "https://m.qingting.fm/vchannels/365706",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__183 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__184 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/0d6cbacb84f018018b71bebe28bc5601.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/368072",
    linkOutApp: "https://m.qingting.fm/vchannels/368072",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__184 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__185 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/c3f6dfc92595a7feff658ce24bb1222d.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/356117",
    linkOutApp: "https://m.qingting.fm/vchannels/356117",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__185 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const layoutConfig__186 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__187 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/e1df9ac04059fd3108f1739d632557ec.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/321512",
    linkOutApp: "https://m.qingting.fm/vchannels/321512",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__187 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__188 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/88a812625ca2fe75f741b99604eef7e4.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/355264",
    linkOutApp: "https://m.qingting.fm/vchannels/355264",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__188 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__189 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/94fe246f9c68b81564657206cc639d8a.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/332299",
    linkOutApp: "https://m.qingting.fm/vchannels/332299",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__189 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const baseLayoutConfig__190 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "px"
    },
    positionStyle: {
      position: "relative",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const layoutConfig__191 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__192 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/7975c14d8e4a839a782ad148a66874d1.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/35242",
    linkOutApp: "https://m.qingting.fm/vchannels/35242",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__192 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__193 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/c52caefa256ffbdeb10b295146a3e9f4.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/205768",
    linkOutApp: "https://m.qingting.fm/vchannels/205768",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__193 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__194 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/86a6e78a769f696c5ff419d7eb243cf7.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/367745",
    linkOutApp: "https://m.qingting.fm/vchannels/367745",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__194 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const layoutConfig__195 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__196 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/2849469493495007bc24f52a9060771c.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/354487",
    linkOutApp: "https://m.qingting.fm/vchannels/354487",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__196 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__197 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/9483bd6bb1754248e80ad3aa1b6afa22.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/320747",
    linkOutApp: "https://m.qingting.fm/vchannels/320747",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__197 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__198 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/1183cd6d7d0b4941fe44802c19312bad.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/359961",
    linkOutApp: "https://m.qingting.fm/vchannels/359961",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__198 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const timeController__199 = {
    startTime: "2020-08-31 12:23:06",
    endTime: "2020-08-31 12:23:03",
    dynamic: true,
    duration: 10
  };
  const singleImage__200 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/e9e28bae5347fc7987b8433f8ea93733.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__200 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const baseLayoutConfig__201 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "#fff6ee",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "%"
    },
    positionStyle: {
      position: "relative",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: 4.2,
      marginRight: 4.2,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: 4,
      paddingRight: 4
    }
  };
  const tabNavs__202 = [{
    title: "爆款小说",
    link: "",
    minHeight: null,
    default: true,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "transparent",
      activeColor: "transparent",
      position: "center"
    }
  }, {
    title: "必听爽文",
    link: "",
    minHeight: null,
    default: false,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "",
      activeColor: "",
      position: ""
    }
  }, {
    title: "出版畅销",
    link: "",
    minHeight: null,
    default: false,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "",
      activeColor: "",
      position: ""
    }
  }, {
    title: "心动言情",
    link: "",
    minHeight: null,
    default: false,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "",
      activeColor: "",
      position: ""
    }
  }];
  const tabNavsConfig__202 = {
    showTitle: true,
    fontSize: 13,
    color: "#c51332",
    backgroundColor: "transparent",
    backgroundImage: "",
    openWrap: true,
    lineCount: 4,
    openScroll: false,
    height: 30,
    itemWidth: 100,
    itemHeight: 22,
    marginRight: 10,
    marginBottom: 0,
    borderRadius: 12,
    open: false,
    top: 0,
    openCache: false,
    openLog: true,
    lockMinusListener: false,
    active: {
      fontSize: 13,
      color: "#fffbfb",
      fontWeight: 700,
      backgroundColor: "#c51332",
      backgroundImage: "",
      borderWidth: 1,
      borderColor: "transparent",
      line: {
        paddingBottom: 5,
        borderBottomWidth: 2,
        borderBottomStyle: "solid",
        borderBottomColor: "transparent"
      }
    },
    inactive: {
      backgroundColor: "transparent",
      backgroundImage: "",
      borderWidth: 1,
      borderColor: "#c51332"
    }
  };
  const baseLayoutConfig__203 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "px"
    },
    positionStyle: {
      position: "relative",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const singleImage__204 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/18d82321656f15b74745f48d91504feb.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/268108",
    linkOutApp: "https://m.qingting.fm/vchannels/268108",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__204 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__205 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/fc39e888e9063e9e54bf50083d6b9e16.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/323440",
    linkOutApp: "https://m.qingting.fm/vchannels/323440",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__205 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__206 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/0c0f83d10fede0b60e2299dc4e07f574.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/294908",
    linkOutApp: "https://m.qingting.fm/vchannels/294908",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__206 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__207 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/37395357b57630147fbf21683f417e7e.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/325019",
    linkOutApp: "https://m.qingting.fm/vchannels/325019",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__207 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const baseLayoutConfig__208 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "px"
    },
    positionStyle: {
      position: "relative",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const singleImage__209 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/8395220b0108db0e5a70cbdf7c470c77.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/366125",
    linkOutApp: "https://m.qingting.fm/vchannels/366125",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__209 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__210 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/aa7cd15d12207dbf520cd3b5c97e9e2e.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/368027",
    linkOutApp: "https://m.qingting.fm/vchannels/368027",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__210 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__211 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/b461ff77eb6d3f1ab49cbf48eabfb478.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/366131",
    linkOutApp: "https://m.qingting.fm/vchannels/366131",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__211 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__212 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/94ee3e8fc80b127c014b9ea200deabfd.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/369121",
    linkOutApp: "https://m.qingting.fm/vchannels/369121",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__212 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const baseLayoutConfig__213 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "px"
    },
    positionStyle: {
      position: "relative",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const singleImage__214 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/99e84f5867f58609ce619ce7651240ab.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/370585",
    linkOutApp: "https://m.qingting.fm/vchannels/370585",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__214 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__215 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/c229cabeeec3a0afc4eeaf524581d7bb.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/370579",
    linkOutApp: "https://m.qingting.fm/vchannels/370579",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__215 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__216 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/dd07d0aa7c6d8eae62ceb47c2e6cc148.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/363336",
    linkOutApp: "https://m.qingting.fm/vchannels/363336",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__216 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__217 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/e0ac2e0d63b2fc0305e98c65bfa8bfaf.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/363306",
    linkOutApp: "https://m.qingting.fm/vchannels/363306",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__217 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const baseLayoutConfig__218 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "px"
    },
    positionStyle: {
      position: "relative",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const singleImage__219 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/8a6ff599abb221ff5b36221938ea488e.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/338837",
    linkOutApp: "https://m.qingting.fm/vchannels/338837",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__219 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__220 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/191fecaab56b376f7641a5be93d6113c.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/319491",
    linkOutApp: "https://m.qingting.fm/vchannels/319491",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__220 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__221 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/1347954ccf9b8b13a5ff0307e1547ecd.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/365786",
    linkOutApp: "https://m.qingting.fm/vchannels/365786",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__221 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__222 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/8aa02eed9b0b18b1eba11edd5b6e37ee.png",
    link: "",
    linkInApp: "qingtingfm://app.qingting.fm/vchannels/368263",
    linkOutApp: "https://m.qingting.fm/vchannels/368263",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__222 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__223 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/e9bf3f47e1d3d7c106fa2a6085dea1b7.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__223 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const baseLayoutConfig__224 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "#fe5b4a",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "%"
    },
    positionStyle: {
      position: "relative",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: 4.2,
      marginRight: 4.2,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: 4,
      paddingRight: 4
    }
  };
  const tabNavs__225 = [{
    title: "畅销精选",
    link: "",
    minHeight: null,
    default: true,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "transparent",
      activeColor: "transparent",
      position: "center"
    }
  }, {
    title: "都市生活",
    link: "",
    minHeight: null,
    default: false,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "",
      activeColor: "",
      position: ""
    }
  }, {
    title: "热血玄幻",
    link: "",
    minHeight: null,
    default: false,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "",
      activeColor: "",
      position: ""
    }
  }, {
    title: "豪门种田",
    link: "",
    minHeight: null,
    default: false,
    image: {
      inactive: "",
      active: "",
      inactiveColor: "",
      activeColor: "",
      position: ""
    }
  }];
  const tabNavsConfig__225 = {
    showTitle: true,
    fontSize: 13,
    color: "#ffffff",
    backgroundColor: "transparent",
    backgroundImage: "",
    openWrap: true,
    lineCount: 4,
    openScroll: false,
    height: 30,
    itemWidth: null,
    itemHeight: 22,
    marginRight: 10,
    marginBottom: 0,
    borderRadius: 12,
    open: false,
    top: 0,
    openCache: false,
    openLog: true,
    lockMinusListener: false,
    active: {
      fontSize: 12,
      color: "#ffffff",
      fontWeight: 700,
      backgroundColor: "#ca0000",
      backgroundImage: "",
      borderWidth: 1,
      borderColor: "transparent",
      line: {
        paddingBottom: 5,
        borderBottomWidth: 2,
        borderBottomStyle: "solid",
        borderBottomColor: "transparent"
      }
    },
    inactive: {
      backgroundColor: "transparent",
      backgroundImage: "",
      borderWidth: 1,
      borderColor: "#ffffff"
    }
  };
  const baseLayoutConfig__226 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "px"
    },
    positionStyle: {
      position: "relative",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const layoutConfig__227 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__228 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/9958ce0ad94c6167f5e3533908636f20.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a7ed5266mjx2g",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a7ed5266mjx2g",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__228 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__229 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/9b38e8b7e4b3f220d295c8e6e9528101.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a6ea726obpmco",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a6ea726obpmco",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__229 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__230 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/b97d76f1ab42c910cfcc81f8dac30c72.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a7cbb26fif75y",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a7cbb26fif75y",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__230 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const layoutConfig__231 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__232 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/cc157aa8350ef0d5bcc4fc99a1d51180.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a6eam26t071jh",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a6eam26t071jh",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__232 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__233 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/f23b2b0896d86e7035142ed09d0f6724.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/1721296d8cep3c89hf4j",
    linkOutApp: "https://novel.qingting.fm/novels/1721296d8cep3c89hf4j",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__233 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__234 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/1a417a83f09995bd9cb79866b16283ae.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/32044810172d11ea88c3f9da2654db67",
    linkOutApp: "https://novel.qingting.fm/novels/32044810172d11ea88c3f9da2654db67",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__234 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const baseLayoutConfig__235 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "px"
    },
    positionStyle: {
      position: "relative",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const layoutConfig__236 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__237 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/74bc5ced1d833a9ebb7cd9d9d33c5a81.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a7afw26g0ja5u",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a7afw26g0ja5u",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__237 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__238 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/c852091431af4a7a35061a16ee7aae01.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a6e9z26izc8d9",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a6e9z26izc8d9",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__238 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__239 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/1482e219e099fbfee86ebde681a6d063.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/17375e9b84ad8xpv0nje",
    linkOutApp: "https://novel.qingting.fm/novels/17375e9b84ad8xpv0nje",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__239 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const layoutConfig__240 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__241 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/90a48596f8a48efae14b6b9e4b62c83f.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a6ffx26oomj1d",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a6ffx26oomj1d",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__241 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__242 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/d59c4027e8a6745c0c3e6b6c4ce924fa.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a7bc326y7dvku",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a7bc326y7dvku",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__242 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__243 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/8ca2d8ee941dd4e1cfa517e307c3e480.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a737626pc617b",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a737626pc617b",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__243 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const baseLayoutConfig__244 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "px"
    },
    positionStyle: {
      position: "relative",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const layoutConfig__245 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__246 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/0fac01e6aa73854f875eb5c7f78e5ceb.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a7b5c26q74knc",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a7b5c26q74knc",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__246 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__247 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/63286bc089110b9c91bb9b2a60df6afa.png",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__247 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__248 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/ae0c810b8c08ed4c01bb41f54e09eb40.png",
    link: "",
    linkInApp: "",
    linkOutApp: "",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__248 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const layoutConfig__249 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__250 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/fdbea841880afe4a8380a606e46886e3.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a7e3c26nqwjl4",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a7e3c26nqwjl4",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__250 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__251 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/43cc4ccbfa3a7c6eaeb83b118580300d.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a7d1926x7jsru",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a7d1926x7jsru",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__251 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__252 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/b3e5affacfb2020aaf60597ec3846da1.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a7ddq26qm8vwt",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a7ddq26qm8vwt",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__252 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const baseLayoutConfig__253 = {
    commonStyle: {
      textAlign: "left",
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      type: "px"
    },
    positionStyle: {
      position: "relative",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null,
      paddingTop: null,
      paddingBottom: null,
      paddingLeft: null,
      paddingRight: null
    }
  };
  const layoutConfig__254 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__255 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/c48980e996a04eea930b966a83770e4f.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/172128b01d8l3c8mbgpk",
    linkOutApp: "https://novel.qingting.fm/novels/172128b01d8l3c8mbgpk",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__255 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__256 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/3ec25277add5134701ef7ad0b3be803d.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a785g26awg0lj",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a785g26awg0lj",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__256 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__257 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/0f162a662772a6f92603b1be4b477973.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/172128abb9113c8xk0iu",
    linkOutApp: "https://novel.qingting.fm/novels/172128abb9113c8xk0iu",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__257 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const layoutConfig__258 = {
    wrap: false,
    horizontalCss: "flex-start",
    verticalCss: "items-stretch",
    commonStyle: {
      textAlign: null,
      height: null,
      overflow: null,
      background: {
        color: "transparent",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      borderRadius: null
    },
    positionStyle: {
      position: "relative",
      type: "px",
      top: null,
      bottom: null,
      left: null,
      right: null
    },
    spacingStyle: {
      marginTop: null,
      marginBottom: null,
      marginLeft: null,
      marginRight: null
    }
  };
  const singleImage__259 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/93554a7c9bcb8f63eb1aa578add39987.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/17375e9b062p8fybn6ci",
    linkOutApp: "https://novel.qingting.fm/novels/17375e9b062p8fybn6ci",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__259 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__260 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/4d17ee29d99e3078418de2ce6b43f55a.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/16f54d2a7b5g26yahtvw",
    linkOutApp: "https://novel.qingting.fm/novels/16f54d2a7b5g26yahtvw",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__260 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__261 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/ef0c0dc004aa61ca9adf6e5eee63d4a8.png",
    link: "",
    linkInApp: "https://novel.qingting.fm/novels/17186e22c2db6vo85q8p",
    linkOutApp: "https://novel.qingting.fm/novels/17186e22c2db6vo85q8p",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: true
  };
  const imageContainerStyle__261 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__262 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/2519e83bc90a092dbe149ccdcbac1945.jpg",
    link: "",
    linkInApp: "",
    linkOutApp: " ",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__262 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const singleImage__263 = {
    src: "https://sss.qingting.fm/bp/5f3a3baf3262e283fb9dec3c/image/c9912bd5082975f81b70a5ac2f865e49.jpg",
    link: "",
    linkInApp: "http://sss.qingting.fm/super-vip-rights/build/index.html?source=home_supervip_icon_content",
    linkOutApp: "http://sss.qingting.fm/super-vip-rights/build/index.html?source=home_supervip_icon_content",
    isCenter: true,
    widthType: "percent",
    width: 100,
    openLazyload: false,
    openExpose: false,
    openNewWebview: false
  };
  const imageContainerStyle__263 = {
    marginTop: null,
    marginBottom: null,
    marginLeft: null,
    marginRight: null,
    position: "relative",
    top: null,
    bottom: null,
    left: null,
    right: null,
    zIndex: 1
  };
  const spaceLayoutConfig__264 = {
    common: {
      height: 80,
      cloneElementId: ""
    },
    styles: {
      background: {
        color: "#ca0000",
        image: "",
        repeat: "no-repeat",
        size: "auto"
      },
      position: "relative",
      top: null
    }
  };
  const envController__265 = {
    env: "all",
    operation: "allow",
    version: "8.8.0",
    comparison: "isGreaterOrEqual",
    versionEnv: "inIosApp",
    versionOperation: "deny"
  };
  const commonStyle__266 = {
    backgroundImage: customStyle__266.bgImg ? `url(${customStyle__266.bgImg})` : customStyle__266.hasGradient ? `linear-gradient(${customStyle__266.gradientDeg}deg, ${customStyle__266.bgColor}, ${customStyle__266.bgColor2})` : 'none',
    backgroundSize: 'cover',
    backgroundColor: customStyle__266.bgColor,
    backgroundRepeat: 'no-repeat',
    zIndex: customStyle__266.zIndex,
    aspectRatio: customStyle__266.aspectRatio
  };
  const style__266 = {
    top: {
      height: customStyle__266.height + unit
    },
    bottom: {
      height: customStyle__266.height + unit
    },
    left: {
      top: customStyle__266.top + unit,
      width: customStyle__266.width + unit,
      height: customStyle__266.height + unit
    },
    right: {
      top: customStyle__266.top + unit,
      width: customStyle__266.width + unit,
      height: customStyle__266.height + unit
    }
  };
  const style__267 = {
    backgroundImage: `url(${btnStyle__267.bgImg})`,
    backgroundColor: btnStyle__267.bgColor,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
    color: btnStyle__267.color,
    fontSize: btnStyle__267.fontSize + btnStyle__267.unit,
    margin: '0 auto',
    width: btnStyle__267.width + btnStyle__267.unit,
    height: btnStyle__267.height + btnStyle__267.unit,
    lineHeight: btnStyle__267.height + btnStyle__267.unit,
    borderRadius: btnStyle__267.height / 2 + btnStyle__267.unit,
    textAlign: 'center',
    position: btnStyle__267.isAbsolute ? 'absolute' : 'relative',
    animation: btnStyle__267.hasAnimation ? `buy-button-breath 1s infinite` : null
  };
  const abStyle__267 = {
    top: btnStyle__267.top + btnStyle__267.unit,
    left: btnStyle__267.left + btnStyle__267.unit,
    right: btnStyle__267.right + btnStyle__267.unit,
    bottom: btnStyle__267.bottom + btnStyle__267.unit
  };
  const reStyle__267 = {
    marginTop: btnStyle__267.top + btnStyle__267.unit,
    marginBottom: btnStyle__267.bottom + btnStyle__267.unit,
    marginLeft: btnStyle__267.left + btnStyle__267.unit,
    marginRight: btnStyle__267.right + btnStyle__267.unit
  };
  return <ContainerRender id="857" nodeId="93a35833-a42e-4c50-b747-d8f98939d857" nodeType="component-container" containerConfig={containerConfig} basicConfig={basicConfig}><TimeController id="d0e" nodeId="f28e1074-8d85-417f-b6be-9fae177f3d0e" nodeType="time-controller" config={timeController}><EnvController id="9cd" nodeId="6938d029-b4a9-4898-957a-5a71544bd9cd" nodeType="env-controller" config={envController}><SingleImage id="61d" nodeId="96b61e22-ee3e-4a55-9009-54db40dc061d" nodeType="image" config={singleImage} containerStyle={imageContainerStyle}><RenderRule id="892" nodeId="19178b26-ab56-4b50-95e2-1c7214c6e892" nodeType="fixed-rule" basicConfig={basicConfig__4}></RenderRule><ImageLink id="b8f" nodeId="0b829a3b-f0de-44bb-a620-70e891230b8f" nodeType="image-link" imageArchor={imageArchor}></ImageLink></SingleImage><SingleImage id="9dc" nodeId="f46553e8-2037-4f68-994a-bb827cbac9dc" nodeType="image" config={singleImage__6} containerStyle={imageContainerStyle__6}><ImageLink id="0b3" nodeId="d5b65e3b-37f1-4f12-a779-aa8fc828a0b3" nodeType="image-link" imageArchor={imageArchor__7}></ImageLink><ModalSlide id="919" nodeId="ec85b176-9498-40d9-8b1b-4868f2f68919" nodeType="modal-slid" row={row} picConfig={picConfig} cornerConfig={cornerConfig} wholeConfig={wholeConfig} Modal={Modal}></ModalSlide><BaseLayout id="1a0" nodeId="3ae6873f-e596-458c-9f8e-0bb00a0b61a0" nodeType="base-layout" config={baseLayoutConfig}><BuyButton id="85b" nodeId="9902ef7c-6a52-4ce9-ab89-4d07b732185b" nodeType="buy-button" productId={productId} btnStyle={btnStyle.isAbsolute ? { ...style,
              ...abStyle
            } : { ...style,
              ...reStyle
            }} options={options}></BuyButton></BaseLayout></SingleImage><SingleImage id="9ef" nodeId="a1c00f3a-c86d-4601-8051-5e8b1048d9ef" nodeType="image" config={singleImage__11} containerStyle={imageContainerStyle__11}><RenderCountDown id="273" nodeId="7b45cc55-e68f-47aa-b750-5c3513abe273" nodeType="countdown" basicConfig={basicConfig__12}></RenderCountDown></SingleImage><RenderReserve id="87c" nodeId="b0124fb6-207c-48ce-b3f9-9a3d03bc087c" nodeType="reserve" styleConfig={styleConfig} basicConfig={basicConfig__13}></RenderReserve><SingleImage id="01e" nodeId="ee658f3c-77dd-448a-92d2-738eb77af01e" nodeType="image" config={singleImage__14} containerStyle={imageContainerStyle__14}><BaseLayout id="1eb" nodeId="587b8496-c68b-4ec0-96cf-f658a5e271eb" nodeType="base-layout" config={baseLayoutConfig__15}><TabNavsContainer id="74e" nodeId="bd9122a1-79d1-43a8-8981-0be51a56874e" nodeType="tab-navs" navs={tabNavs} config={tabNavsConfig}><SingleImage id="ba8" nodeId="9a4384cb-c612-4317-b5d2-da6651525ba8" nodeType="image" config={singleImage__17} containerStyle={imageContainerStyle__17}></SingleImage><SingleImage id="9b1" nodeId="aec3de35-874e-4d9d-84f9-71985944b9b1" nodeType="image" config={singleImage__18} containerStyle={imageContainerStyle__18}></SingleImage><SingleImage id="722" nodeId="5b0b58f8-9f3d-4ef6-bd40-8aea3582c722" nodeType="image" config={singleImage__19} containerStyle={imageContainerStyle__19}></SingleImage><SingleImage id="615" nodeId="98bd6c5f-e2c3-4981-902f-273427ccb615" nodeType="image" config={singleImage__20} containerStyle={imageContainerStyle__20}></SingleImage><SingleImage id="532" nodeId="1e52b527-a5a1-4587-9e9b-ca9e7e9af532" nodeType="image" config={singleImage__21} containerStyle={imageContainerStyle__21}></SingleImage><SingleImage id="045" nodeId="6d376b89-6fce-4aff-a931-a55904aad045" nodeType="image" config={singleImage__22} containerStyle={imageContainerStyle__22}></SingleImage></TabNavsContainer></BaseLayout></SingleImage></EnvController><EnvController id="539" nodeId="ae7e0b4e-88fb-450e-9b83-3eb82af04539" nodeType="env-controller" config={envController__23}><SingleImage id="a86" nodeId="c9b42de2-53bb-4c58-adea-ea35c2a54a86" nodeType="image" config={singleImage__24} containerStyle={imageContainerStyle__24}></SingleImage><SingleImage id="5bf" nodeId="db068a35-f275-45fe-be16-449d1fe9d5bf" nodeType="image" config={singleImage__25} containerStyle={imageContainerStyle__25}></SingleImage></EnvController><SingleImage id="992" nodeId="b304b1d4-0b6a-40f3-93b1-76ff2f598992" nodeType="image" config={singleImage__26} containerStyle={imageContainerStyle__26}><MemberDraw id="4e4" nodeId="20d8bfc9-89f3-407d-99a0-fc19815424e4" nodeType="rotary-draw" {...config} threeParty={{
          jscookie,
          linkedme: window.linkedme,
          LotteryGrid,
          Toast,
          Modal,
          qtWebLog,
          qt,
          wxShare
        }}></MemberDraw><RenderShare id="ac9" nodeId="5a3c4621-0352-4c9c-a18a-43895c175ac9" nodeType="fixed-share" basicConfig={basicConfig__28}></RenderShare></SingleImage><SingleImage id="1a2" nodeId="4c291f2e-79f0-4ee0-bfd0-2383b34831a2" nodeType="image" config={singleImage__29} containerStyle={imageContainerStyle__29}><SingleImage id="975" nodeId="2f191878-e7d3-4558-be5f-64536ae5c975" nodeType="image" config={singleImage__30} containerStyle={imageContainerStyle__30}></SingleImage><SingleImage id="6e8" nodeId="065e400e-e5a5-47ce-877c-df9503c986e8" nodeType="image" config={singleImage__31} containerStyle={imageContainerStyle__31}></SingleImage><SingleImage id="ea3" nodeId="0ab176b5-2507-44e9-be9f-eacf5917eea3" nodeType="image" config={singleImage__32} containerStyle={imageContainerStyle__32}></SingleImage></SingleImage><SingleImage id="3e5" nodeId="a36393b8-77f8-4647-8400-20d0b66873e5" nodeType="image" config={singleImage__33} containerStyle={imageContainerStyle__33}></SingleImage><BaseLayout id="89d" nodeId="921e1f6a-ff88-4c16-86f5-a6af773bb89d" nodeType="base-layout" config={baseLayoutConfig__34}><TabNavsContainer__35 id="1e3" nodeId="c9bfabb4-9666-4062-9db9-60217bb281e3" nodeType="tab-navs" navs={tabNavs__35} config={tabNavsConfig__35}><BaseLayout id="5fc" nodeId="f6a4ebe4-53f5-4917-8333-641af5b855fc" nodeType="base-layout" config={baseLayoutConfig__36}><HorizontalLayout id="c49" nodeId="ca614e92-ffec-47a4-b8c6-3b57cff88c49" nodeType="horizontal-layout" config={layoutConfig}><SingleImage id="0a6" nodeId="74249d9d-bd24-4b24-9083-ab98170660a6" nodeType="image" config={singleImage__38} containerStyle={imageContainerStyle__38}></SingleImage><SingleImage id="5d7" nodeId="ed98c8dd-514e-4fb7-872a-eb0f884df5d7" nodeType="image" config={singleImage__39} containerStyle={imageContainerStyle__39}></SingleImage><SingleImage id="cba" nodeId="b04c6c3f-00e1-4b00-8dae-79197346bcba" nodeType="image" config={singleImage__40} containerStyle={imageContainerStyle__40}></SingleImage></HorizontalLayout><HorizontalLayout id="454" nodeId="4114f381-8315-4589-ac7d-6c418e567454" nodeType="horizontal-layout" config={layoutConfig__41}><SingleImage id="570" nodeId="ef478426-5284-4b02-850a-34d253442570" nodeType="image" config={singleImage__42} containerStyle={imageContainerStyle__42}></SingleImage><SingleImage id="0fd" nodeId="af0c053c-4c51-407c-bc5d-e45c38d150fd" nodeType="image" config={singleImage__43} containerStyle={imageContainerStyle__43}></SingleImage><SingleImage id="f63" nodeId="a65cca07-c94b-436c-923d-6208b6ad8f63" nodeType="image" config={singleImage__44} containerStyle={imageContainerStyle__44}></SingleImage></HorizontalLayout></BaseLayout><SingleImage id="f02" nodeId="8eddb123-3775-4ac4-9b1f-36ff099e6f02" nodeType="image" config={singleImage__45} containerStyle={imageContainerStyle__45}></SingleImage><BaseLayout id="754" nodeId="97815f2b-4626-4f7d-99ac-0ac2cfebe754" nodeType="base-layout" config={baseLayoutConfig__46}><HorizontalLayout id="b78" nodeId="e3d1c4a6-bae1-4d4b-acfd-054cc4276b78" nodeType="horizontal-layout" config={layoutConfig__47}><SingleImage id="478" nodeId="3ec9c5e2-3b48-432b-a39e-714617119478" nodeType="image" config={singleImage__48} containerStyle={imageContainerStyle__48}></SingleImage><SingleImage id="81d" nodeId="5b7a5e47-3d8f-45a7-a508-e94189bcc81d" nodeType="image" config={singleImage__49} containerStyle={imageContainerStyle__49}></SingleImage><SingleImage id="fd1" nodeId="dc8231ca-7135-4310-be7a-3f1d1a650fd1" nodeType="image" config={singleImage__50} containerStyle={imageContainerStyle__50}></SingleImage></HorizontalLayout><HorizontalLayout id="e0f" nodeId="307130c7-fef3-4fdd-8d5c-57c18b265e0f" nodeType="horizontal-layout" config={layoutConfig__51}><SingleImage id="334" nodeId="da4fe5c3-d10f-4e77-abed-246b342d0334" nodeType="image" config={singleImage__52} containerStyle={imageContainerStyle__52}></SingleImage><SingleImage id="880" nodeId="11709958-6ab0-4ca3-b081-6772e9535880" nodeType="image" config={singleImage__53} containerStyle={imageContainerStyle__53}></SingleImage><SingleImage id="587" nodeId="59c46a9b-6ea5-46a5-9882-4f6e12fd6587" nodeType="image" config={singleImage__54} containerStyle={imageContainerStyle__54}></SingleImage></HorizontalLayout></BaseLayout><BaseLayout id="2c0" nodeId="6c5904db-7669-444b-8c45-9293f844e2c0" nodeType="base-layout" config={baseLayoutConfig__55}><HorizontalLayout id="253" nodeId="58828a62-7284-4f3b-8c92-4ead47ba2253" nodeType="horizontal-layout" config={layoutConfig__56}><SingleImage id="926" nodeId="f2537418-9ee3-4bae-a570-2f763b9d8926" nodeType="image" config={singleImage__57} containerStyle={imageContainerStyle__57}></SingleImage><SingleImage id="840" nodeId="37341b8e-16c1-46fb-8320-f63e17f91840" nodeType="image" config={singleImage__58} containerStyle={imageContainerStyle__58}></SingleImage><SingleImage id="b87" nodeId="27f7f137-573c-4ece-8e9e-264fb98e9b87" nodeType="image" config={singleImage__59} containerStyle={imageContainerStyle__59}></SingleImage></HorizontalLayout><HorizontalLayout id="da2" nodeId="83df6545-1a5c-4975-b75f-497db62dcda2" nodeType="horizontal-layout" config={layoutConfig__60}><SingleImage id="2ef" nodeId="cdc89d1a-6a4a-4237-a60c-18da5646a2ef" nodeType="image" config={singleImage__61} containerStyle={imageContainerStyle__61}></SingleImage><SingleImage id="215" nodeId="fd435d7f-ecf1-4ef5-8ab7-51f47bdac215" nodeType="image" config={singleImage__62} containerStyle={imageContainerStyle__62}></SingleImage><SingleImage id="5eb" nodeId="b962f3f0-24b7-4ad2-8503-99f1a9c4e5eb" nodeType="image" config={singleImage__63} containerStyle={imageContainerStyle__63}></SingleImage></HorizontalLayout></BaseLayout></TabNavsContainer__35></BaseLayout><SingleImage id="207" nodeId="5bc37693-e530-47a7-acf5-f6e2a334c207" nodeType="image" config={singleImage__64} containerStyle={imageContainerStyle__64}><BaseLayout id="f6d" nodeId="9eacde52-837c-48d7-95f9-c35853a16f6d" nodeType="base-layout" config={baseLayoutConfig__65}><TabNavsContainer__66 id="46e" nodeId="da3d051a-0cb2-4ba2-8c39-073e71b9846e" nodeType="tab-navs" navs={tabNavs__66} config={tabNavsConfig__66}><BaseLayout id="8c0" nodeId="9d3cd0f7-10ce-406b-8097-9020d3e368c0" nodeType="base-layout" config={baseLayoutConfig__67}><SingleImage id="ef4" nodeId="16177b3e-8af9-4e2a-911a-6903bdbd1ef4" nodeType="image" config={singleImage__68} containerStyle={imageContainerStyle__68}></SingleImage><SingleImage id="5a1" nodeId="ebf67257-e34d-4f25-9a83-61fc854e95a1" nodeType="image" config={singleImage__69} containerStyle={imageContainerStyle__69}></SingleImage><SingleImage id="20d" nodeId="26337b82-a099-490f-86a1-a3f98fdc520d" nodeType="image" config={singleImage__70} containerStyle={imageContainerStyle__70}></SingleImage><SingleImage id="41c" nodeId="3c3dd706-3a54-4b38-b53b-6df8cefe041c" nodeType="image" config={singleImage__71} containerStyle={imageContainerStyle__71}></SingleImage></BaseLayout><BaseLayout id="749" nodeId="65bb2e39-d65a-415f-adf4-e78211092749" nodeType="base-layout" config={baseLayoutConfig__72}><SingleImage id="d94" nodeId="092e32bb-d46a-45e3-a38f-bd63e7355d94" nodeType="image" config={singleImage__73} containerStyle={imageContainerStyle__73}></SingleImage><SingleImage id="a3c" nodeId="3bc2802f-9b5c-443c-855b-07f8a9727a3c" nodeType="image" config={singleImage__74} containerStyle={imageContainerStyle__74}></SingleImage><SingleImage id="649" nodeId="3089d6e7-6b0a-4161-852f-8b5edc627649" nodeType="image" config={singleImage__75} containerStyle={imageContainerStyle__75}></SingleImage><SingleImage id="b30" nodeId="06838be0-679d-4b85-8790-e8af029dbb30" nodeType="image" config={singleImage__76} containerStyle={imageContainerStyle__76}></SingleImage></BaseLayout><BaseLayout id="9ae" nodeId="21e2f9bb-7778-466e-9bcc-37b1d5d449ae" nodeType="base-layout" config={baseLayoutConfig__77}><SingleImage id="e33" nodeId="0f1a5740-fe17-4d3f-9572-a31f954eee33" nodeType="image" config={singleImage__78} containerStyle={imageContainerStyle__78}></SingleImage><SingleImage id="b74" nodeId="b6444ed8-9edb-4957-ac07-4eea6e1beb74" nodeType="image" config={singleImage__79} containerStyle={imageContainerStyle__79}></SingleImage><SingleImage id="047" nodeId="cba4307d-2bae-40fe-9f80-b31269d46047" nodeType="image" config={singleImage__80} containerStyle={imageContainerStyle__80}></SingleImage><SingleImage id="785" nodeId="b1515e98-1934-4270-9ae6-2c2a8b13b785" nodeType="image" config={singleImage__81} containerStyle={imageContainerStyle__81}></SingleImage></BaseLayout><BaseLayout id="435" nodeId="1b74f33d-7c9e-45de-adce-23f7039a6435" nodeType="base-layout" config={baseLayoutConfig__82}><SingleImage id="bc7" nodeId="0ad9c2fd-ca87-49ee-be23-06e90a27cbc7" nodeType="image" config={singleImage__83} containerStyle={imageContainerStyle__83}></SingleImage><SingleImage id="997" nodeId="f9e1ac41-f89f-4c30-806a-bc7f03911997" nodeType="image" config={singleImage__84} containerStyle={imageContainerStyle__84}></SingleImage><SingleImage id="19f" nodeId="94063481-5b0a-4729-9b4b-cb54c0ccc19f" nodeType="image" config={singleImage__85} containerStyle={imageContainerStyle__85}></SingleImage><SingleImage id="5ba" nodeId="dfcca706-671b-47d3-83a2-023e196be5ba" nodeType="image" config={singleImage__86} containerStyle={imageContainerStyle__86}></SingleImage></BaseLayout></TabNavsContainer__66></BaseLayout></SingleImage><SingleImage id="d8f" nodeId="ad1c5bd3-0500-4ab6-9b1e-ded50eea3d8f" nodeType="image" config={singleImage__87} containerStyle={imageContainerStyle__87}></SingleImage><BaseLayout id="bc8" nodeId="2d20302e-297d-4553-8a4c-7b86363f5bc8" nodeType="base-layout" config={baseLayoutConfig__88}><TabNavsContainer__89 id="23b" nodeId="87e30b49-8b08-4ffc-af90-f486d1ddb23b" nodeType="tab-navs" navs={tabNavs__89} config={tabNavsConfig__89}><BaseLayout id="6a6" nodeId="6bcb762c-69a7-48c5-9eec-25b3488756a6" nodeType="base-layout" config={baseLayoutConfig__90}><HorizontalLayout id="8bb" nodeId="6461a910-f7e4-4103-a0a9-b51d31f5c8bb" nodeType="horizontal-layout" config={layoutConfig__91}><SingleImage id="67c" nodeId="7fbd12d3-3bf2-44ce-bd29-a8df1279267c" nodeType="image" config={singleImage__92} containerStyle={imageContainerStyle__92}></SingleImage><SingleImage id="683" nodeId="6bb5b2a6-4792-49a1-b14a-1ab0e0d14683" nodeType="image" config={singleImage__93} containerStyle={imageContainerStyle__93}></SingleImage><SingleImage id="557" nodeId="0311c05e-195b-4834-ac4c-a9e7041de557" nodeType="image" config={singleImage__94} containerStyle={imageContainerStyle__94}></SingleImage></HorizontalLayout><HorizontalLayout id="3b7" nodeId="8b888b01-72eb-43d0-b315-a821e2c993b7" nodeType="horizontal-layout" config={layoutConfig__95}><SingleImage id="45e" nodeId="705318ed-6f59-4ee7-8c9d-622ca51fa45e" nodeType="image" config={singleImage__96} containerStyle={imageContainerStyle__96}></SingleImage><SingleImage id="764" nodeId="5fad0295-d5d3-4f78-856c-e6f8d9f27764" nodeType="image" config={singleImage__97} containerStyle={imageContainerStyle__97}></SingleImage><SingleImage id="d05" nodeId="3ef2001d-bd13-4345-857e-b189e316bd05" nodeType="image" config={singleImage__98} containerStyle={imageContainerStyle__98}></SingleImage></HorizontalLayout></BaseLayout><BaseLayout id="8a5" nodeId="404f99d7-5813-4ac5-a158-b009a34688a5" nodeType="base-layout" config={baseLayoutConfig__99}><HorizontalLayout id="c11" nodeId="f9694668-220e-4e65-affd-acbe57fefc11" nodeType="horizontal-layout" config={layoutConfig__100}><SingleImage id="8be" nodeId="906c1520-5512-4aa4-8327-cfd26c95b8be" nodeType="image" config={singleImage__101} containerStyle={imageContainerStyle__101}></SingleImage><SingleImage id="783" nodeId="81960044-2671-4862-b77c-cc91f0948783" nodeType="image" config={singleImage__102} containerStyle={imageContainerStyle__102}></SingleImage><SingleImage id="b74" nodeId="40db342e-e572-4c55-b54e-1016b7470b74" nodeType="image" config={singleImage__103} containerStyle={imageContainerStyle__103}></SingleImage></HorizontalLayout><HorizontalLayout id="330" nodeId="dece15da-ec94-4614-8726-8e51f5082330" nodeType="horizontal-layout" config={layoutConfig__104}><SingleImage id="4c4" nodeId="2610c296-d14c-4d85-bb45-1615aa8334c4" nodeType="image" config={singleImage__105} containerStyle={imageContainerStyle__105}></SingleImage><SingleImage id="70a" nodeId="dc44f43e-8e6d-41b7-aa1e-40069a69770a" nodeType="image" config={singleImage__106} containerStyle={imageContainerStyle__106}></SingleImage><SingleImage id="23f" nodeId="43d70362-5dde-4e3f-8f71-3408e1ee123f" nodeType="image" config={singleImage__107} containerStyle={imageContainerStyle__107}></SingleImage></HorizontalLayout></BaseLayout><BaseLayout id="751" nodeId="0315943e-1b6a-442b-999d-4492e6ba6751" nodeType="base-layout" config={baseLayoutConfig__108}><HorizontalLayout id="b6a" nodeId="e2677e89-b420-4a5e-a93d-a4b46d6aeb6a" nodeType="horizontal-layout" config={layoutConfig__109}><SingleImage id="58e" nodeId="0eef86b9-89bf-448e-9512-f7b9e154158e" nodeType="image" config={singleImage__110} containerStyle={imageContainerStyle__110}></SingleImage><SingleImage id="394" nodeId="41d739f0-cfd1-4283-9300-f37e410e2394" nodeType="image" config={singleImage__111} containerStyle={imageContainerStyle__111}></SingleImage><SingleImage id="097" nodeId="f25b358e-1442-4d54-96e8-234268e7b097" nodeType="image" config={singleImage__112} containerStyle={imageContainerStyle__112}></SingleImage></HorizontalLayout><HorizontalLayout id="74b" nodeId="551cf3b1-7818-4e3d-bfca-faacf6b4474b" nodeType="horizontal-layout" config={layoutConfig__113}><SingleImage id="0a4" nodeId="868c9f19-c8f0-4c75-88c9-a48251f290a4" nodeType="image" config={singleImage__114} containerStyle={imageContainerStyle__114}></SingleImage><SingleImage id="cd4" nodeId="f3067f74-ee8a-4565-baa7-5274b431fcd4" nodeType="image" config={singleImage__115} containerStyle={imageContainerStyle__115}></SingleImage><SingleImage id="647" nodeId="46aee2c5-ce7c-4e8a-9a97-bf9a9de9a647" nodeType="image" config={singleImage__116} containerStyle={imageContainerStyle__116}></SingleImage></HorizontalLayout></BaseLayout><BaseLayout id="f01" nodeId="5d27f44a-4ba1-4d37-af9f-c1df0015bf01" nodeType="base-layout" config={baseLayoutConfig__117}><HorizontalLayout id="863" nodeId="67caa9a7-9d4c-4a3f-bc4f-1cc42b612863" nodeType="horizontal-layout" config={layoutConfig__118}><SingleImage id="959" nodeId="7071b723-85ef-4cb0-a430-b09623b46959" nodeType="image" config={singleImage__119} containerStyle={imageContainerStyle__119}></SingleImage><SingleImage id="449" nodeId="4cadcf65-c6b5-41f3-9242-e3c1d83e1449" nodeType="image" config={singleImage__120} containerStyle={imageContainerStyle__120}></SingleImage><SingleImage id="5a0" nodeId="33ea5af3-f11e-444c-b79b-178ea999f5a0" nodeType="image" config={singleImage__121} containerStyle={imageContainerStyle__121}></SingleImage></HorizontalLayout><HorizontalLayout id="045" nodeId="47c0f1f3-27b3-4a79-823f-3b2faae62045" nodeType="horizontal-layout" config={layoutConfig__122}><SingleImage id="649" nodeId="85178ab5-31a2-4899-a866-44bf771ca649" nodeType="image" config={singleImage__123} containerStyle={imageContainerStyle__123}></SingleImage><SingleImage id="d0d" nodeId="9ac8013c-ec0e-4843-9dc7-f9cd8ed6ad0d" nodeType="image" config={singleImage__124} containerStyle={imageContainerStyle__124}></SingleImage><SingleImage id="30b" nodeId="c8bffb04-a315-4cf0-92f8-7060b977830b" nodeType="image" config={singleImage__125} containerStyle={imageContainerStyle__125}></SingleImage></HorizontalLayout></BaseLayout></TabNavsContainer__89></BaseLayout><SingleImage id="e81" nodeId="87229c4f-2df2-4ad9-a4bc-50456150ee81" nodeType="image" config={singleImage__126} containerStyle={imageContainerStyle__126}></SingleImage><SingleImage id="4cb" nodeId="46aeab5f-2417-4a1f-a5aa-a6e811a1f4cb" nodeType="image" config={singleImage__127} containerStyle={imageContainerStyle__127}></SingleImage><SpaceLayout id="a33" nodeId="530e2ca5-aee6-4f0a-830b-e489d605ea33" nodeType="space-layout" config={spaceLayoutConfig}></SpaceLayout><EnvController id="920" nodeId="cc1f05e2-6c11-46dc-8439-7ba26f18b920" nodeType="env-controller" config={envController__129}><FixedBar id="50b" nodeId="59362096-d3cb-47f2-aa2e-51fabc06250b" nodeType="fixed-bar" position={position} customStyle={Object.assign(commonStyle, style__130[position])} effects={effects} effectParam={effectParam}><BuyButton__131 id="864" nodeId="3ca4dad4-54af-4065-a92c-90aadab4d864" nodeType="buy-button" productId={productId__131} btnStyle={btnStyle__131.isAbsolute ? { ...style__131,
            ...abStyle__131
          } : { ...style__131,
            ...reStyle__131
          }} options={options__131}></BuyButton__131></FixedBar></EnvController></TimeController><TimeController id="802" nodeId="dc694aca-2c37-4b77-9e18-bd0454d98802" nodeType="time-controller" config={timeController__132}><BaseLayout id="d92" nodeId="8a243856-806e-4b40-8495-b367d86d5d92" nodeType="base-layout" config={baseLayoutConfig__133}><EnvController id="91d" nodeId="69828bf4-f4b8-432a-80c3-a7695b4ca91d" nodeType="env-controller" config={envController__134}><SingleImage id="e06" nodeId="3d033c0f-0276-4c46-b16f-987abe943e06" nodeType="image" config={singleImage__135} containerStyle={imageContainerStyle__135}><RenderCountDown id="3ab" nodeId="292a0026-4814-45bd-baf6-857ded4d73ab" nodeType="countdown" basicConfig={basicConfig__136}></RenderCountDown><TopicMarquee id="3c7" nodeId="d4d09a2d-be43-42de-b15b-d74c0cd113c7" nodeType="topic-marquee" config={marqueeConfig}></TopicMarquee><ImageLink id="b27" nodeId="cb9dadfa-9e01-4a13-9fb1-61d8810f8b27" nodeType="image-link" imageArchor={imageArchor__138}></ImageLink><RenderRule__139 id="9ef" nodeId="bfe198a5-49f3-45ee-b6c1-e8bbe52b19ef" nodeType="fixed-rule" basicConfig={basicConfig__139}></RenderRule__139></SingleImage><SingleImage id="a37" nodeId="255dac12-65ec-4076-82a7-cb9697525a37" nodeType="image" config={singleImage__140} containerStyle={imageContainerStyle__140}><ModalSlide id="2f0" nodeId="a4d2936f-e719-4507-922d-da64696212f0" nodeType="modal-slid" row={row__141} picConfig={picConfig__141} cornerConfig={cornerConfig__141} wholeConfig={wholeConfig__141} Modal={Modal}></ModalSlide><BaseLayout id="975" nodeId="686decf6-d3f4-4449-94a2-60e86410f975" nodeType="base-layout" config={baseLayoutConfig__142}><BuyButton__143 id="cec" nodeId="d84248ae-0770-4d9b-98db-b73cb0335cec" nodeType="buy-button" productId={productId__143} btnStyle={btnStyle__143.isAbsolute ? { ...style__143,
                ...abStyle__143
              } : { ...style__143,
                ...reStyle__143
              }} options={options__143}></BuyButton__143></BaseLayout></SingleImage></EnvController><EnvController id="5c8" nodeId="53d9cf1c-304d-4e3a-9d76-b37069d415c8" nodeType="env-controller" config={envController__144}><SingleImage id="c0c" nodeId="b0805574-f441-468d-bfd5-208d29582c0c" nodeType="image" config={singleImage__145} containerStyle={imageContainerStyle__145}></SingleImage><SingleImage id="4b3" nodeId="e5362fbb-6542-4186-9628-1bb538d2c4b3" nodeType="image" config={singleImage__146} containerStyle={imageContainerStyle__146}></SingleImage><SingleImage id="7b9" nodeId="4b6d51cb-5fc9-4163-a0e1-960112d9f7b9" nodeType="image" config={singleImage__147} containerStyle={imageContainerStyle__147}></SingleImage></EnvController><SingleImage id="302" nodeId="69b6b655-1ce3-445e-a60b-da1b04152302" nodeType="image" config={singleImage__148} containerStyle={imageContainerStyle__148}><MemberDraw id="9ec" nodeId="b980b95d-3739-4e21-9b06-7429773f79ec" nodeType="rotary-draw" {...config__149} threeParty={{
            jscookie,
            linkedme: window.linkedme,
            LotteryGrid,
            Toast,
            Modal,
            qtWebLog,
            qt,
            wxShare
          }}></MemberDraw><TimeController id="515" nodeId="1b68ef41-fda1-476e-9a3b-28dbbc1f5515" nodeType="time-controller" config={timeController__150}><RenderShare id="aab" nodeId="43e4b9e9-2b2f-453d-bac8-90e3ef42eaab" nodeType="fixed-share" basicConfig={basicConfig__151}></RenderShare></TimeController></SingleImage><SingleImage id="909" nodeId="20acfc03-4093-4a57-91dc-48144a996909" nodeType="image" config={singleImage__152} containerStyle={imageContainerStyle__152}><BaseLayout id="254" nodeId="fbf5be24-1cd9-4c64-aac4-f07e2b973254" nodeType="base-layout" config={baseLayoutConfig__153}><TabNavsContainer__154 id="622" nodeId="5df7f4c6-3c75-40da-a357-abd0e76a9622" nodeType="tab-navs" navs={tabNavs__154} config={tabNavsConfig__154}><SingleImage id="3f1" nodeId="46fffc5d-07db-42d7-b6b5-5e6acf6ab3f1" nodeType="image" config={singleImage__155} containerStyle={imageContainerStyle__155}></SingleImage><SingleImage id="490" nodeId="80555aa5-0e5b-4624-a25c-373f90c8f490" nodeType="image" config={singleImage__156} containerStyle={imageContainerStyle__156}></SingleImage><SingleImage id="126" nodeId="d3fe0bbe-5c10-49af-a3e9-2a8a8d93c126" nodeType="image" config={singleImage__157} containerStyle={imageContainerStyle__157}></SingleImage><SingleImage id="3e8" nodeId="f33c4cf5-0470-4f9d-bad3-09bbd38183e8" nodeType="image" config={singleImage__158} containerStyle={imageContainerStyle__158}></SingleImage><SingleImage id="ca7" nodeId="9f316bf7-3343-4c99-9bbd-3e58e08ebca7" nodeType="image" config={singleImage__159} containerStyle={imageContainerStyle__159}></SingleImage><SingleImage id="794" nodeId="6b3e61bc-2a7f-477b-a080-f4f69d4bb794" nodeType="image" config={singleImage__160} containerStyle={imageContainerStyle__160}></SingleImage><SingleImage id="aa0" nodeId="0d74f45e-0617-4e79-9973-b5d191888aa0" nodeType="image" config={singleImage__161} containerStyle={imageContainerStyle__161}></SingleImage><SingleImage id="bc3" nodeId="dd94028d-e77f-429a-924f-9af9f90dfbc3" nodeType="image" config={singleImage__162} containerStyle={imageContainerStyle__162}></SingleImage></TabNavsContainer__154></BaseLayout></SingleImage><SingleImage id="816" nodeId="b59fff99-34b6-4c8c-bd35-ee86e3d6c816" nodeType="image" config={singleImage__163} containerStyle={imageContainerStyle__163}></SingleImage><SingleImage id="83a" nodeId="4f7cdf6c-9c12-4e0e-8c83-2bf10c1ea83a" nodeType="image" config={singleImage__164} containerStyle={imageContainerStyle__164}><SingleImage id="5d9" nodeId="2ea6952c-62a9-4603-a283-5098d545e5d9" nodeType="image" config={singleImage__165} containerStyle={imageContainerStyle__165}></SingleImage><SingleImage id="74a" nodeId="13cbc7bf-b8c2-41c9-8a81-9174c561774a" nodeType="image" config={singleImage__166} containerStyle={imageContainerStyle__166}></SingleImage><SingleImage id="e6c" nodeId="5f0584c0-0878-40d2-871e-2a6d546e9e6c" nodeType="image" config={singleImage__167} containerStyle={imageContainerStyle__167}></SingleImage></SingleImage><SingleImage id="1f4" nodeId="04b68481-0e5d-4722-b17f-cc4d379291f4" nodeType="image" config={singleImage__168} containerStyle={imageContainerStyle__168}></SingleImage><BaseLayout id="742" nodeId="4315ff7c-6bbd-46d0-92d0-a67341f26742" nodeType="base-layout" config={baseLayoutConfig__169}><TabNavsContainer__170 id="6dc" nodeId="74d252bb-530b-41b3-8a83-5c324447d6dc" nodeType="tab-navs" navs={tabNavs__170} config={tabNavsConfig__170}><BaseLayout id="9e7" nodeId="08396f46-325d-48f2-a740-b38a276949e7" nodeType="base-layout" config={baseLayoutConfig__171}><HorizontalLayout id="f11" nodeId="36e5c866-6106-4def-ac04-b6deda23bf11" nodeType="horizontal-layout" config={layoutConfig__172}><SingleImage id="78b" nodeId="34ce8b13-43af-4ffb-9d24-4f2814bb278b" nodeType="image" config={singleImage__173} containerStyle={imageContainerStyle__173}></SingleImage><SingleImage id="020" nodeId="494816ed-928e-4dcf-a1ad-63eed747d020" nodeType="image" config={singleImage__174} containerStyle={imageContainerStyle__174}></SingleImage><SingleImage id="03a" nodeId="350dc21e-db2b-4c1c-88ff-28e3d608603a" nodeType="image" config={singleImage__175} containerStyle={imageContainerStyle__175}></SingleImage></HorizontalLayout><HorizontalLayout id="acb" nodeId="adc3b1c5-7047-4ddd-9e6e-dd7d11545acb" nodeType="horizontal-layout" config={layoutConfig__176}><SingleImage id="d2b" nodeId="6b5c87f1-73d5-42cb-bcba-cbb408fe6d2b" nodeType="image" config={singleImage__177} containerStyle={imageContainerStyle__177}></SingleImage><SingleImage id="06e" nodeId="0bfa40f3-8439-487e-800a-c2d5a817706e" nodeType="image" config={singleImage__178} containerStyle={imageContainerStyle__178}></SingleImage><SingleImage id="c94" nodeId="20f04b3f-e05c-4f15-aa1f-5eb759101c94" nodeType="image" config={singleImage__179} containerStyle={imageContainerStyle__179}></SingleImage></HorizontalLayout></BaseLayout><SingleImage id="e54" nodeId="02c55c85-54e9-4748-9f6c-3e3c01e73e54" nodeType="image" config={singleImage__180} containerStyle={imageContainerStyle__180}></SingleImage><BaseLayout id="e88" nodeId="b45c57fb-df76-45e6-8c11-9f152a3efe88" nodeType="base-layout" config={baseLayoutConfig__181}><HorizontalLayout id="c32" nodeId="4057f128-e186-4611-b592-b4d14bc5dc32" nodeType="horizontal-layout" config={layoutConfig__182}><SingleImage id="07a" nodeId="0d5912ca-b406-4d9f-9532-c22a7bf9707a" nodeType="image" config={singleImage__183} containerStyle={imageContainerStyle__183}></SingleImage><SingleImage id="9c9" nodeId="1181f8e4-4212-4ca6-810c-1d58b973d9c9" nodeType="image" config={singleImage__184} containerStyle={imageContainerStyle__184}></SingleImage><SingleImage id="7a4" nodeId="f9fb02ad-1ba8-493f-9691-cc50bd3e57a4" nodeType="image" config={singleImage__185} containerStyle={imageContainerStyle__185}></SingleImage></HorizontalLayout><HorizontalLayout id="bcf" nodeId="88a7cd18-1202-4c47-a38e-06285d151bcf" nodeType="horizontal-layout" config={layoutConfig__186}><SingleImage id="a4e" nodeId="bf113c5f-6845-4955-9711-9b8af11e3a4e" nodeType="image" config={singleImage__187} containerStyle={imageContainerStyle__187}></SingleImage><SingleImage id="27d" nodeId="c4c2c8c5-5d0f-4340-846a-c4e48b87b27d" nodeType="image" config={singleImage__188} containerStyle={imageContainerStyle__188}></SingleImage><SingleImage id="fdb" nodeId="1ca732bd-53e2-43aa-b1c0-9f5663f3cfdb" nodeType="image" config={singleImage__189} containerStyle={imageContainerStyle__189}></SingleImage></HorizontalLayout></BaseLayout><BaseLayout id="dd7" nodeId="2280db56-75da-4d97-a186-a576404c5dd7" nodeType="base-layout" config={baseLayoutConfig__190}><HorizontalLayout id="b4f" nodeId="ad42e9b1-f7fb-4b0b-b7a7-2420a73bbb4f" nodeType="horizontal-layout" config={layoutConfig__191}><SingleImage id="dbd" nodeId="c7188bef-feae-477c-8fd0-762fa7a03dbd" nodeType="image" config={singleImage__192} containerStyle={imageContainerStyle__192}></SingleImage><SingleImage id="200" nodeId="6ae7a667-e9a4-4607-afde-15e01651a200" nodeType="image" config={singleImage__193} containerStyle={imageContainerStyle__193}></SingleImage><SingleImage id="a62" nodeId="9242aace-18e8-4b17-804b-677f6d584a62" nodeType="image" config={singleImage__194} containerStyle={imageContainerStyle__194}></SingleImage></HorizontalLayout><HorizontalLayout id="cfb" nodeId="a45dff68-9747-48a6-b9f9-7723335e6cfb" nodeType="horizontal-layout" config={layoutConfig__195}><SingleImage id="a81" nodeId="eb4c1839-b596-48ca-8238-0b747bc8fa81" nodeType="image" config={singleImage__196} containerStyle={imageContainerStyle__196}></SingleImage><SingleImage id="43b" nodeId="d172d490-d2d0-4fc3-a226-22511871443b" nodeType="image" config={singleImage__197} containerStyle={imageContainerStyle__197}></SingleImage><SingleImage id="b0a" nodeId="23569fe3-e1f7-4986-bd54-a0a422115b0a" nodeType="image" config={singleImage__198} containerStyle={imageContainerStyle__198}></SingleImage></HorizontalLayout></BaseLayout></TabNavsContainer__170></BaseLayout><TimeController id="469" nodeId="7f723e65-918b-4a10-8f59-7ba2dba7d469" nodeType="time-controller" config={timeController__199}><SingleImage id="f92" nodeId="782cd5d3-7715-4d60-90b0-8ee66d5e7f92" nodeType="image" config={singleImage__200} containerStyle={imageContainerStyle__200}><BaseLayout id="612" nodeId="5c1bbc92-b6ee-44a7-a9b0-61203d540612" nodeType="base-layout" config={baseLayoutConfig__201}><TabNavsContainer__202 id="97a" nodeId="7b1f2e50-4734-4116-85bc-6fd43ea2a97a" nodeType="tab-navs" navs={tabNavs__202} config={tabNavsConfig__202}><BaseLayout id="c34" nodeId="4e8957da-31de-43bd-8c72-84aebfb1fc34" nodeType="base-layout" config={baseLayoutConfig__203}><SingleImage id="54f" nodeId="5b0b178d-a209-4f08-9de0-8c3c80c2354f" nodeType="image" config={singleImage__204} containerStyle={imageContainerStyle__204}></SingleImage><SingleImage id="624" nodeId="d52065ba-1462-4ffe-9a9c-c977cf1c8624" nodeType="image" config={singleImage__205} containerStyle={imageContainerStyle__205}></SingleImage><SingleImage id="3f0" nodeId="86256e5a-6fbf-4825-8619-375cd857e3f0" nodeType="image" config={singleImage__206} containerStyle={imageContainerStyle__206}></SingleImage><SingleImage id="a58" nodeId="b9658682-ba81-443b-908d-4f76e9e55a58" nodeType="image" config={singleImage__207} containerStyle={imageContainerStyle__207}></SingleImage></BaseLayout><BaseLayout id="744" nodeId="60a15fdd-14fd-4067-9471-cfc18cbd0744" nodeType="base-layout" config={baseLayoutConfig__208}><SingleImage id="cec" nodeId="97e5208f-cbbd-40fa-97cb-b463c6d16cec" nodeType="image" config={singleImage__209} containerStyle={imageContainerStyle__209}></SingleImage><SingleImage id="0cb" nodeId="f8f9a172-8f27-47a8-be9b-f522d81630cb" nodeType="image" config={singleImage__210} containerStyle={imageContainerStyle__210}></SingleImage><SingleImage id="fc0" nodeId="4a589376-ca56-4cd4-baa2-74442c4abfc0" nodeType="image" config={singleImage__211} containerStyle={imageContainerStyle__211}></SingleImage><SingleImage id="935" nodeId="4ca0dda2-773a-481b-b6b9-3411236f9935" nodeType="image" config={singleImage__212} containerStyle={imageContainerStyle__212}></SingleImage></BaseLayout><BaseLayout id="433" nodeId="39a792a9-e39e-4393-8aa8-c301e1237433" nodeType="base-layout" config={baseLayoutConfig__213}><SingleImage id="a16" nodeId="f5cf6d10-f5ed-4bba-a304-6c189531ea16" nodeType="image" config={singleImage__214} containerStyle={imageContainerStyle__214}></SingleImage><SingleImage id="c84" nodeId="a7907a13-8e7c-4884-a86e-09bcc9526c84" nodeType="image" config={singleImage__215} containerStyle={imageContainerStyle__215}></SingleImage><SingleImage id="7a0" nodeId="78a9ea6e-1d83-4328-b881-27450a1bc7a0" nodeType="image" config={singleImage__216} containerStyle={imageContainerStyle__216}></SingleImage><SingleImage id="ca4" nodeId="6110fe76-56cb-457b-b341-74fab6e70ca4" nodeType="image" config={singleImage__217} containerStyle={imageContainerStyle__217}></SingleImage></BaseLayout><BaseLayout id="ab3" nodeId="19c8b6af-ffbd-4956-8acb-0280791dfab3" nodeType="base-layout" config={baseLayoutConfig__218}><SingleImage id="9aa" nodeId="4c2c489d-22db-421e-a459-0a0240c559aa" nodeType="image" config={singleImage__219} containerStyle={imageContainerStyle__219}></SingleImage><SingleImage id="edc" nodeId="b06ee590-a0c2-43a2-bb5b-29f25e3f2edc" nodeType="image" config={singleImage__220} containerStyle={imageContainerStyle__220}></SingleImage><SingleImage id="1bb" nodeId="5f4acc50-b168-4a22-b962-553f97cb71bb" nodeType="image" config={singleImage__221} containerStyle={imageContainerStyle__221}></SingleImage><SingleImage id="cf1" nodeId="ae263491-2421-4034-95b0-a2c067571cf1" nodeType="image" config={singleImage__222} containerStyle={imageContainerStyle__222}></SingleImage></BaseLayout></TabNavsContainer__202></BaseLayout></SingleImage></TimeController><SingleImage id="47b" nodeId="db9458c2-7a23-4ace-80a0-f259263dd47b" nodeType="image" config={singleImage__223} containerStyle={imageContainerStyle__223}></SingleImage><BaseLayout id="275" nodeId="9a4a19ae-10e3-4b21-ab7b-150ab1c84275" nodeType="base-layout" config={baseLayoutConfig__224}><TabNavsContainer__225 id="3e5" nodeId="5c02d3c4-464f-4cce-a0f1-4a7e2b7d73e5" nodeType="tab-navs" navs={tabNavs__225} config={tabNavsConfig__225}><BaseLayout id="9e6" nodeId="a5c2dfc2-0d19-4dd9-b55f-3192003de9e6" nodeType="base-layout" config={baseLayoutConfig__226}><HorizontalLayout id="0b5" nodeId="a799fc8d-4ef5-4f12-8a59-f843d9bcb0b5" nodeType="horizontal-layout" config={layoutConfig__227}><SingleImage id="0ae" nodeId="0ec57003-6409-4cbb-8cfc-8239747900ae" nodeType="image" config={singleImage__228} containerStyle={imageContainerStyle__228}></SingleImage><SingleImage id="23a" nodeId="fc7021af-0c96-45fe-bf4b-0f94e70cd23a" nodeType="image" config={singleImage__229} containerStyle={imageContainerStyle__229}></SingleImage><SingleImage id="d61" nodeId="6b541b31-6538-4d21-92b7-afda65bfcd61" nodeType="image" config={singleImage__230} containerStyle={imageContainerStyle__230}></SingleImage></HorizontalLayout><HorizontalLayout id="d07" nodeId="fa0f2b34-d394-4a41-b893-18f2defffd07" nodeType="horizontal-layout" config={layoutConfig__231}><SingleImage id="965" nodeId="eeab644b-c344-443b-b1cd-58a0fee76965" nodeType="image" config={singleImage__232} containerStyle={imageContainerStyle__232}></SingleImage><SingleImage id="8c0" nodeId="ec71b6f4-b309-40eb-91a6-b11b3ed7f8c0" nodeType="image" config={singleImage__233} containerStyle={imageContainerStyle__233}></SingleImage><SingleImage id="8b4" nodeId="4ff53c97-c084-4d43-87b4-1db8203728b4" nodeType="image" config={singleImage__234} containerStyle={imageContainerStyle__234}></SingleImage></HorizontalLayout></BaseLayout><BaseLayout id="15a" nodeId="b7747a2e-f7de-44f4-81bb-24f8de1a915a" nodeType="base-layout" config={baseLayoutConfig__235}><HorizontalLayout id="26f" nodeId="33c0b9b7-6887-4683-8cfe-f3fc3ac8e26f" nodeType="horizontal-layout" config={layoutConfig__236}><SingleImage id="592" nodeId="33e7678c-0316-4f0a-a90e-8e8a282f1592" nodeType="image" config={singleImage__237} containerStyle={imageContainerStyle__237}></SingleImage><SingleImage id="b52" nodeId="1918e53c-6d84-4d14-a9c8-5bc69145bb52" nodeType="image" config={singleImage__238} containerStyle={imageContainerStyle__238}></SingleImage><SingleImage id="f15" nodeId="06d160fa-d187-4e15-a00a-656be4768f15" nodeType="image" config={singleImage__239} containerStyle={imageContainerStyle__239}></SingleImage></HorizontalLayout><HorizontalLayout id="7e9" nodeId="bbdeabc9-4020-4055-97cf-5f3a8d90b7e9" nodeType="horizontal-layout" config={layoutConfig__240}><SingleImage id="6e1" nodeId="220d9d7f-9029-47a5-8c33-b9a4d7dd76e1" nodeType="image" config={singleImage__241} containerStyle={imageContainerStyle__241}></SingleImage><SingleImage id="ed5" nodeId="45f6f871-95b1-429a-aa9e-d58a367f4ed5" nodeType="image" config={singleImage__242} containerStyle={imageContainerStyle__242}></SingleImage><SingleImage id="c9b" nodeId="6f278e4a-cda7-4891-b971-de28d7629c9b" nodeType="image" config={singleImage__243} containerStyle={imageContainerStyle__243}></SingleImage></HorizontalLayout></BaseLayout><BaseLayout id="8b3" nodeId="e4b37783-b27c-4a9a-a701-500a8847d8b3" nodeType="base-layout" config={baseLayoutConfig__244}><HorizontalLayout id="52f" nodeId="bba931a0-5359-43a0-bc40-82454222e52f" nodeType="horizontal-layout" config={layoutConfig__245}><SingleImage id="6ab" nodeId="c8493c59-754c-4b4f-88a1-d64e6a7db6ab" nodeType="image" config={singleImage__246} containerStyle={imageContainerStyle__246}></SingleImage><SingleImage id="d37" nodeId="e3c5c066-0f49-47b5-8098-dfeb4d6d8d37" nodeType="image" config={singleImage__247} containerStyle={imageContainerStyle__247}></SingleImage><SingleImage id="566" nodeId="66b44f37-45b7-4645-9e83-5147754ba566" nodeType="image" config={singleImage__248} containerStyle={imageContainerStyle__248}></SingleImage></HorizontalLayout><HorizontalLayout id="3b1" nodeId="78b4f68a-8997-4f89-b077-8d9d89f573b1" nodeType="horizontal-layout" config={layoutConfig__249}><SingleImage id="3b9" nodeId="a8741203-7294-40bf-935a-12181aa953b9" nodeType="image" config={singleImage__250} containerStyle={imageContainerStyle__250}></SingleImage><SingleImage id="dbf" nodeId="0949cf9e-e5c9-4564-bf0b-e3cb76e2cdbf" nodeType="image" config={singleImage__251} containerStyle={imageContainerStyle__251}></SingleImage><SingleImage id="994" nodeId="92cd967d-c1b2-44bf-bf3d-59a5a60bd994" nodeType="image" config={singleImage__252} containerStyle={imageContainerStyle__252}></SingleImage></HorizontalLayout></BaseLayout><BaseLayout id="5c2" nodeId="859ea67b-ed3f-4fb6-a9ae-c8040ec265c2" nodeType="base-layout" config={baseLayoutConfig__253}><HorizontalLayout id="ca2" nodeId="62e29cce-bf89-44db-b424-c11c9ba2dca2" nodeType="horizontal-layout" config={layoutConfig__254}><SingleImage id="e90" nodeId="fd0a69f1-668f-42b1-836f-baa230ee0e90" nodeType="image" config={singleImage__255} containerStyle={imageContainerStyle__255}></SingleImage><SingleImage id="d24" nodeId="9f818e51-24a4-4051-854b-6cd3ae0f4d24" nodeType="image" config={singleImage__256} containerStyle={imageContainerStyle__256}></SingleImage><SingleImage id="05f" nodeId="003bfa3d-b13a-4e2e-acf4-81f1dfe3c05f" nodeType="image" config={singleImage__257} containerStyle={imageContainerStyle__257}></SingleImage></HorizontalLayout><HorizontalLayout id="044" nodeId="20a48bcd-7ba0-481b-8597-e57232cb1044" nodeType="horizontal-layout" config={layoutConfig__258}><SingleImage id="039" nodeId="98e8f72c-2df9-42c6-a219-cce9709c6039" nodeType="image" config={singleImage__259} containerStyle={imageContainerStyle__259}></SingleImage><SingleImage id="11d" nodeId="277021f5-37aa-471f-8383-d88d68a8911d" nodeType="image" config={singleImage__260} containerStyle={imageContainerStyle__260}></SingleImage><SingleImage id="989" nodeId="668efa4e-62d1-4b37-90b8-c4a879311989" nodeType="image" config={singleImage__261} containerStyle={imageContainerStyle__261}></SingleImage></HorizontalLayout></BaseLayout></TabNavsContainer__225></BaseLayout><SingleImage id="815" nodeId="34e98744-efc3-4e89-93c2-0bf9c6833815" nodeType="image" config={singleImage__262} containerStyle={imageContainerStyle__262}></SingleImage><SingleImage id="ae3" nodeId="46cc0522-472e-4b3e-a8d3-51360504fae3" nodeType="image" config={singleImage__263} containerStyle={imageContainerStyle__263}></SingleImage><SpaceLayout__264 id="102" nodeId="6f5832d4-df6e-4e2a-8f0e-3a46feeab102" nodeType="space-layout" config={spaceLayoutConfig__264}></SpaceLayout__264><EnvController id="0c6" nodeId="e44d59ab-fdd2-4e3d-a74f-1e97dfe410c6" nodeType="env-controller" config={envController__265}><FixedBar__266 id="df2" nodeId="4cff20a3-a924-4619-aabd-e24c5ab60df2" nodeType="fixed-bar" position={position} customStyle={Object.assign(commonStyle__266, style__266[position])} effects={effects} effectParam={effectParam__266}><BuyButton__267 id="1ab" nodeId="26872458-81db-411b-bf5d-b72e3ab831ab" nodeType="buy-button" productId={productId__267} btnStyle={btnStyle__267.isAbsolute ? { ...style__267,
              ...abStyle__267
            } : { ...style__267,
              ...reStyle__267
            }} options={options__267}></BuyButton__267></FixedBar__266></EnvController></BaseLayout></TimeController><LeavePop id="7fb" nodeId="4ead8c1c-8c62-4c51-9a2a-c7ec837a37fb" nodeType="leave-pop" config={popConfig}></LeavePop></ContainerRender>;
});